<template>
  <svg
    viewBox="0 0 83.6 56"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        gradientUnits="userSpaceOnUse"
        x1="33.5"
        x2="41.5"
        y1="13.2"
        y2="13.2"
      >
        <stop offset="0" stop-color="#fff" stop-opacity=".9" />
        <stop offset="0" stop-color="#fff" stop-opacity=".9" />
        <stop offset=".4" stop-color="#fff" />
        <stop offset=".6" stop-color="rgba(255, 255, 255, 1)" />
        <stop
          offset=".7"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop offset=".8" stop-color="#fff" stop-opacity=".9" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-2"
        gradientUnits="userSpaceOnUse"
        x1="33.5"
        x2="41.5"
        y1="13.2"
        y2="13.2"
      >
        <stop offset="0" stop-color="#fff" stop-opacity=".8" />
        <stop offset="0" stop-color="#fff" stop-opacity=".8" />
        <stop offset=".4" stop-color="#fff" />
        <stop offset=".5" stop-color="rgba(255, 255, 255, 1)" />
        <stop
          offset=".6"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop
          offset=".8"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop offset=".8" stop-color="#fff" stop-opacity=".8" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-3"
        gradientUnits="userSpaceOnUse"
        x1="33.5"
        x2="41.5"
        y1="13.2"
        y2="13.2"
      >
        <stop offset="0" stop-color="#fff" stop-opacity=".7" />
        <stop offset="0" stop-color="#fff" stop-opacity=".7" />
        <stop offset=".4" stop-color="#fff" />
        <stop offset=".5" stop-color="rgba(255, 255, 255, 1)" />
        <stop
          offset=".6"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop
          offset=".7"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop
          offset=".8"
          stop-color="rgba(255, 255, 255, .7)"
          stop-opacity=".7"
        />
        <stop offset=".8" stop-color="#fff" stop-opacity=".7" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-4"
        gradientUnits="userSpaceOnUse"
        x1="33.5"
        x2="41.5"
        y1="13.2"
        y2="13.2"
      >
        <stop offset="0" stop-color="#fff" stop-opacity=".6" />
        <stop offset="0" stop-color="#fff" stop-opacity=".6" />
        <stop offset=".4" stop-color="#fff" />
        <stop offset=".5" stop-color="rgba(255, 255, 255, 1)" />
        <stop
          offset=".6"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop
          offset=".7"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop
          offset=".7"
          stop-color="rgba(255, 255, 255, .7)"
          stop-opacity=".7"
        />
        <stop offset=".8" stop-color="#fff" stop-opacity=".6" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-5"
        gradientUnits="userSpaceOnUse"
        x1="33.5"
        x2="41.5"
        y1="13.2"
        y2="13.2"
      >
        <stop offset="0" stop-color="#fff" stop-opacity=".5" />
        <stop offset="0" stop-color="#fff" stop-opacity=".5" />
        <stop offset=".4" stop-color="#fff" />
        <stop offset=".5" stop-color="rgba(255, 255, 255, 1)" />
        <stop
          offset=".5"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop
          offset=".6"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop
          offset=".7"
          stop-color="rgba(255, 255, 255, .7)"
          stop-opacity=".7"
        />
        <stop
          offset=".8"
          stop-color="rgba(255, 255, 255, .6)"
          stop-opacity=".6"
        />
        <stop offset=".8" stop-color="#fff" stop-opacity=".5" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-6"
        gradientUnits="userSpaceOnUse"
        x1="33.5"
        x2="41.5"
        y1="13.2"
        y2="13.2"
      >
        <stop offset="0" stop-color="#fff" stop-opacity=".5" />
        <stop offset="0" stop-color="#fff" stop-opacity=".5" />
        <stop offset=".4" stop-color="#fff" />
        <stop offset=".5" stop-color="rgba(255, 255, 255, 1)" />
        <stop
          offset=".5"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop
          offset=".6"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop
          offset=".7"
          stop-color="rgba(255, 255, 255, .7)"
          stop-opacity=".7"
        />
        <stop
          offset=".7"
          stop-color="rgba(255, 255, 255, .6)"
          stop-opacity=".6"
        />
        <stop offset=".8" stop-color="#fff" stop-opacity=".5" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-7"
        gradientUnits="userSpaceOnUse"
        x1="33.5"
        x2="41.5"
        y1="13.2"
        y2="13.2"
      >
        <stop offset="0" stop-color="#fff" stop-opacity=".4" />
        <stop offset="0" stop-color="#fff" stop-opacity=".4" />
        <stop offset=".4" stop-color="#fff" />
        <stop offset=".5" stop-color="rgba(255, 255, 255, 1)" />
        <stop
          offset=".5"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop
          offset=".6"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop
          offset=".7"
          stop-color="rgba(255, 255, 255, .7)"
          stop-opacity=".7"
        />
        <stop
          offset=".7"
          stop-color="rgba(255, 255, 255, .6)"
          stop-opacity=".6"
        />
        <stop
          offset=".8"
          stop-color="rgba(255, 255, 255, .4)"
          stop-opacity=".4"
        />
        <stop offset=".8" stop-color="#fff" stop-opacity=".4" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-8"
        gradientUnits="userSpaceOnUse"
        x1="33.5"
        x2="41.5"
        y1="13.2"
        y2="13.2"
      >
        <stop offset="0" stop-color="#fff" stop-opacity=".3" />
        <stop offset="0" stop-color="#fff" stop-opacity=".3" />
        <stop offset=".4" stop-color="#fff" />
        <stop offset=".5" stop-color="rgba(255, 255, 255, 1)" />
        <stop
          offset=".5"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop
          offset=".6"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop
          offset=".6"
          stop-color="rgba(255, 255, 255, .7)"
          stop-opacity=".7"
        />
        <stop
          offset=".7"
          stop-color="rgba(255, 255, 255, .6)"
          stop-opacity=".6"
        />
        <stop
          offset=".8"
          stop-color="rgba(255, 255, 255, .4)"
          stop-opacity=".4"
        />
        <stop offset=".8" stop-color="#fff" stop-opacity=".3" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-9"
        gradientUnits="userSpaceOnUse"
        x1="33.5"
        x2="41.5"
        y1="13.2"
        y2="13.2"
      >
        <stop offset="0" stop-color="#fff" stop-opacity=".2" />
        <stop offset="0" stop-color="#fff" stop-opacity=".2" />
        <stop offset=".4" stop-color="#fff" />
        <stop offset=".5" stop-color="rgba(255, 255, 255, 1)" />
        <stop
          offset=".5"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop
          offset=".6"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop
          offset=".6"
          stop-color="rgba(255, 255, 255, .7)"
          stop-opacity=".7"
        />
        <stop
          offset=".7"
          stop-color="rgba(255, 255, 255, .6)"
          stop-opacity=".6"
        />
        <stop
          offset=".7"
          stop-color="rgba(255, 255, 255, .4)"
          stop-opacity=".4"
        />
        <stop
          offset=".8"
          stop-color="rgba(255, 255, 255, .2)"
          stop-opacity=".2"
        />
        <stop offset=".8" stop-color="#fff" stop-opacity=".2" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-10"
        gradientUnits="userSpaceOnUse"
        x1="33.5"
        x2="41.5"
        y1="13.2"
        y2="13.2"
      >
        <stop offset="0" stop-color="#fff" stop-opacity="0" />
        <stop offset="0" stop-color="#fff" stop-opacity="0" />
        <stop offset=".4" stop-color="#fff" />
        <stop offset=".4" stop-color="rgba(255, 255, 255, 1)" />
        <stop
          offset=".5"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop
          offset=".6"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop
          offset=".6"
          stop-color="rgba(255, 255, 255, .7)"
          stop-opacity=".7"
        />
        <stop
          offset=".7"
          stop-color="rgba(255, 255, 255, .6)"
          stop-opacity=".6"
        />
        <stop
          offset=".7"
          stop-color="rgba(255, 255, 255, .4)"
          stop-opacity=".4"
        />
        <stop
          offset=".8"
          stop-color="rgba(255, 255, 255, .2)"
          stop-opacity=".2"
        />
        <stop offset=".8" stop-color="#fff" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-11"
        gradientUnits="userSpaceOnUse"
        x1="33.5"
        x2="41.5"
        y1="13.2"
        y2="13.2"
      >
        <stop offset="0" stop-color="#fff" stop-opacity="0" />
        <stop offset="0" stop-color="#fff" stop-opacity="0" />
        <stop offset=".4" stop-color="#fff" />
        <stop offset=".4" stop-color="rgba(255, 255, 255, 1)" />
        <stop
          offset=".5"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop
          offset=".5"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop
          offset=".6"
          stop-color="rgba(255, 255, 255, .7)"
          stop-opacity=".7"
        />
        <stop
          offset=".7"
          stop-color="rgba(255, 255, 255, .6)"
          stop-opacity=".6"
        />
        <stop
          offset=".7"
          stop-color="rgba(255, 255, 255, .4)"
          stop-opacity=".4"
        />
        <stop
          offset=".8"
          stop-color="rgba(255, 255, 255, .2)"
          stop-opacity=".2"
        />
        <stop offset=".8" stop-color="#fff" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-12"
        gradientUnits="userSpaceOnUse"
        x1="42.1"
        x2="50.1"
        y1="13.2"
        y2="13.2"
      >
        <stop offset=".2" stop-color="#fff" stop-opacity=".9" />
        <stop
          offset=".3"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop offset=".4" stop-color="rgba(255, 255, 255, 1)" />
        <stop offset=".6" stop-color="#fff" />
        <stop offset="1" stop-color="#fff" stop-opacity=".9" />
        <stop offset="1" stop-color="#fff" stop-opacity=".9" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-13"
        gradientUnits="userSpaceOnUse"
        x1="42.1"
        x2="50.1"
        y1="13.2"
        y2="13.2"
      >
        <stop offset=".2" stop-color="#fff" stop-opacity=".8" />
        <stop
          offset=".2"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop
          offset=".4"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop offset=".5" stop-color="rgba(255, 255, 255, 1)" />
        <stop offset=".6" stop-color="#fff" />
        <stop offset="1" stop-color="#fff" stop-opacity=".8" />
        <stop offset="1" stop-color="#fff" stop-opacity=".8" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-14"
        gradientUnits="userSpaceOnUse"
        x1="42.1"
        x2="50.1"
        y1="13.2"
        y2="13.2"
      >
        <stop offset=".2" stop-color="#fff" stop-opacity=".7" />
        <stop
          offset=".2"
          stop-color="rgba(255, 255, 255, .7)"
          stop-opacity=".7"
        />
        <stop
          offset=".3"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop
          offset=".4"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop offset=".5" stop-color="rgba(255, 255, 255, 1)" />
        <stop offset=".6" stop-color="#fff" />
        <stop offset="1" stop-color="#fff" stop-opacity=".7" />
        <stop offset="1" stop-color="#fff" stop-opacity=".7" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-15"
        gradientUnits="userSpaceOnUse"
        x1="42.1"
        x2="50.1"
        y1="13.2"
        y2="13.2"
      >
        <stop offset=".2" stop-color="#fff" stop-opacity=".6" />
        <stop
          offset=".3"
          stop-color="rgba(255, 255, 255, .7)"
          stop-opacity=".7"
        />
        <stop
          offset=".3"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop
          offset=".4"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop offset=".5" stop-color="rgba(255, 255, 255, 1)" />
        <stop offset=".6" stop-color="#fff" />
        <stop offset="1" stop-color="#fff" stop-opacity=".6" />
        <stop offset="1" stop-color="#fff" stop-opacity=".6" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-16"
        gradientUnits="userSpaceOnUse"
        x1="42.1"
        x2="50.1"
        y1="13.2"
        y2="13.2"
      >
        <stop offset=".2" stop-color="#fff" stop-opacity=".5" />
        <stop
          offset=".2"
          stop-color="rgba(255, 255, 255, .6)"
          stop-opacity=".6"
        />
        <stop
          offset=".3"
          stop-color="rgba(255, 255, 255, .7)"
          stop-opacity=".7"
        />
        <stop
          offset=".4"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop
          offset=".5"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop offset=".5" stop-color="rgba(255, 255, 255, 1)" />
        <stop offset=".6" stop-color="#fff" />
        <stop offset="1" stop-color="#fff" stop-opacity=".5" />
        <stop offset="1" stop-color="#fff" stop-opacity=".5" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-17"
        gradientUnits="userSpaceOnUse"
        x1="42.1"
        x2="50.1"
        y1="13.2"
        y2="13.2"
      >
        <stop offset=".2" stop-color="#fff" stop-opacity=".5" />
        <stop
          offset=".3"
          stop-color="rgba(255, 255, 255, .6)"
          stop-opacity=".6"
        />
        <stop
          offset=".3"
          stop-color="rgba(255, 255, 255, .7)"
          stop-opacity=".7"
        />
        <stop
          offset=".4"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop
          offset=".5"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop offset=".5" stop-color="rgba(255, 255, 255, 1)" />
        <stop offset=".6" stop-color="#fff" />
        <stop offset="1" stop-color="#fff" stop-opacity=".5" />
        <stop offset="1" stop-color="#fff" stop-opacity=".5" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-18"
        gradientUnits="userSpaceOnUse"
        x1="42.1"
        x2="50.1"
        y1="13.2"
        y2="13.2"
      >
        <stop offset=".2" stop-color="#fff" stop-opacity=".4" />
        <stop
          offset=".2"
          stop-color="rgba(255, 255, 255, .4)"
          stop-opacity=".4"
        />
        <stop
          offset=".3"
          stop-color="rgba(255, 255, 255, .6)"
          stop-opacity=".6"
        />
        <stop
          offset=".3"
          stop-color="rgba(255, 255, 255, .7)"
          stop-opacity=".7"
        />
        <stop
          offset=".4"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop
          offset=".5"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop offset=".5" stop-color="rgba(255, 255, 255, 1)" />
        <stop offset=".6" stop-color="#fff" />
        <stop offset="1" stop-color="#fff" stop-opacity=".4" />
        <stop offset="1" stop-color="#fff" stop-opacity=".4" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-19"
        gradientUnits="userSpaceOnUse"
        x1="42.1"
        x2="50.1"
        y1="13.2"
        y2="13.2"
      >
        <stop offset=".2" stop-color="#fff" stop-opacity=".3" />
        <stop
          offset=".2"
          stop-color="rgba(255, 255, 255, .4)"
          stop-opacity=".4"
        />
        <stop
          offset=".3"
          stop-color="rgba(255, 255, 255, .6)"
          stop-opacity=".6"
        />
        <stop
          offset=".4"
          stop-color="rgba(255, 255, 255, .7)"
          stop-opacity=".7"
        />
        <stop
          offset=".4"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop
          offset=".5"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop offset=".5" stop-color="rgba(255, 255, 255, 1)" />
        <stop offset=".6" stop-color="#fff" />
        <stop offset="1" stop-color="#fff" stop-opacity=".3" />
        <stop offset="1" stop-color="#fff" stop-opacity=".3" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-20"
        gradientUnits="userSpaceOnUse"
        x1="42.1"
        x2="50.1"
        y1="13.2"
        y2="13.2"
      >
        <stop offset=".2" stop-color="#fff" stop-opacity=".2" />
        <stop
          offset=".2"
          stop-color="rgba(255, 255, 255, .2)"
          stop-opacity=".2"
        />
        <stop
          offset=".3"
          stop-color="rgba(255, 255, 255, .4)"
          stop-opacity=".4"
        />
        <stop
          offset=".3"
          stop-color="rgba(255, 255, 255, .6)"
          stop-opacity=".6"
        />
        <stop
          offset=".4"
          stop-color="rgba(255, 255, 255, .7)"
          stop-opacity=".7"
        />
        <stop
          offset=".4"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop
          offset=".5"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop offset=".5" stop-color="rgba(255, 255, 255, 1)" />
        <stop offset=".6" stop-color="#fff" />
        <stop offset="1" stop-color="#fff" stop-opacity=".2" />
        <stop offset="1" stop-color="#fff" stop-opacity=".2" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-21"
        gradientUnits="userSpaceOnUse"
        x1="42.1"
        x2="50.1"
        y1="13.2"
        y2="13.2"
      >
        <stop offset=".2" stop-color="#fff" stop-opacity="0" />
        <stop
          offset=".2"
          stop-color="rgba(255, 255, 255, .2)"
          stop-opacity=".2"
        />
        <stop
          offset=".3"
          stop-color="rgba(255, 255, 255, .4)"
          stop-opacity=".4"
        />
        <stop
          offset=".3"
          stop-color="rgba(255, 255, 255, .6)"
          stop-opacity=".6"
        />
        <stop
          offset=".4"
          stop-color="rgba(255, 255, 255, .7)"
          stop-opacity=".7"
        />
        <stop
          offset=".4"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop
          offset=".5"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop offset=".6" stop-color="rgba(255, 255, 255, 1)" />
        <stop offset=".6" stop-color="#fff" />
        <stop offset="1" stop-color="#fff" stop-opacity="0" />
        <stop offset="1" stop-color="#fff" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-22"
        gradientUnits="userSpaceOnUse"
        x1="42.1"
        x2="50.1"
        y1="13.2"
        y2="13.2"
      >
        <stop offset=".2" stop-color="#fff" stop-opacity="0" />
        <stop
          offset=".2"
          stop-color="rgba(255, 255, 255, .2)"
          stop-opacity=".2"
        />
        <stop
          offset=".3"
          stop-color="rgba(255, 255, 255, .4)"
          stop-opacity=".4"
        />
        <stop
          offset=".3"
          stop-color="rgba(255, 255, 255, .6)"
          stop-opacity=".6"
        />
        <stop
          offset=".4"
          stop-color="rgba(255, 255, 255, .7)"
          stop-opacity=".7"
        />
        <stop
          offset=".5"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop
          offset=".5"
          stop-color="rgba(255, 255, 255, .9)"
          stop-opacity=".9"
        />
        <stop offset=".6" stop-color="rgba(255, 255, 255, 1)" />
        <stop offset=".6" stop-color="#fff" />
        <stop offset="1" stop-color="#fff" stop-opacity="0" />
        <stop offset="1" stop-color="#fff" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-23"
        gradientUnits="userSpaceOnUse"
        x1="33"
        x2="50.5"
        y1="16.7"
        y2="16.7"
      >
        <stop offset="0" stop-color="#b77939" />
        <stop offset=".2" stop-color="#f4c130" />
        <stop offset=".4" stop-color="#ffe06a" />
        <stop offset=".5" stop-color="#ffe580" />
        <stop offset=".6" stop-color="#ffe06a" />
        <stop offset=".8" stop-color="#f4c130" />
        <stop offset=".9" stop-color="#b77939" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-24"
        xlink:href="#linear-gradient-23"
        y1="15.8"
        y2="15.8"
      />
      <linearGradient
        id="linear-gradient-25"
        gradientUnits="userSpaceOnUse"
        x1="34.5"
        x2="35.1"
        y1="18.5"
        y2="18.5"
      >
        <stop offset="0" stop-color="#b77939" />
        <stop offset=".2" stop-color="#f4c130" />
        <stop offset=".4" stop-color="#ffe06a" />
        <stop offset=".5" stop-color="#ffe580" />
        <stop offset=".6" stop-color="#ffe06a" />
        <stop offset=".8" stop-color="#f4c130" />
        <stop offset="1" stop-color="#b77939" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-26"
        gradientTransform="matrix(-1 0 0 1 167.7 0)"
        x1="118.6"
        x2="119.3"
        xlink:href="#linear-gradient-25"
      />
      <linearGradient
        id="linear-gradient-27"
        x1="33.2"
        x2="50.4"
        xlink:href="#linear-gradient-25"
        y1="18.2"
        y2="18.2"
      />
      <linearGradient
        id="linear-gradient-28"
        gradientUnits="userSpaceOnUse"
        x1="37.7"
        x2="37.6"
        y1="18"
        y2="16.9"
      >
        <stop offset=".3" stop-color="#fff" />
        <stop offset=".4" stop-color="#fdfcfc" />
        <stop offset=".5" stop-color="#f8f5f3" />
        <stop offset=".6" stop-color="#eee8e5" />
        <stop offset=".7" stop-color="#e2d7d0" />
        <stop offset=".8" stop-color="#d1c0b5" />
        <stop offset=".8" stop-color="#bca494" />
        <stop offset=".9" stop-color="#a4826d" />
        <stop offset="1" stop-color="#895c40" />
        <stop offset="1" stop-color="#7c4b2c" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-29"
        gradientUnits="userSpaceOnUse"
        x1="37.1"
        x2="38.2"
        y1="17.2"
        y2="16.2"
      >
        <stop offset="0" stop-color="#b77939" />
        <stop offset=".2" stop-color="#cd9435" />
        <stop offset=".3" stop-color="#e9b431" />
        <stop offset=".4" stop-color="#f4c130" />
        <stop offset=".6" stop-color="#ffe580" />
        <stop offset=".7" stop-color="#ffe789" />
        <stop offset=".7" stop-color="#ffeca4" />
        <stop offset=".8" stop-color="#fff5ce" />
        <stop offset=".9" stop-color="#fff" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-30"
        gradientTransform="matrix(-1 0 0 1 167.7 0)"
        x1="121.9"
        x2="121.7"
        xlink:href="#linear-gradient-28"
        y1="18"
        y2="16.9"
      />
      <linearGradient
        id="linear-gradient-31"
        gradientTransform="matrix(-1 0 0 1 167.7 0)"
        x1="121.2"
        x2="122.4"
        xlink:href="#linear-gradient-29"
        y1="17.2"
        y2="16.2"
      />
      <linearGradient
        id="linear-gradient-32"
        gradientTransform="matrix(-1 0 0 1 429 0)"
        gradientUnits="userSpaceOnUse"
        x1="388.2"
        x2="388.2"
        y1="13.9"
        y2="8.6"
      >
        <stop offset="0" stop-color="#b77939" />
        <stop offset="0" stop-color="#d19735" />
        <stop offset="0" stop-color="#e4ae32" />
        <stop offset=".1" stop-color="#f0bc30" />
        <stop offset=".2" stop-color="#f4c130" />
        <stop offset=".4" stop-color="#ffe06a" />
        <stop offset=".4" stop-color="#ffe06e" />
        <stop offset=".4" stop-color="#ffe68b" />
        <stop offset=".4" stop-color="#ffeaa0" />
        <stop offset=".5" stop-color="#ffedac" />
        <stop offset=".5" stop-color="#ffeeb1" />
        <stop offset=".5" stop-color="#ffedac" />
        <stop offset=".6" stop-color="#ffeaa0" />
        <stop offset=".6" stop-color="#ffe68b" />
        <stop offset=".6" stop-color="#ffe06e" />
        <stop offset=".6" stop-color="#ffe06a" />
        <stop offset=".8" stop-color="#f4c130" />
        <stop offset=".9" stop-color="#ebb731" />
        <stop offset=".9" stop-color="#d59d34" />
        <stop offset="1" stop-color="#b77939" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-33"
        gradientTransform="translate(5.5)"
        x1="37.3"
        x2="37.3"
        xlink:href="#linear-gradient-32"
        y1="13.9"
        y2="8.6"
      />
      <linearGradient
        id="linear-gradient-34"
        gradientUnits="userSpaceOnUse"
        x1="39.7"
        x2="43.8"
        y1="11.2"
        y2="11.2"
      >
        <stop offset=".2" stop-color="#7c4b2c" />
        <stop offset=".2" stop-color="#86593c" />
        <stop offset=".3" stop-color="#aa8b77" />
        <stop offset=".3" stop-color="#c8b4a7" />
        <stop offset=".3" stop-color="#e0d4cd" />
        <stop offset=".4" stop-color="#f1ece8" />
        <stop offset=".4" stop-color="#fbfaf9" />
        <stop offset=".5" stop-color="#fff" />
        <stop offset=".6" stop-color="#fff" />
        <stop offset=".6" stop-color="#fbfaf9" />
        <stop offset=".6" stop-color="#f1ece8" />
        <stop offset=".7" stop-color="#e0d4cd" />
        <stop offset=".7" stop-color="#c8b4a7" />
        <stop offset=".8" stop-color="#aa8b77" />
        <stop offset=".8" stop-color="#86593c" />
        <stop offset=".8" stop-color="#7c4b2c" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-35"
        gradientUnits="userSpaceOnUse"
        x1="40.7"
        x2="40.7"
        y1="13.9"
        y2="8.6"
      >
        <stop offset="0" stop-color="#b77939" />
        <stop offset="0" stop-color="#c38536" />
        <stop offset="0" stop-color="#d59732" />
        <stop offset="0" stop-color="#e1a330" />
        <stop offset="0" stop-color="#e5a730" />
        <stop offset="0" stop-color="#e5a731" />
        <stop offset=".1" stop-color="#ebbe67" />
        <stop offset=".2" stop-color="#f1d295" />
        <stop offset=".2" stop-color="#f6e2bb" />
        <stop offset=".2" stop-color="#faeed9" />
        <stop offset=".3" stop-color="#fcf7ee" />
        <stop offset=".3" stop-color="#fefdfa" />
        <stop offset=".3" stop-color="#fff" />
        <stop offset=".7" stop-color="#fff" />
        <stop offset=".7" stop-color="#fefdfb" />
        <stop offset=".7" stop-color="#fefaef" />
        <stop offset=".8" stop-color="#fdf4dc" />
        <stop offset=".8" stop-color="#fbecc2" />
        <stop offset=".8" stop-color="#f9e29f" />
        <stop offset=".9" stop-color="#f7d575" />
        <stop offset=".9" stop-color="#f5c744" />
        <stop offset=".9" stop-color="#f4c130" />
        <stop offset="1" stop-color="#b77939" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-36"
        gradientTransform="matrix(-1 0 0 1 434.4 0)"
        x1="391.6"
        x2="391.6"
        xlink:href="#linear-gradient-35"
        y1="13.9"
        y2="8.6"
      />
      <linearGradient
        id="linear-gradient-37"
        gradientUnits="userSpaceOnUse"
        x1="41.2"
        x2="41"
        y1="20.1"
        y2="19.7"
      >
        <stop offset="0" stop-color="#bddef0" />
        <stop offset=".2" stop-color="#b7d8ed" />
        <stop offset=".3" stop-color="#a7c8e4" />
        <stop offset=".6" stop-color="#8daed6" />
        <stop offset=".8" stop-color="#698ac3" />
        <stop offset="1" stop-color="#4061ad" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-38"
        gradientUnits="userSpaceOnUse"
        x1="42.3"
        x2="42.6"
        y1="20.1"
        y2="19.5"
      >
        <stop offset="0" stop-color="#bddef0" />
        <stop offset=".9" stop-color="#4061ad" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-39"
        gradientUnits="userSpaceOnUse"
        x1="42.6"
        x2="42.3"
        y1="20.8"
        y2="20.2"
      >
        <stop offset=".4" stop-color="#6888c5" />
        <stop offset=".5" stop-color="#6585c3" />
        <stop offset=".6" stop-color="#4a6ab3" />
        <stop offset=".7" stop-color="#4061ad" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-40"
        gradientUnits="userSpaceOnUse"
        x1="41.1"
        x2="41.2"
        y1="20.6"
        y2="20.3"
      >
        <stop offset="0" stop-color="#6888c5" />
        <stop offset=".1" stop-color="#6585c3" />
        <stop offset=".5" stop-color="#4a6ab3" />
        <stop offset=".8" stop-color="#4061ad" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-41"
        gradientTransform="rotate(-180 234 150.35)"
        gradientUnits="userSpaceOnUse"
        x1="424.8"
        x2="426.2"
        y1="280.2"
        y2="280.2"
      >
        <stop offset="0" stop-color="#4061ad" />
        <stop offset="1" stop-color="#283a6b" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-42"
        gradientUnits="userSpaceOnUse"
        x1="41.7"
        x2="41.9"
        y1="19.9"
        y2="20.5"
      >
        <stop offset="0" stop-color="#bddef0" />
        <stop offset="1" stop-color="#4061ad" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-43"
        gradientUnits="userSpaceOnUse"
        x1="41.8"
        x2="43.1"
        y1="20.5"
        y2="20.5"
      >
        <stop offset="0" stop-color="#283a6b" />
        <stop offset="1" stop-color="#6888c5" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-44"
        gradientTransform="rotate(-180 234 150.35)"
        x1="426.2"
        x2="427.5"
        xlink:href="#linear-gradient-43"
        y1="280.8"
        y2="280.8"
      />
      <linearGradient
        id="linear-gradient-45"
        gradientTransform="rotate(-180 234 150.35)"
        gradientUnits="userSpaceOnUse"
        x1="426.2"
        x2="427.5"
        y1="280.2"
        y2="280.2"
      >
        <stop offset="0" stop-color="#283a6b" />
        <stop offset="1" stop-color="#4061ad" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-46"
        gradientTransform="rotate(-180 234 150.35)"
        gradientUnits="userSpaceOnUse"
        x1="424.8"
        x2="426.2"
        y1="280.8"
        y2="280.8"
      >
        <stop offset="0" stop-color="#6888c5" />
        <stop offset="1" stop-color="#283a6b" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-47"
        gradientTransform="rotate(-3.1 125.348 82.905)"
        gradientUnits="userSpaceOnUse"
        x1="38.6"
        x2="38.6"
        y1="15.5"
        y2="14.1"
      >
        <stop offset="0" stop-color="#fff" />
        <stop offset=".2" stop-color="#eca9b1" />
        <stop offset=".4" stop-color="#cf1f35" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-48"
        gradientTransform="rotate(-3.1 125.348 82.905)"
        gradientUnits="userSpaceOnUse"
        x1="38.4"
        x2="39.3"
        y1="15.4"
        y2="15.4"
      >
        <stop offset="0" stop-color="#88151b" />
        <stop offset="1" stop-color="#ba2029" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-49"
        x1="37.9"
        x2="38.5"
        xlink:href="#linear-gradient-48"
        y1="15.6"
        y2="15.6"
      />
      <linearGradient
        id="linear-gradient-50"
        gradientTransform="rotate(-3.1 125.348 82.905)"
        gradientUnits="userSpaceOnUse"
        x1="37.9"
        x2="38.4"
        y1="14.9"
        y2="14.9"
      >
        <stop offset="0" stop-color="#ba2029" />
        <stop offset="1" stop-color="#88151b" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-51"
        gradientTransform="scale(-1 1) rotate(-3.1 -59.502 6914.222)"
        x1="324.4"
        x2="324.4"
        xlink:href="#linear-gradient-47"
        y1="31"
        y2="29.6"
      />
      <linearGradient
        id="linear-gradient-52"
        gradientTransform="scale(-1 1) rotate(-3.1 -59.502 6914.222)"
        x1="324.2"
        x2="325.1"
        xlink:href="#linear-gradient-48"
        y1="30.9"
        y2="30.9"
      />
      <linearGradient
        id="linear-gradient-53"
        gradientTransform="scale(-1 1) rotate(-3.1 -59.502 6914.222)"
        x1="323.7"
        x2="324.3"
        xlink:href="#linear-gradient-48"
        y1="31.1"
        y2="31.1"
      />
      <linearGradient
        id="linear-gradient-54"
        gradientTransform="scale(-1 1) rotate(-3.1 -59.502 6914.222)"
        x1="323.7"
        x2="324.2"
        xlink:href="#linear-gradient-50"
        y1="30.4"
        y2="30.4"
      />
      <linearGradient
        id="linear-gradient-55"
        gradientUnits="userSpaceOnUse"
        x1="41.8"
        x2="41.8"
        y1="8.5"
        y2="5.7"
      >
        <stop offset=".1" stop-color="#fef2d5" />
        <stop offset=".2" stop-color="#ffe580" />
        <stop offset=".4" stop-color="#ffdb58" />
        <stop offset=".5" stop-color="#f4c130" />
        <stop offset=".7" stop-color="#e5a730" />
        <stop offset=".8" stop-color="#b77939" />
        <stop offset=".9" stop-color="#b17437" />
        <stop offset=".9" stop-color="#a06733" />
        <stop offset="1" stop-color="#84512d" />
        <stop offset="1" stop-color="#7c4b2c" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-56"
        gradientUnits="userSpaceOnUse"
        x1="40.1"
        x2="43.5"
        y1="7.7"
        y2="7.7"
      >
        <stop offset="0" stop-color="#7c4b2c" />
        <stop offset="0" stop-color="#905f2c" />
        <stop offset="0" stop-color="#bb892e" />
        <stop offset="0" stop-color="#daa72f" />
        <stop offset=".1" stop-color="#edba2f" />
        <stop offset=".1" stop-color="#f4c130" />
        <stop offset=".1" stop-color="#f4c43c" />
        <stop offset=".2" stop-color="#f7d269" />
        <stop offset=".2" stop-color="#f9de91" />
        <stop offset=".2" stop-color="#fae8b3" />
        <stop offset=".3" stop-color="#fcf0cf" />
        <stop offset=".3" stop-color="#fdf7e4" />
        <stop offset=".4" stop-color="#fefbf3" />
        <stop offset=".4" stop-color="#fefefc" />
        <stop offset=".5" stop-color="#fff" />
        <stop offset=".6" stop-color="#fefefb" />
        <stop offset=".6" stop-color="#fefbf2" />
        <stop offset=".7" stop-color="#fdf6e1" />
        <stop offset=".7" stop-color="#fcefca" />
        <stop offset=".8" stop-color="#fae6ac" />
        <stop offset=".8" stop-color="#f8db87" />
        <stop offset=".9" stop-color="#f6ce5d" />
        <stop offset=".9" stop-color="#f4c130" />
        <stop offset="1" stop-color="#7c4b2c" />
        <stop offset="1" stop-color="#7c4b2c" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-57"
        gradientUnits="userSpaceOnUse"
        x1="42.1"
        x2="42.1"
        y1="5.9"
        y2="7.2"
      >
        <stop offset="0" stop-color="#f4c130" />
        <stop offset="0" stop-color="#f4c53f" />
        <stop offset=".2" stop-color="#f7d679" />
        <stop offset=".3" stop-color="#fae5a9" />
        <stop offset=".5" stop-color="#fcf0ce" />
        <stop offset=".6" stop-color="#fdf8e9" />
        <stop offset=".7" stop-color="#fefdf9" />
        <stop offset=".8" stop-color="#fff" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-58"
        x1="41.4"
        x2="41.4"
        xlink:href="#linear-gradient-57"
      />
      <linearGradient
        id="linear-gradient-59"
        gradientTransform="matrix(-1 0 0 1 167.7 0)"
        gradientUnits="userSpaceOnUse"
        x1="124.3"
        x2="125.7"
        y1="7.1"
        y2="7.1"
      >
        <stop offset="0" stop-color="#f4c130" />
        <stop offset=".1" stop-color="#edbb2f" />
        <stop offset=".4" stop-color="#dcaa2f" />
        <stop offset=".6" stop-color="#c08e2e" />
        <stop offset=".8" stop-color="#99672c" />
        <stop offset="1" stop-color="#7c4b2c" />
        <stop offset="1" stop-color="#7c4b2c" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-60"
        x1="40.2"
        x2="41.5"
        xlink:href="#linear-gradient-59"
      />
      <radialGradient
        id="radial-gradient"
        cx="33.4"
        cy="14.5"
        fx="33.4"
        fy="14.5"
        gradientTransform="rotate(.4 157.313 -72.17)"
        gradientUnits="userSpaceOnUse"
        r=".7"
      >
        <stop offset="0" stop-color="#fff" />
        <stop offset="0" stop-color="#f9fafb" />
        <stop offset=".2" stop-color="#e9eef0" />
        <stop offset=".3" stop-color="#dde5e9" />
        <stop offset=".4" stop-color="#b1c6ce" />
        <stop offset=".5" stop-color="#97b3be" />
        <stop offset=".7" stop-color="#7d9ca6" />
        <stop offset=".8" stop-color="#7e979d" />
        <stop offset=".9" stop-color="#838c85" />
        <stop offset=".9" stop-color="#85897f" />
      </radialGradient>
      <radialGradient
        id="radial-gradient-2"
        cx="33.9"
        cy="13.5"
        fx="33.9"
        fy="13.5"
        r=".7"
        xlink:href="#radial-gradient"
      />
      <radialGradient
        id="radial-gradient-3"
        cx="34.4"
        cy="12.6"
        fx="34.4"
        fy="12.6"
        r=".7"
        xlink:href="#radial-gradient"
      />
      <radialGradient
        id="radial-gradient-4"
        cx="35.1"
        cy="11.8"
        fx="35.1"
        fy="11.8"
        r=".7"
        xlink:href="#radial-gradient"
      />
      <radialGradient
        id="radial-gradient-5"
        cx="35.8"
        cy="11.1"
        fx="35.8"
        fy="11.1"
        r=".7"
        xlink:href="#radial-gradient"
      />
      <radialGradient
        id="radial-gradient-6"
        cx="36.6"
        cy="10.4"
        fx="36.6"
        fy="10.4"
        r=".7"
        xlink:href="#radial-gradient"
      />
      <radialGradient
        id="radial-gradient-7"
        cx="37.4"
        cy="9.9"
        fx="37.4"
        fy="9.9"
        r=".7"
        xlink:href="#radial-gradient"
      />
      <radialGradient
        id="radial-gradient-8"
        cx="38.3"
        cy="9.4"
        fx="38.3"
        fy="9.4"
        r=".7"
        xlink:href="#radial-gradient"
      />
      <radialGradient
        id="radial-gradient-9"
        cx="39.3"
        cy="9"
        fx="39.3"
        fy="9"
        r=".7"
        xlink:href="#radial-gradient"
      />
      <radialGradient
        id="radial-gradient-10"
        cx="248"
        cy="7.4"
        fx="248"
        fy="7.4"
        gradientTransform="scale(-1 1) rotate(.4 11.163 -41940.89)"
        r=".7"
        xlink:href="#radial-gradient"
      />
      <radialGradient
        id="radial-gradient-11"
        cx="247"
        cy="7.8"
        fx="247"
        fy="7.8"
        gradientTransform="scale(-1 1) rotate(.4 11.163 -41940.89)"
        r=".7"
        xlink:href="#radial-gradient"
      />
      <radialGradient
        id="radial-gradient-12"
        cx="246.1"
        cy="8.2"
        fx="246.1"
        fy="8.2"
        gradientTransform="scale(-1 1) rotate(.4 11.163 -41940.89)"
        r=".7"
        xlink:href="#radial-gradient"
      />
      <radialGradient
        id="radial-gradient-13"
        cx="245.2"
        cy="8.8"
        fx="245.2"
        fy="8.8"
        gradientTransform="scale(-1 1) rotate(.4 11.163 -41940.89)"
        r=".7"
        xlink:href="#radial-gradient"
      />
      <radialGradient
        id="radial-gradient-14"
        cx="244.4"
        cy="9.4"
        fx="244.4"
        fy="9.4"
        gradientTransform="scale(-1 1) rotate(.4 11.163 -41940.89)"
        xlink:href="#radial-gradient"
      />
      <radialGradient
        id="radial-gradient-15"
        cx="243.7"
        cy="10.2"
        fx="243.7"
        fy="10.2"
        gradientTransform="scale(-1 1) rotate(.4 11.163 -41940.89)"
        r=".7"
        xlink:href="#radial-gradient"
      />
      <radialGradient
        id="radial-gradient-16"
        cx="243.1"
        cy="11"
        fx="243.1"
        fy="11"
        gradientTransform="scale(-1 1) rotate(.4 11.163 -41940.89)"
        r=".7"
        xlink:href="#radial-gradient"
      />
      <radialGradient
        id="radial-gradient-17"
        cx="242.6"
        cy="11.9"
        fx="242.6"
        fy="11.9"
        gradientTransform="scale(-1 1) rotate(.4 11.163 -41940.89)"
        r=".7"
        xlink:href="#radial-gradient"
      />
      <radialGradient
        id="radial-gradient-18"
        cx="242.1"
        cy="12.9"
        fx="242.1"
        fy="12.9"
        gradientTransform="scale(-1 1) rotate(.4 11.163 -41940.89)"
        r=".7"
        xlink:href="#radial-gradient"
      />
      <radialGradient
        id="radial-gradient-19"
        cx="41.8"
        cy="21.9"
        fx="41.8"
        fy="21.9"
        gradientUnits="userSpaceOnUse"
        r="9.2"
      >
        <stop offset=".6" stop-color="#fff" />
        <stop offset=".6" stop-color="#fafafa" />
        <stop offset=".7" stop-color="#eee" />
        <stop offset=".7" stop-color="#d9d9d8" />
        <stop offset=".8" stop-color="#bbb" />
        <stop offset=".9" stop-color="#969695" />
        <stop offset=".9" stop-color="#676766" />
        <stop offset="1" stop-color="#323230" />
        <stop offset="1" stop-color="#1d1d1b" />
      </radialGradient>
      <radialGradient
        id="radial-gradient-20"
        cx="41.8"
        cy="21.9"
        fx="41.8"
        fy="21.9"
        r="9.2"
        xlink:href="#radial-gradient-19"
      />
      <radialGradient
        id="radial-gradient-21"
        cx="41.7"
        cy="15.6"
        fx="41.7"
        fy="15.6"
        r=".9"
        xlink:href="#radial-gradient"
      />
      <radialGradient
        id="radial-gradient-22"
        cx="33.8"
        cy="16.6"
        fx="33.8"
        fy="16.6"
        gradientUnits="userSpaceOnUse"
        r=".7"
      >
        <stop offset="0" stop-color="#dde5e9" />
        <stop offset=".1" stop-color="#d1dce1" />
        <stop offset=".4" stop-color="#b2c6ce" />
        <stop offset=".5" stop-color="#97b3be" />
        <stop offset=".7" stop-color="#7d9ca6" />
        <stop offset=".8" stop-color="#7e979d" />
        <stop offset=".9" stop-color="#838c85" />
        <stop offset=".9" stop-color="#85897f" />
      </radialGradient>
      <radialGradient
        id="radial-gradient-23"
        cx="118"
        fx="118"
        gradientTransform="matrix(-1 0 0 1 167.7 0)"
        r=".7"
        xlink:href="#radial-gradient-22"
      />
      <radialGradient
        id="radial-gradient-24"
        cx="41.7"
        cy="9.9"
        fx="41.7"
        fy="9.9"
        r=".7"
        xlink:href="#radial-gradient"
      />
      <radialGradient
        id="radial-gradient-25"
        cx="41.7"
        cy="11"
        fx="41.7"
        fy="11"
        r=".7"
        xlink:href="#radial-gradient"
      />
      <radialGradient
        id="radial-gradient-26"
        cx="41.7"
        cy="12"
        fx="41.7"
        fy="12"
        r=".7"
        xlink:href="#radial-gradient"
      />
      <radialGradient
        id="radial-gradient-27"
        cx="41.7"
        cy="13"
        fx="41.7"
        fy="13"
        r=".7"
        xlink:href="#radial-gradient"
      />
      <radialGradient
        id="radial-gradient-28"
        cx="41.5"
        cy="6.9"
        fx="41.5"
        fy="6.9"
        gradientUnits="userSpaceOnUse"
        r="2.2"
      >
        <stop offset="0" stop-color="#fff" />
        <stop offset=".2" stop-color="#fef2d5" />
        <stop offset=".2" stop-color="#fef0cb" />
        <stop offset=".3" stop-color="#feecb1" />
        <stop offset=".4" stop-color="#fee687" />
        <stop offset=".4" stop-color="#ffe580" />
        <stop offset=".5" stop-color="#ffdb58" />
        <stop offset=".6" stop-color="#f4c130" />
        <stop offset=".8" stop-color="#e5a730" />
        <stop offset=".9" stop-color="#b77939" />
        <stop offset=".9" stop-color="#ae7237" />
        <stop offset="1" stop-color="#955f31" />
        <stop offset="1" stop-color="#7c4b2c" />
      </radialGradient>
      <radialGradient
        id="radial-gradient-29"
        cx="41.8"
        cy="4.4"
        fx="41.8"
        fy="4.4"
        gradientUnits="userSpaceOnUse"
        r="1.4"
      >
        <stop offset="0" stop-color="#ffe680" />
        <stop offset=".2" stop-color="#ffe680" />
        <stop offset=".4" stop-color="#ffdc4f" />
        <stop offset=".6" stop-color="#f5c216" />
        <stop offset=".8" stop-color="#e6a81b" />
        <stop offset="1" stop-color="#bd7a2a" />
        <stop offset="1" stop-color="#bc782b" />
      </radialGradient>
      <radialGradient
        id="radial-gradient-30"
        cx="41.7"
        cy="4.3"
        fx="41.7"
        fy="4.3"
        r=".6"
        xlink:href="#radial-gradient"
      />
      <radialGradient
        id="radial-gradient-31"
        cx="41.7"
        cy="8.9"
        fx="41.7"
        fy="8.9"
        r=".7"
        xlink:href="#radial-gradient"
      />
      <clipPath id="clippath">
        <path class="cls-41" d="M32.5 7.8h7.9v7.3h-7.9z" />
      </clipPath>
      <clipPath id="clippath-1">
        <path class="cls-41" d="M51.1 15.1h-7.9V7.8h7.9z" />
      </clipPath>
      <clipPath id="clippath-2">
        <path
          class="cls-41"
          d="m35 18.5-.6-.4c-.1-.5-.2-.6-.5-1.4-.4-.9-.9-2-.9-2l1.2-.4h.1s-.3.9-.3 1.1c0 .1 0 .4.1.5.2 0 .4-.1.4-.3l.2-.6.7 2.4s-.5-.5-.7-.3c-.1.1 0 .3.1.5l.2.7Z"
        />
      </clipPath>
      <clipPath id="clippath-3">
        <path
          class="cls-41"
          d="m48.5 18.5.6-.4c.1-.5.2-.6.5-1.4.4-.9.9-2 .9-2l-1.2-.4h-.1s.3.9.3 1.1c0 .1 0 .4-.1.5-.2 0-.4-.1-.4-.3l-.2-.6-.7 2.4s.5-.5.7-.3c.1.1 0 .3-.1.5l-.2.7Z"
        />
      </clipPath>
      <clipPath id="clippath-4">
        <path
          class="cls-41"
          d="M41.8 19h7.5c0 .2-.1.3-.3.3H34.6c-.2 0-.3-.1-.3-.3h7.5Z"
        />
      </clipPath>
      <clipPath id="clippath-5">
        <path
          class="cls-41"
          d="M37.7 17h-.5c-.2 0-.3 0-.3-.3 0-.2 0-.3.3-.3h1.2c.2 0 .3 0 .3.3 0 .2 0 .3-.3.3h-.6Z"
        />
      </clipPath>
      <clipPath id="clippath-6">
        <path
          class="cls-41"
          d="M45.9 17h.5c.2 0 .3 0 .3-.3 0-.2 0-.3-.3-.3h-1.2c-.2 0-.3 0-.3.3 0 .2 0 .3.3.3h.6Z"
        />
      </clipPath>
      <clipPath id="clippath-7">
        <path
          class="cls-41"
          d="M41 13.9s.7-4.7-.8-5.3h3.1c-1.5.6-.8 5.3-.8 5.3H41Z"
        />
      </clipPath>
      <clipPath id="clippath-8">
        <path
          class="cls-41"
          d="M43.7 8.6h-.2s-1 .3-1.7.3-1.7-.3-1.7-.3h-.2c-.1.1-.2.3 0 .4.2.3.7.6.7 2.3s-.1 2.4-.1 2.4h2.7s-.2-1.5-.2-2.4c0-1.4.5-2.1.7-2.3.1-.1 0-.3 0-.4Z"
        />
      </clipPath>
    </defs>
    <g style="isolation: isolate">
      <g id="Layer_1" data-name="Layer 1">
        <path class="cls-53" d="M27.2 56V0h29.2v56H27.2z" />
        <path class="cls-389" d="M28 55.2h27.6V.8H28v54.4z" />
        <path class="cls-53" d="M0 25.9h83.6v20.5H0V25.9z" />
        <path
          class="cls-116"
          d="m12.4 40.5-3.1-4.4c.7 0 1.3-.3 1.8-.8.6-.6.9-1.4.9-2.2 0-.7-.3-1.5-.8-2s-1.2-.8-2-.8H6.1v10.3h-.7V29.5h3.9c1 0 1.9.3 2.5 1 .7.7 1.1 1.6 1.1 2.6s-.4 2-1.2 2.8c-.3.3-.7.6-1.1.7l2.8 4h-.9Z"
        />
        <path
          class="cls-116"
          d="M6.4 40.5v-10h2.8c.7 0 1.3.2 1.8.7.5.5.7 1.2.7 1.8 0 .7-.3 1.5-.8 2s-1 .7-1.7.7h-.6l3.4 4.7h-1l-3.9-5.5h2c1.2 0 1.8-1.1 1.8-2 0-.5-.2-1-.5-1.3-.3-.3-.8-.5-1.3-.5h-2v9.3h-.8ZM24 40.5c.1.5.4 1 .8 1.4.6.5 1.3.8 2.1.8s1.5-.3 2-.8c.6-.6.9-1.3.9-2.1v-7.7h.7v7.7c0 1-.4 1.9-1.1 2.6-.7.7-1.6 1.1-2.5 1.1-1 0-1.9-.4-2.6-1.1-.5-.5-.9-1.2-1-2h.8Z"
        />
        <path
          class="cls-116"
          d="M24.3 40.5c.1.5.4.9.7 1.2.5.5 1.2.7 1.8.7 1.4 0 2.6-1.2 2.6-2.6v-2.2c-.2.3-.4.6-.6.8-.5.5-1.2.8-2 .8s-1.5-.3-2.1-.9c-.5-.5-.8-1.2-.8-2v-4.2h-.8v4.2c0 1 .4 1.9 1.1 2.6.7.7 1.6 1 2.6 1 .6 0 1.3-.2 1.8-.5v.3c0 1-.8 1.8-1.8 1.8-.5 0-1-.2-1.3-.5-.2-.2-.3-.4-.4-.6h-.8Z"
        />
        <path
          class="cls-116"
          d="M29.4 32.2v4.1c0 1.4-1.2 2.7-2.6 2.7-.7 0-1.3-.3-1.8-.8s-.7-1.1-.7-1.8v-4.2h.7v4.2c0 .5.2.9.5 1.3.4.4.8.5 1.3.5 1 0 1.8-.9 1.8-1.9v-4.1h.8ZM42.8 29.5h.7v11h-.7v-11zM41.7 29.5h.7v11h-.7v-11zM77.4 29.5h.8v11h-.8v-11zM76.3 29.5h.8v11h-.8v-11zM74 32.2h.8v8.3H74v-8.3zM72.9 32.2h.8v8.3h-.8v-8.3zM61.5 40.5l-2-11h.8l2 11h-.8zM59.2 29.5s-3.9 8.3-3.9 8.4l-3.9-8.4h.8l3.1 6.6 3-6.6h.9ZM49 40.5l2-11h-.8l-1.9 11h.7z"
        />
        <path
          class="cls-116"
          d="M49.3 40.5s1.9-10.6 1.9-10.7l4 8.7s4-8.6 4-8.7l1.9 10.7h-.8l-1.5-8.2-3.7 8-3.7-8-1.5 8.2h-.8ZM74.8 30.3c0 .6-.4 1-1 1s-1-.4-1-1 .4-1 1-1 1 .4 1 1Zm-1-.3c-.2 0-.3.1-.3.3s.1.3.3.3.3-.1.3-.3-.1-.3-.3-.3Z"
        />
        <path
          class="cls-354"
          d="M38.4 36.4c0 1.4-1.1 2.5-2.5 2.5-.7 0-1.3-.3-1.8-.7-.5-.5-.7-1.1-.7-1.8s.2-1.3.7-1.8c.5-.5 1.1-.7 1.8-.7h2.5v2.5Zm-4.8 2.4c-.6-.6-1-1.4-1-2.3 0-.9.3-1.7 1-2.3.6-.6 1.4-.9 2.3-1h3.3v3.3c0 1.8-1.5 3.3-3.3 3.3-.9 0-1.7-.3-2.3-.9Z"
        />
        <path
          class="cls-116"
          d="M33.6 34.1ZM39.5 40.5v-7.7h-3.6c-2 0-3.6 1.6-3.6 3.6 0 1 .4 1.9 1 2.5.7.7 1.6 1 2.5 1 .9 0 1.8-.4 2.5-1 .3-.3.6-.7.8-1.1v2.6h-.8v-.6c-.7.5-1.6.8-2.5.8-1.2 0-2.2-.5-3.1-1.3-.8-.8-1.3-1.9-1.3-3.1 0-2.4 2-4.3 4.3-4.3H40v8.4h-.7Z"
        />
        <path
          class="cls-354"
          d="M69.6 36.4c0 1.4-1.1 2.5-2.5 2.5-.7 0-1.3-.3-1.8-.7-.5-.5-.7-1.1-.7-1.8s.2-1.3.7-1.8c.5-.5 1.1-.7 1.8-.7h2.5v2.5Zm-4.8 2.4c-.6-.6-1-1.4-1-2.3 0-.9.3-1.7 1-2.3.6-.6 1.4-.9 2.3-1h3.3v3.3c0 1.8-1.5 3.3-3.3 3.3-.9 0-1.7-.3-2.3-.9Z"
        />
        <path
          class="cls-116"
          d="M70.7 40.5v-7.7h-3.6c-2 0-3.6 1.6-3.6 3.6 0 1 .4 1.9 1 2.5.7.7 1.6 1 2.5 1 .9 0 1.8-.4 2.5-1 .3-.3.6-.7.8-1.1v2.6h-.8v-.6c-.7.5-1.6.8-2.5.8-1.2 0-2.2-.5-3.1-1.3-.8-.8-1.3-1.9-1.3-3.1 0-2.4 2-4.3 4.3-4.3h4.3v8.4h-.7ZM22.2 36.4c0 2.4-2 4.4-4.4 4.4s-4.4-2-4.4-4.4 2-4.4 4.4-4.4 4.4 2 4.4 4.4Zm-4.4-3.7c-2 0-3.7 1.6-3.7 3.7s1.6 3.7 3.7 3.7 3.7-1.6 3.7-3.7-1.6-3.7-3.7-3.7Z"
        />
        <path
          class="cls-116"
          d="M21.1 36.4c0 1.8-1.5 3.3-3.3 3.3s-3.3-1.5-3.3-3.3 1.5-3.3 3.3-3.3 3.3 1.5 3.3 3.3Zm-3.3-2.7c-1.4 0-2.6 1.2-2.6 2.6s1.2 2.6 2.6 2.6 2.6-1.2 2.6-2.6-1.2-2.6-2.6-2.6Z"
        />
        <path
          class="cls-53"
          d="m33.6 15 2.3 3.5h11.8l2.3-2.9c-.7-1.3-1.7-4.5-4.9-3.8s-.5-.7-2.3-.7h-1.9v4.8l-7.2-.9 1.3 4h13.7l1.3-4"
        />
        <path
          class="cls-53"
          d="m50 15-2.3 3.5H35.9l-2.3-2.9c.7-1.3 1.7-4.5 4.9-3.8s.5-.7 2.3-.7h1.9v4.8l7.2-.9-1.3 4H34.9l-1.3-4"
        />
        <g style="clip-path: url(#clippath)">
          <path class="cls-460" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-438" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-444" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-493" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-477" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-457" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-424" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-428" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-474" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-459" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-485" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-471" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-502" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-488" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-469" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-480" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-455" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-489" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-453" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-425" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-498" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-496" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-430" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-505" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-508" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-508" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-508" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-508" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-508" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-508" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-508" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-508" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-508" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-495" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-470" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-464" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-492" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-456" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-442" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-433" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-463" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-463" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-494" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-466" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-510" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-468" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-445" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-490" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-458" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-423" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-451" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-436" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-506" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-497" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path class="cls-472" d="M41.5 9.2c-4.4 0-8 3.6-8 8" />
          <path
            d="M41.5 9.2c-4.4 0-8 3.6-8 8"
            style="
              opacity: 0.2;
              stroke-width: 0;
              stroke: url(#linear-gradient-2);
              stroke-miterlimit: 10;
              fill: none;
            "
          />
          <path
            d="M41.5 9.2c-4.4 0-8 3.6-8 8"
            style="
              stroke: url(#linear-gradient-3);
              opacity: 0.2;
              stroke-width: 0;
              stroke-miterlimit: 10;
              fill: none;
            "
          />
          <path
            d="M41.5 9.2c-4.4 0-8 3.6-8 8"
            style="
              stroke: url(#linear-gradient-4);
              opacity: 0.3;
              stroke-width: 0;
              stroke-miterlimit: 10;
              fill: none;
            "
          />
          <path
            d="M41.5 9.2c-4.4 0-8 3.6-8 8"
            style="
              opacity: 0.4;
              stroke-width: 0;
              stroke: url(#linear-gradient-5);
              stroke-miterlimit: 10;
              fill: none;
            "
          />
          <path
            d="M41.5 9.2c-4.4 0-8 3.6-8 8"
            style="
              opacity: 0.5;
              stroke-width: 0;
              stroke: url(#linear-gradient-6);
              stroke-miterlimit: 10;
              fill: none;
            "
          />
          <path
            d="M41.5 9.2c-4.4 0-8 3.6-8 8"
            style="
              opacity: 0.6;
              stroke-width: 0;
              stroke: url(#linear-gradient-7);
              stroke-miterlimit: 10;
              fill: none;
            "
          />
          <path
            d="M41.5 9.2c-4.4 0-8 3.6-8 8"
            style="
              opacity: 0.7;
              stroke-width: 0;
              stroke-miterlimit: 10;
              fill: none;
              stroke: url(#linear-gradient-8);
            "
          />
          <path
            d="M41.5 9.2c-4.4 0-8 3.6-8 8"
            style="
              opacity: 0.7;
              stroke-width: 0;
              stroke: url(#linear-gradient-9);
              stroke-miterlimit: 10;
              fill: none;
            "
          />
          <path
            d="M41.5 9.2c-4.4 0-8 3.6-8 8"
            style="
              stroke: url(#linear-gradient-10);
              opacity: 0.8;
              stroke-width: 0;
              stroke-miterlimit: 10;
              fill: none;
            "
          />
          <path
            d="M41.5 9.2c-4.4 0-8 3.6-8 8"
            style="
              stroke: url(#linear-gradient-11);
              opacity: 0.9;
              stroke-width: 0;
              stroke-miterlimit: 10;
              fill: none;
            "
          />
        </g>
        <g style="clip-path: url(#clippath-1)">
          <path class="cls-460" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-438" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-444" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-493" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-477" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-457" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-424" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-428" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-474" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-459" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-485" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-471" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-502" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-488" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-469" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-480" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-455" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-489" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-453" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-425" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-498" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-496" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-430" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-505" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-508" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-508" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-508" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-508" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-508" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-508" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-508" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-508" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-508" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-495" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-470" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-464" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-492" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-456" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-442" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-433" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-463" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-463" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-494" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-466" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-510" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-468" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-445" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-490" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-458" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-423" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-451" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-436" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-506" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-497" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path class="cls-472" d="M50.1 17.2c0-4.4-3.6-8-8-8" />
          <path
            d="M50.1 17.2c0-4.4-3.6-8-8-8"
            style="
              stroke: url(#linear-gradient-13);
              opacity: 0.2;
              stroke-width: 0;
              stroke-miterlimit: 10;
              fill: none;
            "
          />
          <path
            d="M50.1 17.2c0-4.4-3.6-8-8-8"
            style="
              opacity: 0.2;
              stroke-width: 0;
              stroke: url(#linear-gradient-14);
              stroke-miterlimit: 10;
              fill: none;
            "
          />
          <path
            d="M50.1 17.2c0-4.4-3.6-8-8-8"
            style="
              opacity: 0.3;
              stroke-width: 0;
              stroke: url(#linear-gradient-15);
              stroke-miterlimit: 10;
              fill: none;
            "
          />
          <path
            d="M50.1 17.2c0-4.4-3.6-8-8-8"
            style="
              stroke: url(#linear-gradient-16);
              opacity: 0.4;
              stroke-width: 0;
              stroke-miterlimit: 10;
              fill: none;
            "
          />
          <path
            d="M50.1 17.2c0-4.4-3.6-8-8-8"
            style="
              stroke: url(#linear-gradient-17);
              opacity: 0.5;
              stroke-width: 0;
              stroke-miterlimit: 10;
              fill: none;
            "
          />
          <path
            d="M50.1 17.2c0-4.4-3.6-8-8-8"
            style="
              stroke: url(#linear-gradient-18);
              opacity: 0.6;
              stroke-width: 0;
              stroke-miterlimit: 10;
              fill: none;
            "
          />
          <path
            d="M50.1 17.2c0-4.4-3.6-8-8-8"
            style="
              stroke: url(#linear-gradient-19);
              opacity: 0.7;
              stroke-width: 0;
              stroke-miterlimit: 10;
              fill: none;
            "
          />
          <path
            d="M50.1 17.2c0-4.4-3.6-8-8-8"
            style="
              stroke: url(#linear-gradient-20);
              opacity: 0.7;
              stroke-width: 0;
              stroke-miterlimit: 10;
              fill: none;
            "
          />
          <path
            d="M50.1 17.2c0-4.4-3.6-8-8-8"
            style="
              opacity: 0.8;
              stroke-width: 0;
              stroke: url(#linear-gradient-21);
              stroke-miterlimit: 10;
              fill: none;
            "
          />
          <path
            d="M50.1 17.2c0-4.4-3.6-8-8-8"
            style="
              opacity: 0.9;
              stroke-width: 0;
              stroke: url(#linear-gradient-22);
              stroke-miterlimit: 10;
              fill: none;
            "
          />
        </g>
        <path
          d="M33.4 13.8c0 .2-.2.4-.4.4s-.4-.2-.4-.4.2-.4.4-.4.4.2.4.4Z"
          style="fill: url(#radial-gradient); stroke-width: 0"
        />
        <path
          class="cls-280"
          d="M32.5 13.8c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4-.4.2-.4.4Zm0 0c0-.2.2-.4.5-.4.2 0 .4.2.4.5 0 .2-.2.4-.5.4-.2 0-.4-.2-.4-.5Z"
        />
        <path
          d="M33.8 12.8c0 .2-.2.4-.4.4s-.4-.2-.4-.4.2-.4.4-.4.4.2.4.4Z"
          style="fill: url(#radial-gradient-2); stroke-width: 0"
        />
        <path
          class="cls-280"
          d="M32.9 12.8c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4-.4.2-.4.4Zm0 0c0-.2.2-.4.5-.4.2 0 .4.2.4.5 0 .2-.2.4-.5.4-.2 0-.4-.2-.4-.5Z"
        />
        <path
          d="M34.4 11.9c0 .2-.2.4-.4.4s-.4-.2-.4-.4.2-.4.4-.4.4.2.4.4Z"
          style="fill: url(#radial-gradient-3); stroke-width: 0"
        />
        <path
          class="cls-280"
          d="M33.5 11.9c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4-.4.2-.4.4Zm0 0c0-.2.2-.4.5-.4.2 0 .4.2.4.5 0 .2-.2.4-.5.4-.2 0-.4-.2-.4-.5Z"
        />
        <path
          d="M35 11.1c0 .2-.2.4-.4.4s-.4-.2-.4-.4.2-.4.4-.4.4.2.4.4Z"
          style="fill: url(#radial-gradient-4); stroke-width: 0"
        />
        <path
          class="cls-280"
          d="M34.1 11.1c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4-.4.2-.4.4Zm0 0c0-.2.2-.4.5-.4.2 0 .4.2.4.5 0 .2-.2.4-.5.4-.2 0-.4-.2-.4-.5Z"
        />
        <path
          d="M35.7 10.4c0 .2-.2.4-.4.4s-.4-.2-.4-.4.2-.4.4-.4.4.2.4.4Z"
          style="fill: url(#radial-gradient-5); stroke-width: 0"
        />
        <path
          class="cls-280"
          d="M34.8 10.4c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4-.4.2-.4.4Zm0 0c0-.2.2-.4.5-.4.2 0 .4.2.4.5 0 .2-.2.4-.5.4-.2 0-.4-.2-.4-.5Z"
        />
        <path
          d="M36.5 9.8c0 .2-.2.4-.4.4s-.4-.2-.4-.4.2-.4.4-.4.4.2.4.4Z"
          style="fill: url(#radial-gradient-6); stroke-width: 0"
        />
        <path
          class="cls-280"
          d="M35.6 9.8c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4-.4.2-.4.4Zm0 0c0-.2.2-.4.5-.4.2 0 .4.2.4.5 0 .2-.2.4-.5.4-.2 0-.4-.2-.4-.5Z"
        />
        <path
          d="M37.4 9.2c0 .2-.2.4-.4.4s-.4-.2-.4-.4.2-.4.4-.4.4.2.4.4Z"
          style="fill: url(#radial-gradient-7); stroke-width: 0"
        />
        <path
          class="cls-280"
          d="M36.5 9.2c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4-.4.2-.4.4Zm0 0c0-.2.2-.4.5-.4.2 0 .4.2.4.5 0 .2-.2.4-.5.4-.2 0-.4-.2-.4-.5Z"
        />
        <path
          d="M38.3 8.8c0 .2-.2.4-.4.4s-.4-.2-.4-.4.2-.4.4-.4.4.2.4.4Z"
          style="fill: url(#radial-gradient-8); stroke-width: 0"
        />
        <path
          class="cls-280"
          d="M37.4 8.8c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4-.4.2-.4.4Zm0 0c0-.2.2-.4.5-.4.2 0 .4.2.4.5 0 .2-.2.4-.5.4-.2 0-.4-.2-.4-.5Z"
        />
        <path
          d="M39.3 8.4c0 .2-.2.4-.4.4s-.4-.2-.4-.4.2-.4.4-.4.4.2.4.4Z"
          style="fill: url(#radial-gradient-9); stroke-width: 0"
        />
        <path
          class="cls-280"
          d="M38.4 8.4c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4-.4.2-.4.4Zm0 0c0-.2.2-.4.5-.4.2 0 .4.2.4.5 0 .2-.2.4-.5.4-.2 0-.4-.2-.4-.5Z"
        />
        <path
          d="M44.3 8.4c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4-.4.2-.4.4Z"
          style="fill: url(#radial-gradient-10); stroke-width: 0"
        />
        <path
          class="cls-280"
          d="M45.2 8.4c0-.2-.2-.4-.4-.4s-.4.2-.4.4.2.4.4.4.4-.2.4-.4Zm0 0c0 .2-.2.5-.4.5s-.5-.2-.5-.4.2-.5.4-.5.5.2.5.4Z"
        />
        <path
          d="M45.3 8.8c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4-.4.2-.4.4Z"
          style="fill: url(#radial-gradient-11); stroke-width: 0"
        />
        <path
          class="cls-280"
          d="M46.2 8.8c0-.2-.2-.4-.4-.4s-.4.2-.4.4.2.4.4.4.4-.2.4-.4Zm0 0c0 .2-.2.5-.4.5s-.5-.2-.5-.4.2-.5.4-.5.5.2.5.4Z"
        />
        <path
          d="M46.2 9.2c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4-.4.2-.4.4Z"
          style="fill: url(#radial-gradient-12); stroke-width: 0"
        />
        <path
          class="cls-280"
          d="M47.1 9.2c0-.2-.2-.4-.4-.4s-.4.2-.4.4.2.4.4.4.4-.2.4-.4Zm0 0c0 .2-.2.5-.4.5s-.5-.2-.5-.4.2-.5.4-.5.5.2.5.4Z"
        />
        <path
          d="M47.1 9.8c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4-.4.2-.4.4Z"
          style="fill: url(#radial-gradient-13); stroke-width: 0"
        />
        <path
          class="cls-280"
          d="M48 9.8c0-.2-.2-.4-.4-.4s-.4.2-.4.4.2.4.4.4.4-.2.4-.4Zm0 0c0 .2-.2.5-.4.5s-.5-.2-.5-.4.2-.5.4-.5.5.2.5.4Z"
        />
        <path
          d="M47.9 10.4c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4-.4.2-.4.4Z"
          style="fill: url(#radial-gradient-14); stroke-width: 0"
        />
        <path
          class="cls-280"
          d="M48.8 10.4c0-.2-.2-.4-.4-.4s-.4.2-.4.4.2.4.4.4.4-.2.4-.4Zm0 0c0 .2-.2.5-.4.5s-.5-.2-.5-.4.2-.5.4-.5.5.2.5.4Z"
        />
        <path
          d="M48.6 11.1c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4-.4.2-.4.4Z"
          style="fill: url(#radial-gradient-15); stroke-width: 0"
        />
        <path
          class="cls-280"
          d="M49.5 11.1c0-.2-.2-.4-.4-.4s-.4.2-.4.4.2.4.4.4.4-.2.4-.4Zm0 0c0 .2-.2.5-.4.5s-.5-.2-.5-.4.2-.5.4-.5.5.2.5.4Z"
        />
        <path
          d="M49.2 11.9c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4-.4.2-.4.4Z"
          style="fill: url(#radial-gradient-16); stroke-width: 0"
        />
        <path
          class="cls-280"
          d="M50.1 11.9c0-.2-.2-.4-.4-.4s-.4.2-.4.4.2.4.4.4.4-.2.4-.4Zm0 0c0 .2-.2.5-.4.5s-.5-.2-.5-.4.2-.5.4-.5.5.2.5.4Z"
        />
        <path
          d="M49.8 12.8c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4-.4.2-.4.4Z"
          style="fill: url(#radial-gradient-17); stroke-width: 0"
        />
        <path
          class="cls-280"
          d="M50.7 12.8c0-.2-.2-.4-.4-.4s-.4.2-.4.4.2.4.4.4.4-.2.4-.4Zm0 0c0 .2-.2.5-.4.5s-.5-.2-.5-.4.2-.5.4-.5.5.2.5.4Z"
        />
        <path
          d="M50.2 13.8c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4-.4.2-.4.4Z"
          style="fill: url(#radial-gradient-18); stroke-width: 0"
        />
        <path
          class="cls-280"
          d="M51.1 13.8c0-.2-.2-.4-.4-.4s-.4.2-.4.4.2.4.4.4.4-.2.4-.4Zm0 0c0 .2-.2.5-.4.5s-.5-.2-.5-.4.2-.5.4-.5.5.2.5.4Z"
        />
        <path
          d="M48.8 22.8c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-14c-.5 0-.9.4-.9.9s.4.9.9.9h14Z"
          style="
            fill: url(#radial-gradient-19);
            opacity: 0.5;
            mix-blend-mode: multiply;
            stroke-width: 0;
          "
        />
        <path
          class="cls-37"
          d="M48.8 22.8c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-14c-.5 0-.9.4-.9.9s.4.9.9.9h14Z"
        />
        <path
          class="cls-37"
          d="M48.8 22.8c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-14c-.5 0-.9.4-.9.9s.4.9.9.9h14Z"
        />
        <path
          class="cls-37"
          d="M48.8 22.8c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-14c-.5 0-.9.4-.9.9s.4.9.9.9h14Z"
        />
        <path
          class="cls-37"
          d="M48.8 22.8c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-14c-.5 0-.9.4-.9.9s.4.9.9.9h14Z"
        />
        <path
          class="cls-37"
          d="M48.8 22.8c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-14c-.5 0-.9.4-.9.9s.4.9.9.9h14Z"
        />
        <path
          class="cls-37"
          d="M48.8 22.8c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-14c-.5 0-.9.4-.9.9s.4.9.9.9h14Z"
        />
        <path
          class="cls-37"
          d="M48.8 22.8c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-14c-.5 0-.9.4-.9.9s.4.9.9.9h14Z"
        />
        <path
          class="cls-37"
          d="M48.8 22.8c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-14c-.5 0-.9.4-.9.9s.4.9.9.9h14Z"
        />
        <path
          class="cls-37"
          d="M48.8 22.8c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-14c-.5 0-.9.4-.9.9s.4.9.9.9h14Z"
        />
        <path
          class="cls-37"
          d="M48.8 22.8c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-14c-.5 0-.9.4-.9.9s.4.9.9.9h14Z"
        />
        <path
          class="cls-37"
          d="M48.8 22.8c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-14c-.5 0-.9.4-.9.9s.4.9.9.9h14Z"
        />
        <path
          class="cls-37"
          d="M48.8 22.8c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-14c-.5 0-.9.4-.9.9s.4.9.9.9h14Z"
        />
        <path
          class="cls-37"
          d="M48.8 22.8c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-14c-.5 0-.9.4-.9.9s.4.9.9.9h14Z"
        />
        <path
          class="cls-37"
          d="M48.8 22.8c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-14c-.5 0-.9.4-.9.9s.4.9.9.9h14Z"
        />
        <path
          class="cls-37"
          d="M48.8 22.8c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-14c-.5 0-.9.4-.9.9s.4.9.9.9h14Z"
        />
        <path
          class="cls-37"
          d="M48.8 22.8c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-14c-.5 0-.9.4-.9.9s.4.9.9.9h14Z"
        />
        <path
          class="cls-37"
          d="M48.8 22.8c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-14c-.5 0-.9.4-.9.9s.4.9.9.9h14Z"
        />
        <path
          class="cls-37"
          d="M48.8 22.8c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-14c-.5 0-.9.4-.9.9s.4.9.9.9h14Z"
        />
        <path
          class="cls-37"
          d="M48.8 22.8c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-14c-.5 0-.9.4-.9.9s.4.9.9.9h14Z"
        />
        <path
          class="cls-37"
          d="M48.8 22.8c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-14c-.5 0-.9.4-.9.9s.4.9.9.9h14Z"
        />
        <path
          class="cls-37"
          d="M48.8 22.8c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-14c-.5 0-.9.4-.9.9s.4.9.9.9h14Z"
        />
        <path
          class="cls-37"
          d="M48.8 22.8c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-14c-.5 0-.9.4-.9.9s.4.9.9.9h14Z"
        />
        <path
          class="cls-37"
          d="M48.8 22.8c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-14c-.5 0-.9.4-.9.9s.4.9.9.9h14Z"
        />
        <path
          class="cls-37"
          d="M48.8 22.8c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-14c-.5 0-.9.4-.9.9s.4.9.9.9h14Z"
        />
        <path
          class="cls-37"
          d="M48.8 22.8c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-14c-.5 0-.9.4-.9.9s.4.9.9.9h14Z"
        />
        <path
          class="cls-37"
          d="M48.8 22.8c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-14c-.5 0-.9.4-.9.9s.4.9.9.9h14Z"
        />
        <path
          class="cls-37"
          d="M48.8 22.8c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-14c-.5 0-.9.4-.9.9s.4.9.9.9h14Z"
        />
        <path
          d="M34.9 21h13.7c.5 0 .9.4.9.8 0 .5-.4.8-.9.8H34.9c-.5 0-.9-.4-.9-.8 0-.5.4-.8.9-.8Z"
          style="fill: #809ea8; opacity: 1; stroke-width: 0"
        />
        <path
          d="M35.1 21.1h13.4c.5 0 .9.4 1 .8 0 .4-.4.8-1 .8H35.1c-.5 0-.9-.4-.9-.8s.4-.8.9-.8Z"
          style="fill: #83a1aa; opacity: 1; stroke-width: 0"
        />
        <path
          d="M35.2 21.1h13.1c.5 0 1 .4 1 .8s-.4.8-1 .8H35.2c-.6 0-1-.4-1-.8s.4-.8 1-.8Z"
          style="fill: #87a3ad; opacity: 1; stroke-width: 0"
        />
        <path
          d="M35.4 21.1h12.8c.6 0 1 .3 1 .8 0 .4-.4.8-1 .8H35.4c-.6 0-1-.3-1-.8 0-.4.4-.8 1-.8Z"
          style="fill: #8aa6af; opacity: 0.9; stroke-width: 0"
        />
        <path
          d="M35.6 21.1H48c.6 0 1.1.3 1.1.7 0 .4-.4.7-1.1.7H35.6c-.6 0-1.1-.3-1.1-.7 0-.4.4-.7 1.1-.7Z"
          style="fill: #8da8b1; opacity: 0.9; stroke-width: 0"
        />
        <path
          d="M35.7 21.1h12.1c.6 0 1.1.3 1.1.7 0 .4-.4.7-1.1.7H35.7c-.7 0-1.1-.3-1.1-.7 0-.4.4-.7 1.1-.7Z"
          style="fill: #91aab3; opacity: 0.9; stroke-width: 0"
        />
        <path
          d="M35.9 21.2h11.8c.6 0 1.1.3 1.2.7 0 .4-.4.7-1.2.7H35.9c-.7 0-1.1-.3-1.1-.7 0-.4.5-.7 1.1-.7Z"
          style="fill: #94adb6; opacity: 0.9; stroke-width: 0"
        />
        <path
          d="M36 21.2h11.5c.7 0 1.2.3 1.2.7 0 .4-.4.7-1.2.7H36c-.7 0-1.2-.3-1.2-.7 0-.4.5-.7 1.2-.7Z"
          style="fill: #97afb8; opacity: 0.9; stroke-width: 0"
        />
        <path
          d="M36.2 21.2h11.2c.7 0 1.2.3 1.3.6 0 .3-.4.6-1.2.6H36.3c-.8 0-1.2-.3-1.2-.6s.5-.6 1.2-.6Z"
          style="fill: #9bb2ba; opacity: 0.9; stroke-width: 0"
        />
        <path
          d="M36.3 21.2h10.8c.7 0 1.2.3 1.3.6 0 .3-.4.6-1.3.6H36.3c-.8 0-1.3-.3-1.3-.6s.5-.6 1.3-.6Z"
          style="fill: #9eb4bc; opacity: 0.8; stroke-width: 0"
        />
        <path
          d="M36.5 21.2H47c.7 0 1.3.3 1.3.6s-.4.6-1.3.6H36.5c-.8 0-1.3-.3-1.3-.6s.5-.6 1.3-.6Z"
          style="fill: #a1b7bf; opacity: 0.8; stroke-width: 0"
        />
        <path
          d="M36.7 21.2h10.2c.8 0 1.3.2 1.4.5 0 .3-.4.5-1.4.5H36.7c-.8 0-1.3-.2-1.3-.5s.5-.5 1.3-.5Z"
          style="fill: #a5b9c1; opacity: 0.8; stroke-width: 0"
        />
        <path
          d="M36.8 21.3h9.9c.8 0 1.4.2 1.4.5s-.4.5-1.4.5h-9.9c-.9 0-1.4-.2-1.4-.5s.5-.5 1.4-.5Z"
          style="fill: #a8bcc3; opacity: 0.8; stroke-width: 0"
        />
        <path
          d="M37 21.3h9.6c.8 0 1.4.2 1.5.5 0 .3-.4.5-1.5.5H37c-.9 0-1.4-.2-1.4-.5s.5-.5 1.4-.5Z"
          style="fill: #abbec5; opacity: 0.8; stroke-width: 0"
        />
        <path
          d="M37.1 21.3h9.2c.8 0 1.4.2 1.5.5 0 .2-.4.5-1.5.5H37c-.9 0-1.5-.2-1.5-.5s.5-.5 1.5-.5Z"
          style="fill: #afc1c8; opacity: 0.8; stroke-width: 0"
        />
        <path
          d="M37.3 21.3h8.9c.8 0 1.5.2 1.6.4 0 .2-.4.4-1.5.4h-8.9c-1 0-1.5-.2-1.5-.4s.5-.4 1.5-.4Z"
          style="fill: #b2c3ca; opacity: 0.7; stroke-width: 0"
        />
        <path
          d="M37.5 21.3h8.6c.9 0 1.5.2 1.6.4 0 .2-.4.4-1.6.4h-8.6c-1 0-1.5-.2-1.5-.4s.5-.4 1.5-.4Z"
          style="fill: #b5c6cc; opacity: 0.7; stroke-width: 0"
        />
        <path
          d="M37.6 21.3h8.3c.9 0 1.6.2 1.6.4s-.4.4-1.6.4h-8.3c-1 0-1.6-.2-1.6-.4s.6-.4 1.6-.4Z"
          style="fill: #b9c8ce; opacity: 0.7; stroke-width: 0"
        />
        <path
          d="M37.8 21.4h8c.9 0 1.6.2 1.7.3 0 .2-.4.3-1.7.3h-8c-1.1 0-1.6-.2-1.6-.4s.6-.4 1.6-.4Z"
          style="fill: #bccbd0; opacity: 0.7; stroke-width: 0"
        />
        <path
          d="M37.9 21.4h7.6c.9 0 1.6.2 1.7.3 0 .2-.4.3-1.7.3h-7.7c-1.1 0-1.7-.2-1.7-.3 0-.2.6-.3 1.7-.3Z"
          style="fill: #bfcdd3; opacity: 0.7; stroke-width: 0"
        />
        <path
          d="M38.1 21.4h7.3c1 0 1.7.1 1.8.3.1.2-.4.3-1.7.3h-7.3c-1.1 0-1.7-.1-1.7-.3 0-.2.6-.3 1.7-.3Z"
          style="fill: #c3d0d5; opacity: 0.7; stroke-width: 0"
        />
        <path
          d="M38.2 21.4h7c1 0 1.7.1 1.8.3.1.1-.4.3-1.8.3h-7c-1.1 0-1.7-.1-1.7-.3 0-.1.6-.3 1.7-.3Z"
          style="fill: #c6d2d7; opacity: 0.7; stroke-width: 0"
        />
        <path
          d="M38.4 21.4h6.7c1 0 1.7.1 1.9.2.1.1-.4.2-1.8.2h-6.7c-1.2 0-1.8-.1-1.8-.3 0-.1.6-.3 1.8-.3Z"
          style="fill: #c9d4d9; opacity: 0.6; stroke-width: 0"
        />
        <path
          d="M38.6 21.4H45c1 0 1.8.1 1.9.2.1.1-.4.2-1.9.2h-6.4c-1.2 0-1.8-.1-1.8-.2s.6-.2 1.8-.2Z"
          style="fill: #cdd7dc; opacity: 0.6; stroke-width: 0"
        />
        <path
          d="M38.7 21.5h6c1 0 1.8 0 1.9.2.1 0-.4.2-1.9.2h-6.1c-1.2 0-1.9 0-1.9-.2 0-.1.6-.2 1.9-.2Z"
          style="fill: #d0d9de; opacity: 0.6; stroke-width: 0"
        />
        <path
          d="M44.6 21.8h-5.8c-2.5 0-2.5-.3 0-.3h5.7c2.1 0 3.1.3 0 .3Z"
          style="fill: #d3dce0; opacity: 0.6; stroke-width: 0"
        />
        <path
          d="M48.8 22.8c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-14c-.5 0-.9.4-.9.9s.4.9.9.9h14Z"
          style="
            fill: url(#radial-gradient-20);
            opacity: 0.5;
            mix-blend-mode: multiply;
            stroke-width: 0;
          "
        />
        <path
          d="M41.8 21h7s0-1.5.2-2.2c0-.7.4-1.5.6-2 .4-.9.9-2 .9-2l-1.2-.4h-.1s.3.9.3 1.1c0 .1 0 .4-.1.5-.2 0-.4-.1-.4-.3l-.2-.6-.7 2.4s.5-.5.7-.3c.1.1 0 .3-.1.5-.2.2-.7.4-.9.4-.8 0-1.3-.7-1.4-1.1 0-.3 0-.8.5-.8s.3.6.3.6.5-.3.7-1c.2-.7-.2-1-.4-1s-.4 0-.8.4c0 0 .3-.5.4-1 .1-.7-.2-1.2-.3-1.4 0-.2-.3-.4-.3-.4s-.1 0-.4.3c-.3.3-.7.8-.7 1.4s0 .5.2 1.1c0 0-.2-.5-.8-.5s-.7.7-.7.9 0 .6.4 1.1c0 0 0-.6.5-.6s.6.5.4.9c-.2.3-.6 1.2-1.8 1.2s-1.4-.6-1.4-1.3.5-.6.8-.2l.5.6v-2.7l-.8.6h-.4v-.4l.9-.9h-3l.9.9v.4h-.4l-.8-.6v2.7l.5-.6c.4-.4.8-.3.8.2s-.7 1.3-1.4 1.3c-1.2 0-1.6-.9-1.8-1.2-.2-.4-.2-.9.4-.9s.5.6.5.6c.3-.6.4-.9.4-1.1s0-.9-.7-.9-.8.5-.8.5c.2-.6.2-.8.2-1.1 0-.6-.4-1.1-.7-1.4-.2-.3-.4-.3-.4-.3s-.2.3-.3.4c-.1.3-.5.7-.3 1.4 0 .5.4 1 .4 1-.4-.4-.5-.4-.8-.4s-.6.4-.4 1c.2.7.7 1 .7 1s0-.6.3-.6c.5 0 .6.5.5.8 0 .4-.7 1.1-1.4 1.1s-.7-.1-.9-.4c-.2-.2-.3-.4-.1-.5.2-.2.7.3.7.3l-.7-2.5-.2.7c0 .2-.2.4-.4.3-.2 0-.2-.3-.1-.5 0-.1.3-1.1.3-1.1h-.1l-1.2.4s.5 1 .9 2c.2.5.6 1.3.6 2s.2 2.2.2 2.2h7Z"
          style="fill: url(#linear-gradient-23); stroke-width: 0"
        />
        <path
          class="cls-72"
          d="M36.8 20.3c0 .3.6.6 1.2.6s1.2-.3 1.2-.6-.6-.6-1.2-.6-1.2.3-1.2.6Z"
        />
        <path
          class="cls-401"
          d="M36.8 20.3c0 .3.5.6 1.2.6s1.2-.3 1.2-.6-.5-.6-1.2-.6-1.2.3-1.2.6Z"
        />
        <path
          class="cls-367"
          d="M36.8 20.3c0 .3.5.6 1.2.6s1.2-.2 1.2-.6-.5-.6-1.2-.6-1.2.2-1.2.6Z"
        />
        <path
          class="cls-64"
          d="M36.8 20.3c0 .3.5.5 1.2.5s1.2-.2 1.2-.5-.5-.5-1.2-.5-1.2.2-1.2.5Z"
        />
        <path
          class="cls-297"
          d="M36.9 20.3c0 .3.5.5 1.2.5s1.2-.2 1.2-.5-.5-.5-1.2-.5-1.2.2-1.2.5Z"
        />
        <path
          class="cls-299"
          d="M36.9 20.3c0 .3.5.5 1.1.5s1.1-.2 1.1-.5-.5-.5-1.1-.5-1.1.2-1.1.5Z"
        />
        <path
          class="cls-340"
          d="M36.9 20.3c0 .3.5.5 1.1.5s1.1-.2 1.1-.5-.5-.5-1.1-.5-1.1.2-1.1.5Z"
        />
        <path
          class="cls-49"
          d="M36.9 20.3c0 .3.5.5 1.1.5s1.1-.2 1.1-.5-.5-.5-1.1-.5-1.1.2-1.1.5Z"
        />
        <path
          class="cls-353"
          d="M36.9 20.4c0 .3.5.5 1.1.5s1.1-.2 1.1-.5-.5-.5-1.1-.5-1.1.2-1.1.5Z"
        />
        <path
          class="cls-81"
          d="M37 20.4c0 .3.5.5 1.1.5s1.1-.2 1.1-.5-.5-.5-1.1-.5-1.1.2-1.1.5Z"
        />
        <path
          class="cls-72"
          d="M46.8 20.3c0 .3-.6.6-1.2.6s-1.2-.3-1.2-.6.6-.6 1.2-.6 1.2.3 1.2.6Z"
        />
        <path
          class="cls-401"
          d="M46.8 20.3c0 .3-.5.6-1.2.6s-1.2-.3-1.2-.6.5-.6 1.2-.6 1.2.3 1.2.6Z"
        />
        <path
          class="cls-367"
          d="M46.8 20.3c0 .3-.5.6-1.2.6s-1.2-.2-1.2-.6.5-.6 1.2-.6 1.2.2 1.2.6Z"
        />
        <path
          class="cls-64"
          d="M46.7 20.3c0 .3-.5.5-1.2.5s-1.2-.2-1.2-.5.5-.5 1.2-.5 1.2.2 1.2.5Z"
        />
        <path
          class="cls-297"
          d="M46.7 20.3c0 .3-.5.5-1.2.5s-1.2-.2-1.2-.5.5-.5 1.2-.5 1.2.2 1.2.5Z"
        />
        <path
          class="cls-299"
          d="M46.7 20.3c0 .3-.5.5-1.1.5s-1.1-.2-1.1-.5.5-.5 1.1-.5 1.1.2 1.1.5Z"
        />
        <path
          class="cls-340"
          d="M46.7 20.3c0 .3-.5.5-1.1.5s-1.1-.2-1.1-.5.5-.5 1.1-.5 1.1.2 1.1.5Z"
        />
        <path
          class="cls-49"
          d="M46.6 20.3c0 .3-.5.5-1.1.5s-1.1-.2-1.1-.5.5-.5 1.1-.5 1.1.2 1.1.5Z"
        />
        <path
          class="cls-353"
          d="M46.6 20.4c0 .3-.5.5-1.1.5s-1.1-.2-1.1-.5.5-.5 1.1-.5 1.1.2 1.1.5Z"
        />
        <path
          class="cls-81"
          d="M46.6 20.4c0 .3-.5.5-1.1.5s-1.1-.2-1.1-.5.5-.5 1.1-.5 1.1.2 1.1.5Z"
        />
        <path
          class="cls-208"
          d="M36.9 20.2c0 .3.5.5 1.2.5s1.2-.2 1.2-.5-.5-.5-1.2-.5-1.2.2-1.2.5Z"
        />
        <path
          class="cls-159"
          d="M36.9 20.2c0 .3.5.5 1.2.5s1.2-.2 1.2-.5-.5-.5-1.2-.5-1.2.2-1.2.5Z"
        />
        <path
          class="cls-27"
          d="M36.9 20.2c0 .3.5.5 1.2.5s1.2-.2 1.2-.5-.5-.5-1.2-.5-1.2.2-1.2.5Z"
        />
        <path
          class="cls-187"
          d="M36.9 20.2c0 .3.5.5 1.2.5s1.2-.2 1.2-.5-.5-.5-1.2-.5-1.2.2-1.2.5Z"
        />
        <path
          class="cls-275"
          d="M36.9 20.2c0 .3.5.5 1.2.5s1.2-.2 1.2-.5-.5-.5-1.2-.5-1.2.2-1.2.5Z"
        />
        <path
          class="cls-388"
          d="M36.9 20.2c0 .3.5.5 1.2.5s1.2-.2 1.2-.5-.5-.5-1.2-.5-1.2.2-1.2.5Z"
        />
        <path
          class="cls-404"
          d="M36.9 20.2c0 .3.5.5 1.2.5s1.2-.2 1.2-.5-.5-.5-1.2-.5-1.2.2-1.2.5Z"
        />
        <path
          class="cls-259"
          d="M36.9 20.2c0 .3.5.5 1.2.5s1.2-.2 1.2-.5-.5-.5-1.2-.5-1.2.2-1.2.5Z"
        />
        <path
          class="cls-210"
          d="M36.9 20.2c0 .3.5.5 1.2.5s1.2-.2 1.2-.5-.5-.5-1.2-.5-1.2.2-1.2.5Z"
        />
        <path
          class="cls-311"
          d="M36.9 20.2c0 .3.5.5 1.2.5s1.2-.2 1.2-.5-.5-.5-1.2-.5-1.2.2-1.2.5Z"
        />
        <path
          class="cls-74"
          d="M36.9 20.2c0 .3.5.5 1.2.5s1.2-.2 1.2-.5-.5-.5-1.2-.5-1.2.2-1.2.5Z"
        />
        <path
          class="cls-288"
          d="M36.9 20.2c0 .3.5.5 1.2.5s1.2-.2 1.2-.5-.5-.5-1.2-.5-1.2.2-1.2.5Z"
        />
        <path
          class="cls-344"
          d="M36.9 20.2c0 .3.5.5 1.2.5s1.2-.2 1.2-.5-.5-.5-1.2-.5-1.2.2-1.2.5Z"
        />
        <path
          class="cls-56"
          d="M36.9 20.2c0 .3.5.5 1.2.5s1.2-.2 1.2-.5-.5-.5-1.2-.5-1.2.2-1.2.5Z"
        />
        <path
          class="cls-54"
          d="M36.9 20.2c0 .3.5.5 1.2.5s1.2-.2 1.2-.5-.5-.5-1.2-.5-1.2.2-1.2.5Z"
        />
        <path
          class="cls-186"
          d="M36.9 20.2c0 .3.5.5 1.2.5s1.2-.2 1.2-.5-.5-.5-1.2-.5-1.2.2-1.2.5Z"
        />
        <path
          class="cls-214"
          d="M36.9 20.2c0 .3.5.5 1.2.5s1.2-.2 1.2-.5-.5-.5-1.2-.5-1.2.2-1.2.5Z"
        />
        <path
          class="cls-80"
          d="M36.9 20.2c0 .3.5.5 1.2.5s1.2-.2 1.2-.5-.5-.5-1.2-.5-1.2.2-1.2.5Z"
        />
        <path
          class="cls-178"
          d="M36.9 20.2c0 .3.5.5 1.2.5s1.2-.2 1.2-.5-.5-.5-1.2-.5-1.2.2-1.2.5Z"
        />
        <path
          class="cls-78"
          d="M36.9 20.2c0 .3.5.5 1.2.5s1.2-.2 1.2-.5-.5-.5-1.2-.5-1.2.2-1.2.5Z"
        />
        <path
          class="cls-364"
          d="M36.9 20.2c0 .3.5.5 1.2.5s1.2-.2 1.2-.5-.5-.5-1.2-.5-1.2.2-1.2.5Z"
        />
        <path
          class="cls-312"
          d="M36.9 20.2c0 .3.5.5 1.1.5s1.1-.2 1.1-.5-.5-.5-1.1-.5-1.1.2-1.1.5Z"
        />
        <path
          class="cls-221"
          d="M36.9 20.2c0 .3.5.5 1.1.5s1.1-.2 1.1-.5-.5-.5-1.1-.5-1.1.2-1.1.5Z"
        />
        <path
          class="cls-192"
          d="M37 20.2c0 .3.5.5 1.1.5s1.1-.2 1.1-.5-.5-.5-1.1-.5-1.1.2-1.1.5Z"
        />
        <path
          class="cls-62"
          d="M37 20.2c0 .3.5.5 1.1.5s1.1-.2 1.1-.5-.5-.5-1.1-.5-1.1.2-1.1.5Z"
        />
        <path
          class="cls-291"
          d="M37 20.2c0 .3.5.5 1.1.5s1.1-.2 1.1-.5-.5-.5-1.1-.5-1.1.2-1.1.5Z"
        />
        <path
          class="cls-358"
          d="M37 20.2c0 .3.5.5 1.1.5s1.1-.2 1.1-.5-.5-.5-1.1-.5-1.1.2-1.1.5Z"
        />
        <path
          class="cls-322"
          d="M37 20.2c0 .3.5.5 1.1.5s1.1-.2 1.1-.5-.5-.5-1.1-.5-1.1.2-1.1.5Z"
        />
        <path
          class="cls-110"
          d="M37 20.2c0 .3.5.5 1.1.5s1.1-.2 1.1-.5-.5-.5-1.1-.5-1.1.2-1.1.5Z"
        />
        <path
          class="cls-272"
          d="M37.1 20.1c0 .3.5.5 1.1.5s1.1-.2 1.1-.5-.5-.5-1.1-.5-1.1.2-1.1.5Z"
        />
        <path
          class="cls-301"
          d="M37.1 20.1c0 .2.5.5 1.1.5s1.1-.2 1.1-.5-.5-.5-1.1-.5-1.1.2-1.1.5Z"
        />
        <path
          class="cls-71"
          d="M37.1 20.1c0 .2.5.4 1 .4s1-.2 1-.4-.5-.4-1-.4-1 .2-1 .4Z"
        />
        <path
          class="cls-26"
          d="M37.1 20.1c0 .2.5.4 1 .4s1-.2 1-.4-.5-.4-1-.4-1 .2-1 .4Z"
        />
        <path
          class="cls-374"
          d="M37.1 20.1c0 .2.5.4 1 .4s1-.2 1-.4-.5-.4-1-.4-1 .2-1 .4Z"
        />
        <path
          class="cls-242"
          d="M37.2 20.1c0 .2.5.4 1 .4s1-.2 1-.4-.5-.4-1-.4-1 .2-1 .4Z"
        />
        <path
          class="cls-324"
          d="M37.2 20.1c0 .2.4.4 1 .4s1-.2 1-.4-.4-.4-1-.4-1 .2-1 .4Z"
        />
        <path
          class="cls-337"
          d="M37.2 20.1c0 .2.4.4 1 .4s1-.2 1-.4-.4-.4-1-.4-1 .2-1 .4Z"
        />
        <path
          class="cls-292"
          d="M37.2 20.1c0 .2.4.4 1 .4s1-.2 1-.4-.4-.4-1-.4-1 .2-1 .4Z"
        />
        <path
          class="cls-44"
          d="M37.2 20.1c0 .2.4.4 1 .4s1-.2 1-.4-.4-.4-1-.4-1 .2-1 .4Z"
        />
        <path
          class="cls-237"
          d="M37.2 20.1c0 .2.4.4 1 .4s1-.2 1-.4-.4-.4-1-.4-1 .2-1 .4Z"
        />
        <path
          class="cls-349"
          d="M37.3 20.1c0 .2.4.4.9.4s.9-.2.9-.4-.4-.4-.9-.4-.9.2-.9.4Z"
        />
        <path
          class="cls-244"
          d="M37.3 20.1c0 .2.4.4.9.4s.9-.2.9-.4-.4-.4-.9-.4-.9.2-.9.4Z"
        />
        <path
          class="cls-2"
          d="M37.3 20.1c0 .2.4.4.9.4s.9-.2.9-.4-.4-.4-.9-.4-.9.2-.9.4Z"
        />
        <path
          class="cls-313"
          d="M37.3 20.1c0 .2.4.4.9.4s.9-.2.9-.4-.4-.4-.9-.4-.9.2-.9.4Z"
        />
        <path
          class="cls-357"
          d="M37.3 20.1c0 .2.4.4.9.4s.9-.2.9-.4-.4-.4-.9-.4-.9.2-.9.4Z"
        />
        <path
          class="cls-164"
          d="M37.4 20.1c0 .2.4.3.9.3s.9-.2.9-.3-.4-.3-.9-.3-.9.2-.9.3Z"
        />
        <path
          class="cls-68"
          d="M37.4 20.1c0 .2.4.3.8.3s.8-.2.8-.3-.4-.3-.8-.3-.8.2-.8.3Z"
        />
        <path
          class="cls-393"
          d="M37.4 20.1c0 .2.4.3.8.3s.8-.1.8-.3-.4-.3-.8-.3-.8.1-.8.3Z"
        />
        <path
          class="cls-409"
          d="M37.4 20.1c0 .2.4.3.8.3s.8-.1.8-.3-.4-.3-.8-.3-.8.1-.8.3Z"
        />
        <path
          class="cls-407"
          d="M37.4 20.1c0 .2.3.3.8.3s.8-.1.8-.3-.3-.3-.8-.3-.8.1-.8.3Z"
        />
        <path
          class="cls-294"
          d="M37.5 20.1c0 .2.3.3.8.3s.8-.1.8-.3-.3-.3-.8-.3-.8.1-.8.3Z"
        />
        <path
          class="cls-235"
          d="M37.5 20.1c0 .2.3.3.7.3s.7-.1.7-.3-.3-.3-.7-.3-.7.1-.7.3Z"
        />
        <path
          class="cls-163"
          d="M37.5 20.1c0 .2.3.3.7.3s.7-.1.7-.3-.3-.3-.7-.3-.7.1-.7.3Z"
        />
        <path
          class="cls-327"
          d="M37.5 20.1c0 .2.3.3.7.3s.7-.1.7-.3-.3-.3-.7-.3-.7.1-.7.3Z"
        />
        <path
          class="cls-300"
          d="M37.5 20.1c0 .1.3.3.7.3s.7-.1.7-.3-.3-.3-.7-.3-.7.1-.7.3Z"
        />
        <path
          class="cls-168"
          d="M37.6 20.1c0 .1.3.3.7.3s.7-.1.7-.3-.3-.3-.7-.3-.7.1-.7.3Z"
        />
        <path
          class="cls-281"
          d="M37.6 20.1c0 .1.3.3.6.3s.6-.1.6-.3-.3-.3-.6-.3-.6.1-.6.3Z"
        />
        <path
          class="cls-63"
          d="M37.6 20.1c0 .1.3.2.6.2s.6-.1.6-.2-.3-.2-.6-.2-.6.1-.6.2Z"
        />
        <path
          class="cls-328"
          d="M37.6 20.1c0 .1.3.2.6.2s.6-.1.6-.2-.3-.2-.6-.2-.6.1-.6.2Z"
        />
        <path
          class="cls-39"
          d="M37.6 20.1c0 .1.3.2.6.2s.6-.1.6-.2-.3-.2-.6-.2-.6.1-.6.2Z"
        />
        <path
          class="cls-413"
          d="M37.7 20.1c0 .1.3.2.6.2s.6 0 .6-.2-.3-.2-.6-.2-.6 0-.6.2Z"
        />
        <path
          class="cls-112"
          d="M37.7 20.1c0 .1.2.2.5.2s.5 0 .5-.2-.2-.2-.5-.2-.5 0-.5.2Z"
        />
        <path
          class="cls-384"
          d="M37.7 20.1c0 .1.2.2.5.2s.5 0 .5-.2-.2-.2-.5-.2-.5 0-.5.2Z"
        />
        <path
          class="cls-236"
          d="M37.7 20.1c0 .1.2.2.5.2s.5 0 .5-.2-.2-.2-.5-.2-.5 0-.5.2Z"
        />
        <path
          class="cls-241"
          d="M37.7 20.1c0 .1.2.2.5.2s.5 0 .5-.2-.2-.2-.5-.2-.5 0-.5.2Z"
        />
        <path
          class="cls-220"
          d="M37.7 20s.2.2.5.2.5 0 .5-.2-.2-.2-.5-.2-.5 0-.5.2Z"
        />
        <path
          class="cls-240"
          d="M37.8 20s.2.2.5.2.5 0 .5-.2-.2-.2-.5-.2-.5 0-.5.2Z"
        />
        <path
          class="cls-303"
          d="M37.8 20s.2.2.5.2.5 0 .5-.2-.2-.2-.5-.2-.5 0-.5.2Z"
        />
        <path
          class="cls-209"
          d="M37.8 20s.2.2.4.2.4 0 .4-.2-.2-.2-.4-.2-.4 0-.4.2Z"
        />
        <path
          class="cls-69"
          d="M37.8 20s.2.2.4.2.4 0 .4-.2-.2-.2-.4-.2-.4 0-.4.2Z"
        />
        <path
          class="cls-177"
          d="M37.8 20s.2.2.4.2.4 0 .4-.2-.2-.2-.4-.2-.4 0-.4.2Z"
        />
        <path
          class="cls-120"
          d="M37.8 20s.2.1.4.1.4 0 .4-.1-.2-.1-.4-.1-.4 0-.4.1Z"
        />
        <path
          class="cls-109"
          d="M37.8 20s.2.1.4.1.4 0 .4-.1-.2-.1-.4-.1-.4 0-.4.1Z"
        />
        <path
          class="cls-31"
          d="M37.8 20s.2.1.4.1.4 0 .4-.1-.2-.1-.4-.1-.4 0-.4.1Z"
        />
        <path
          class="cls-19"
          d="M37.8 20s.2.1.4.1.4 0 .4-.1-.2-.1-.4-.1-.4 0-.4.1Z"
        />
        <path
          class="cls-176"
          d="M37.9 20s.2.1.4.1.4 0 .4-.1-.2-.1-.4-.1-.4 0-.4.1Z"
        />
        <path
          class="cls-200"
          d="M37.9 20s.2.1.4.1.4 0 .4-.1-.2-.1-.4-.1-.4 0-.4.1Z"
        />
        <path
          class="cls-233"
          d="M37.9 20s.2.1.3.1.3 0 .3-.1-.2-.1-.3-.1-.3 0-.3.1Z"
        />
        <path
          class="cls-224"
          d="M37.9 20s.1.1.3.1.3 0 .3-.1-.1-.1-.3-.1-.3 0-.3.1Z"
        />
        <path
          class="cls-362"
          d="M37.9 20s.1.1.3.1.3 0 .3-.1-.1-.1-.3-.1-.3 0-.3.1Z"
        />
        <path
          class="cls-378"
          d="M37.9 20s.1.1.3.1.3 0 .3-.1-.1-.1-.3-.1-.3 0-.3.1Z"
        />
        <path class="cls-1" d="M37.9 20h.6-.6Z" />
        <path class="cls-11" d="M37.9 20h.6-.6Z" />
        <path class="cls-8" d="M38 20h.6-.6Z" />
        <path class="cls-107" d="M38 20h.6-.6Z" />
        <path
          class="cls-208"
          d="M46.7 20.2c0 .3-.5.5-1.2.5s-1.2-.2-1.2-.5.5-.5 1.2-.5 1.2.2 1.2.5Z"
        />
        <path
          class="cls-159"
          d="M46.7 20.2c0 .3-.5.5-1.2.5s-1.2-.2-1.2-.5.5-.5 1.2-.5 1.2.2 1.2.5Z"
        />
        <path
          class="cls-27"
          d="M46.7 20.2c0 .3-.5.5-1.2.5s-1.2-.2-1.2-.5.5-.5 1.2-.5 1.2.2 1.2.5Z"
        />
        <path
          class="cls-187"
          d="M46.7 20.2c0 .3-.5.5-1.2.5s-1.2-.2-1.2-.5.5-.5 1.2-.5 1.2.2 1.2.5Z"
        />
        <path
          class="cls-275"
          d="M46.7 20.2c0 .3-.5.5-1.2.5s-1.2-.2-1.2-.5.5-.5 1.2-.5 1.2.2 1.2.5Z"
        />
        <path
          class="cls-388"
          d="M46.7 20.2c0 .3-.5.5-1.2.5s-1.2-.2-1.2-.5.5-.5 1.2-.5 1.2.2 1.2.5Z"
        />
        <path
          class="cls-404"
          d="M46.7 20.2c0 .3-.5.5-1.2.5s-1.2-.2-1.2-.5.5-.5 1.2-.5 1.2.2 1.2.5Z"
        />
        <path
          class="cls-259"
          d="M46.7 20.2c0 .3-.5.5-1.2.5s-1.2-.2-1.2-.5.5-.5 1.2-.5 1.2.2 1.2.5Z"
        />
        <path
          class="cls-210"
          d="M46.7 20.2c0 .3-.5.5-1.2.5s-1.2-.2-1.2-.5.5-.5 1.2-.5 1.2.2 1.2.5Z"
        />
        <path
          class="cls-311"
          d="M46.7 20.2c0 .3-.5.5-1.2.5s-1.2-.2-1.2-.5.5-.5 1.2-.5 1.2.2 1.2.5Z"
        />
        <path
          class="cls-74"
          d="M46.7 20.2c0 .3-.5.5-1.2.5s-1.2-.2-1.2-.5.5-.5 1.2-.5 1.2.2 1.2.5Z"
        />
        <path
          class="cls-288"
          d="M46.7 20.2c0 .3-.5.5-1.2.5s-1.2-.2-1.2-.5.5-.5 1.2-.5 1.2.2 1.2.5Z"
        />
        <path
          class="cls-344"
          d="M46.7 20.2c0 .3-.5.5-1.2.5s-1.2-.2-1.2-.5.5-.5 1.2-.5 1.2.2 1.2.5Z"
        />
        <path
          class="cls-56"
          d="M46.7 20.2c0 .3-.5.5-1.2.5s-1.2-.2-1.2-.5.5-.5 1.2-.5 1.2.2 1.2.5Z"
        />
        <path
          class="cls-54"
          d="M46.7 20.2c0 .3-.5.5-1.2.5s-1.2-.2-1.2-.5.5-.5 1.2-.5 1.2.2 1.2.5Z"
        />
        <path
          class="cls-186"
          d="M46.7 20.2c0 .3-.5.5-1.2.5s-1.2-.2-1.2-.5.5-.5 1.2-.5 1.2.2 1.2.5Z"
        />
        <path
          class="cls-214"
          d="M46.7 20.2c0 .3-.5.5-1.2.5s-1.2-.2-1.2-.5.5-.5 1.2-.5 1.2.2 1.2.5Z"
        />
        <path
          class="cls-80"
          d="M46.7 20.2c0 .3-.5.5-1.2.5s-1.2-.2-1.2-.5.5-.5 1.2-.5 1.2.2 1.2.5Z"
        />
        <path
          class="cls-178"
          d="M46.6 20.2c0 .3-.5.5-1.2.5s-1.2-.2-1.2-.5.5-.5 1.2-.5 1.2.2 1.2.5Z"
        />
        <path
          class="cls-78"
          d="M46.6 20.2c0 .3-.5.5-1.2.5s-1.2-.2-1.2-.5.5-.5 1.2-.5 1.2.2 1.2.5Z"
        />
        <path
          class="cls-364"
          d="M46.6 20.2c0 .3-.5.5-1.2.5s-1.2-.2-1.2-.5.5-.5 1.2-.5 1.2.2 1.2.5Z"
        />
        <path
          class="cls-312"
          d="M46.6 20.2c0 .3-.5.5-1.1.5s-1.1-.2-1.1-.5.5-.5 1.1-.5 1.1.2 1.1.5Z"
        />
        <path
          class="cls-221"
          d="M46.6 20.2c0 .3-.5.5-1.1.5s-1.1-.2-1.1-.5.5-.5 1.1-.5 1.1.2 1.1.5Z"
        />
        <path
          class="cls-192"
          d="M46.6 20.2c0 .3-.5.5-1.1.5s-1.1-.2-1.1-.5.5-.5 1.1-.5 1.1.2 1.1.5Z"
        />
        <path
          class="cls-62"
          d="M46.6 20.2c0 .3-.5.5-1.1.5s-1.1-.2-1.1-.5.5-.5 1.1-.5 1.1.2 1.1.5Z"
        />
        <path
          class="cls-291"
          d="M46.6 20.2c0 .3-.5.5-1.1.5s-1.1-.2-1.1-.5.5-.5 1.1-.5 1.1.2 1.1.5Z"
        />
        <path
          class="cls-358"
          d="M46.6 20.2c0 .3-.5.5-1.1.5s-1.1-.2-1.1-.5.5-.5 1.1-.5 1.1.2 1.1.5Z"
        />
        <path
          class="cls-322"
          d="M46.5 20.2c0 .3-.5.5-1.1.5s-1.1-.2-1.1-.5.5-.5 1.1-.5 1.1.2 1.1.5Z"
        />
        <path
          class="cls-110"
          d="M46.5 20.2c0 .3-.5.5-1.1.5s-1.1-.2-1.1-.5.5-.5 1.1-.5 1.1.2 1.1.5Z"
        />
        <path
          class="cls-272"
          d="M46.5 20.1c0 .3-.5.5-1.1.5s-1.1-.2-1.1-.5.5-.5 1.1-.5 1.1.2 1.1.5Z"
        />
        <path
          class="cls-301"
          d="M46.5 20.1c0 .2-.5.5-1.1.5s-1.1-.2-1.1-.5.5-.5 1.1-.5 1.1.2 1.1.5Z"
        />
        <path
          class="cls-71"
          d="M46.5 20.1c0 .2-.5.4-1 .4s-1-.2-1-.4.5-.4 1-.4 1 .2 1 .4Z"
        />
        <path
          class="cls-26"
          d="M46.4 20.1c0 .2-.5.4-1 .4s-1-.2-1-.4.5-.4 1-.4 1 .2 1 .4Z"
        />
        <path
          class="cls-374"
          d="M46.4 20.1c0 .2-.5.4-1 .4s-1-.2-1-.4.5-.4 1-.4 1 .2 1 .4Z"
        />
        <path
          class="cls-242"
          d="M46.4 20.1c0 .2-.5.4-1 .4s-1-.2-1-.4.5-.4 1-.4 1 .2 1 .4Z"
        />
        <path
          class="cls-324"
          d="M46.4 20.1c0 .2-.4.4-1 .4s-1-.2-1-.4.4-.4 1-.4 1 .2 1 .4Z"
        />
        <path
          class="cls-337"
          d="M46.4 20.1c0 .2-.4.4-1 .4s-1-.2-1-.4.4-.4 1-.4 1 .2 1 .4Z"
        />
        <path
          class="cls-292"
          d="M46.4 20.1c0 .2-.4.4-1 .4s-1-.2-1-.4.4-.4 1-.4 1 .2 1 .4Z"
        />
        <path
          class="cls-44"
          d="M46.3 20.1c0 .2-.4.4-1 .4s-1-.2-1-.4.4-.4 1-.4 1 .2 1 .4Z"
        />
        <path
          class="cls-237"
          d="M46.3 20.1c0 .2-.4.4-1 .4s-1-.2-1-.4.4-.4 1-.4 1 .2 1 .4Z"
        />
        <path
          class="cls-349"
          d="M46.3 20.1c0 .2-.4.4-.9.4s-.9-.2-.9-.4.4-.4.9-.4.9.2.9.4Z"
        />
        <path
          class="cls-244"
          d="M46.3 20.1c0 .2-.4.4-.9.4s-.9-.2-.9-.4.4-.4.9-.4.9.2.9.4Z"
        />
        <path
          class="cls-2"
          d="M46.3 20.1c0 .2-.4.4-.9.4s-.9-.2-.9-.4.4-.4.9-.4.9.2.9.4Z"
        />
        <path
          class="cls-313"
          d="M46.2 20.1c0 .2-.4.4-.9.4s-.9-.2-.9-.4.4-.4.9-.4.9.2.9.4Z"
        />
        <path
          class="cls-357"
          d="M46.2 20.1c0 .2-.4.4-.9.4s-.9-.2-.9-.4.4-.4.9-.4.9.2.9.4Z"
        />
        <path
          class="cls-164"
          d="M46.2 20.1c0 .2-.4.3-.9.3s-.9-.2-.9-.3.4-.3.9-.3.9.2.9.3Z"
        />
        <path
          class="cls-68"
          d="M46.2 20.1c0 .2-.4.3-.8.3s-.8-.2-.8-.3.4-.3.8-.3.8.2.8.3Z"
        />
        <path
          class="cls-393"
          d="M46.2 20.1c0 .2-.4.3-.8.3s-.8-.1-.8-.3.4-.3.8-.3.8.1.8.3Z"
        />
        <path
          class="cls-409"
          d="M46.1 20.1c0 .2-.4.3-.8.3s-.8-.1-.8-.3.4-.3.8-.3.8.1.8.3Z"
        />
        <path
          class="cls-407"
          d="M46.1 20.1c0 .2-.3.3-.8.3s-.8-.1-.8-.3.3-.3.8-.3.8.1.8.3Z"
        />
        <path
          class="cls-294"
          d="M46.1 20.1c0 .2-.3.3-.8.3s-.8-.1-.8-.3.3-.3.8-.3.8.1.8.3Z"
        />
        <path
          class="cls-235"
          d="M46.1 20.1c0 .2-.3.3-.7.3s-.7-.1-.7-.3.3-.3.7-.3.7.1.7.3Z"
        />
        <path
          class="cls-163"
          d="M46.1 20.1c0 .2-.3.3-.7.3s-.7-.1-.7-.3.3-.3.7-.3.7.1.7.3Z"
        />
        <path
          class="cls-327"
          d="M46 20.1c0 .2-.3.3-.7.3s-.7-.1-.7-.3.3-.3.7-.3.7.1.7.3Z"
        />
        <path
          class="cls-300"
          d="M46 20.1c0 .1-.3.3-.7.3s-.7-.1-.7-.3.3-.3.7-.3.7.1.7.3Z"
        />
        <path
          class="cls-168"
          d="M46 20.1c0 .1-.3.3-.7.3s-.7-.1-.7-.3.3-.3.7-.3.7.1.7.3Z"
        />
        <path
          class="cls-281"
          d="M46 20.1c0 .1-.3.3-.6.3s-.6-.1-.6-.3.3-.3.6-.3.6.1.6.3Z"
        />
        <path
          class="cls-63"
          d="M46 20.1c0 .1-.3.2-.6.2s-.6-.1-.6-.2.3-.2.6-.2.6.1.6.2Z"
        />
        <path
          class="cls-328"
          d="M45.9 20.1c0 .1-.3.2-.6.2s-.6-.1-.6-.2.3-.2.6-.2.6.1.6.2Z"
        />
        <path
          class="cls-39"
          d="M45.9 20.1c0 .1-.3.2-.6.2s-.6-.1-.6-.2.3-.2.6-.2.6.1.6.2Z"
        />
        <path
          class="cls-413"
          d="M45.9 20.1c0 .1-.3.2-.6.2s-.6 0-.6-.2.3-.2.6-.2.6 0 .6.2Z"
        />
        <path
          class="cls-112"
          d="M45.9 20.1c0 .1-.2.2-.5.2s-.5 0-.5-.2.2-.2.5-.2.5 0 .5.2Z"
        />
        <path
          class="cls-384"
          d="M45.9 20.1c0 .1-.2.2-.5.2s-.5 0-.5-.2.2-.2.5-.2.5 0 .5.2Z"
        />
        <path
          class="cls-236"
          d="M45.8 20.1c0 .1-.2.2-.5.2s-.5 0-.5-.2.2-.2.5-.2.5 0 .5.2Z"
        />
        <path
          class="cls-241"
          d="M45.8 20.1c0 .1-.2.2-.5.2s-.5 0-.5-.2.2-.2.5-.2.5 0 .5.2Z"
        />
        <path
          class="cls-220"
          d="M45.8 20s-.2.2-.5.2-.5 0-.5-.2.2-.2.5-.2.5 0 .5.2Z"
        />
        <path
          class="cls-240"
          d="M45.8 20s-.2.2-.5.2-.5 0-.5-.2.2-.2.5-.2.5 0 .5.2Z"
        />
        <path
          class="cls-303"
          d="M45.8 20s-.2.2-.5.2-.5 0-.5-.2.2-.2.5-.2.5 0 .5.2Z"
        />
        <path
          class="cls-209"
          d="M45.8 20s-.2.2-.4.2-.4 0-.4-.2.2-.2.4-.2.4 0 .4.2Z"
        />
        <path
          class="cls-69"
          d="M45.8 20s-.2.2-.4.2-.4 0-.4-.2.2-.2.4-.2.4 0 .4.2Z"
        />
        <path
          class="cls-177"
          d="M45.8 20s-.2.2-.4.2-.4 0-.4-.2.2-.2.4-.2.4 0 .4.2Z"
        />
        <path
          class="cls-120"
          d="M45.8 20s-.2.1-.4.1-.4 0-.4-.1.2-.1.4-.1.4 0 .4.1Z"
        />
        <path
          class="cls-109"
          d="M45.7 20s-.2.1-.4.1-.4 0-.4-.1.2-.1.4-.1.4 0 .4.1Z"
        />
        <path
          class="cls-31"
          d="M45.7 20s-.2.1-.4.1-.4 0-.4-.1.2-.1.4-.1.4 0 .4.1Z"
        />
        <path
          class="cls-19"
          d="M45.7 20s-.2.1-.4.1-.4 0-.4-.1.2-.1.4-.1.4 0 .4.1Z"
        />
        <path
          class="cls-176"
          d="M45.7 20s-.2.1-.4.1-.4 0-.4-.1.2-.1.4-.1.4 0 .4.1Z"
        />
        <path
          class="cls-200"
          d="M45.7 20s-.2.1-.4.1-.4 0-.4-.1.2-.1.4-.1.4 0 .4.1Z"
        />
        <path
          class="cls-233"
          d="M45.7 20s-.2.1-.3.1-.3 0-.3-.1.2-.1.3-.1.3 0 .3.1Z"
        />
        <path
          class="cls-224"
          d="M45.7 20s-.1.1-.3.1-.3 0-.3-.1.1-.1.3-.1.3 0 .3.1Z"
        />
        <path
          class="cls-362"
          d="M45.7 20s-.1.1-.3.1-.3 0-.3-.1.1-.1.3-.1.3 0 .3.1Z"
        />
        <path
          class="cls-378"
          d="M45.7 20s-.1.1-.3.1-.3 0-.3-.1.1-.1.3-.1.3 0 .3.1Z"
        />
        <path class="cls-1" d="M45.6 20H45h.6Z" />
        <path class="cls-11" d="M45.6 20H45h.6Z" />
        <path class="cls-8" d="M45.6 20H45h.6Z" />
        <path class="cls-107" d="M45.6 20H45h.6Z" />
        <path
          d="M41.8 13.9h1.5l-.9.9v.4h.4l.8-.6v2.7l-.5-.6c-.4-.4-.8-.3-.8.2s.7 1.3 1.4 1.3c1.2 0 1.6-.9 1.8-1.2.2-.4.2-.9-.4-.9s-.5.6-.5.6c-.3-.6-.4-.9-.4-1.1s0-.9.7-.9.8.5.8.5c-.2-.6-.2-.8-.2-1.1 0-.6.4-1.1.7-1.4.2-.3.4-.3.4-.3s.2.3.3.4c.1.3.5.7.3 1.4 0 .5-.4 1-.4 1 .4-.4.5-.4.8-.4s.6.4.4 1c-.2.7-.7 1-.7 1s0-.6-.3-.6c-.5 0-.6.5-.5.8 0 .4.7 1.1 1.4 1.1s.7-.1.9-.4c.2-.2.3-.4.1-.5-.2-.2-.7.3-.7.3l.7-2.5.2.7c0 .2.2.4.4.3.2 0 .2-.3.1-.5 0-.1-.3-1.1-.3-1.1h.1l1.2.4s-.5 1-.9 2c-.2.6-.4 1.1-.5 1.4 0 0-.5.3-.6.4-.1.1-.1.3 0 .3h.4c.2 0 .3.1.3.3s-.1.3-.3.3H34.6c-.2 0-.3-.1-.3-.3s.1-.3.3-.3h.4c.2 0 .2-.2 0-.3l-.6-.4c0-.3-.3-.8-.5-1.4-.4-.9-.9-2-.9-2l1.2-.4h.1s-.3.9-.3 1.1c0 .1 0 .4.1.5.2 0 .4-.1.4-.3l.2-.6.7 2.4s-.5-.5-.7-.3c-.1.1 0 .3.1.5.2.2.7.4.9.4.8 0 1.3-.7 1.4-1.1 0-.3 0-.8-.5-.8s-.3.6-.3.6-.5-.3-.7-1c-.2-.7.2-1 .4-1s.4 0 .8.4c0 0-.3-.5-.4-1-.1-.7.2-1.2.3-1.4 0-.2.3-.4.3-.4s.1 0 .4.3c.3.3.7.8.7 1.4s0 .5-.2 1.1c0 0 .2-.5.8-.5s.7.7.7.9 0 .6-.4 1.1c0 0 0-.6-.5-.6s-.6.5-.4.9c.2.3.6 1.2 1.8 1.2s1.4-.6 1.4-1.3-.5-.6-.8-.2l-.5.6v-2.7l.8.6h.4v-.4l-.9-.9h1.5Z"
          style="fill: url(#linear-gradient-24); stroke-width: 0"
        />
        <g class="cls-528">
          <path
            class="cls-377"
            d="M36.2 19s-.2 0-.2-.2v-.1s.5-.4.8-.7c.3-.3.6-.7.6-.7h.2s.4.4.8.7c.4.4.9.7.9.7v.2c0 .2 0 .2-.2.2h-3.3Z"
          />
        </g>
        <g class="cls-529">
          <path
            class="cls-258"
            d="M36.3 18.9s-.2 0-.2-.2v-.1s.5-.3.8-.7c.3-.3.6-.7.6-.7h.2s.4.4.8.7c.4.3.9.7.9.7v.2c0 .2 0 .2-.2.2H36Z"
          />
        </g>
        <g class="cls-533">
          <path
            class="cls-161"
            d="M36.3 18.9s-.2 0-.2-.2v-.1s.4-.3.8-.7c.3-.3.6-.7.6-.7h.2s.4.4.8.7c.4.3.8.6.9.6v.2c0 .2 0 .2-.2.2h-3.1Z"
          />
        </g>
        <g class="cls-537">
          <path
            class="cls-382"
            d="M36.3 18.9s-.1 0-.1-.2v-.1l.8-.6c.3-.3.5-.6.6-.7h.2s.4.4.8.7c.4.3.8.6.9.6v.1c0 .1 0 .2-.1.2h-3Z"
          />
        </g>
        <g class="cls-544">
          <path
            class="cls-316"
            d="M36.4 18.9s-.1 0-.1-.2v-.1s.4-.3.7-.6c.3-.3.5-.6.5-.6h.2s.4.3.7.6l.8.6v.1c0 .1 0 .2-.1.2h-3Z"
          />
        </g>
        <g class="cls-543">
          <path
            class="cls-282"
            d="M36.4 18.9s-.1 0-.1-.1v-.1s.4-.3.7-.6c.3-.3.5-.6.5-.6h.2s.4.3.7.6l.8.6v.1c0 .1 0 .1-.1.1h-2.9Z"
          />
        </g>
        <g class="cls-540">
          <path
            class="cls-160"
            d="M36.5 18.8s-.1 0-.1-.1v-.1s.4-.3.7-.6c.3-.3.5-.6.5-.6h.2s.3.3.7.6c.4.3.8.5.8.6v.1c0 .1 0 .1-.1.1h-2.8Z"
          />
        </g>
        <g class="cls-554">
          <path
            class="cls-197"
            d="M36.5 18.8s-.1 0-.1-.1v-.1c0-.1.4-.3.7-.6.3-.3.5-.6.5-.6h.2s.3.3.7.6c.4.3.7.5.8.5v.1c0 .1 0 .1-.1.1h-2.7Z"
          />
        </g>
        <g class="cls-551">
          <path
            class="cls-329"
            d="M36.5 18.8s-.1 0-.1-.1v-.1c0-.1.4-.3.7-.5.3-.2.5-.5.5-.5h.2s.3.3.7.5c.3.3.7.5.7.5v.1c0 .1 0 .1-.1.1h-2.6Z"
          />
        </g>
        <g class="cls-548">
          <path
            class="cls-346"
            d="M36.6 18.8s-.1 0-.1-.1.4-.3.6-.5c.3-.2.5-.5.5-.5h.2s.3.3.6.5c.3.3.7.5.7.5v.1c0 .1 0 .1-.1.1h-2.6Z"
          />
        </g>
        <g class="cls-547">
          <path
            class="cls-170"
            d="M36.6 18.8s-.1 0-.1-.1.4-.2.6-.5c.2-.2.4-.5.5-.5h.2s.3.3.6.5.7.5.7.5v.1c0 .1 0 .1-.1.1h-2.5Z"
          />
        </g>
        <path
          class="cls-67"
          d="M36.7 18.7s-.1 0-.1-.1c0 0 .3-.2.6-.5.2-.2.4-.5.4-.5h.2s.3.3.6.5.6.4.7.5v.1c0 .1 0 .1-.1.1h-2.4Z"
        />
        <path
          class="cls-336"
          d="M37.2 17c0-.3 0-.8-.5-.8s-.3.6-.3.6-.5-.3-.7-1c-.2-.7.2-1 .4-1s.4 0 .8.4c0 0-.3-.5-.4-1-.1-.7.2-1.2.3-1.4 0-.2.3-.4.3-.4s.1 0 .4.3c.3.3.7.8.7 1.4s0 .5-.2 1.1c0 0 .2-.5.8-.5s.7.7.7.9 0 .6-.4 1.1c0 0 0-.6-.5-.6s-.6.5-.4.9"
        />
        <path
          class="cls-402"
          d="M38.3 16.9c-.2-.3-.2-.6 0-.8 0 0 .2-.1.4-.1h.2c.3.1.4.5.4.6.3-.5.3-.9.3-1.1 0-.2-.1-.9-.7-.9s-.6.2-.7.4c0-.6.2-.8.1-1.1 0-.6-.4-1.1-.7-1.4s-.3-.3-.4-.3-.2.3-.3.4c0 .1-.1.3-.2.4 0 .2-.1.3-.1.5v.5c0 .4.3.8.3 1h-.1c-.3-.3-.5-.3-.7-.3s-.6.3-.4 1c.2.6.6.8.6.9 0 0 0-.6.3-.6.2 0 .3 0 .4.2.1.2.1.5 0 .6"
        />
        <path
          class="cls-415"
          d="M38.3 16.9c-.2-.3-.2-.6 0-.8l.4-.2c.2-.1.1 0 .2 0 .3.1.4.5.4.5.3-.5.3-.9.3-1.1 0-.2-.1-.8-.6-.8s-.6.2-.8.4c0-.6.1-.8.1-1.1 0-.6-.4-1.1-.7-1.4s-.3-.3-.3-.2-.2.2-.3.4c0 .1-.1.3-.2.4 0 .2-.1.3-.1.5v.5c0 .4.3.8.3 1h-.1c-.3-.3-.5-.3-.7-.3s-.6.3-.4 1c.2.6.6.8.6.8s0-.6.3-.6c.2 0 .3 0 .4.2.1.2.1.5 0 .7"
        />
        <path
          class="cls-83"
          d="M38.3 16.9c-.2-.3-.2-.6 0-.8 0 0 .2-.2.4-.2h.2c.3 0 .4.5.4.5.2-.5.3-.8.3-1.1 0-.2-.1-.8-.6-.8s-.6.2-.8.4c0-.6.1-.8.1-1.1 0-.6-.4-1.2-.7-1.4l-.3-.2s-.2.2-.2.4c0 .1-.1.3-.2.5 0 .2-.1.3-.1.5v.5c0 .4.3.8.3 1H37c-.3-.3-.5-.3-.7-.3s-.6.3-.4 1c.2.6.6.8.6.8s0-.6.3-.6c.2 0 .3 0 .4.2.1.2.1.5 0 .7"
        />
        <path
          class="cls-216"
          d="M38.3 16.9c-.2-.3-.2-.6 0-.8 0 0 .2-.2.4-.2h.2c.3 0 .4.5.4.5.2-.4.3-.8.3-1 0-.2-.1-.8-.6-.8s-.6.2-.8.4v-1.1c0-.6-.4-1.2-.7-1.5s-.3-.2-.3-.2-.2.2-.2.4c0 .1-.1.3-.2.5 0 .2-.1.3-.1.5v.5c0 .5.3.9.3 1h-.1c-.3-.3-.5-.3-.7-.3s-.5.3-.4.9c.2.6.6.8.6.8s0-.6.3-.6c.2 0 .3 0 .4.2.1.2.1.5 0 .7"
        />
        <path
          class="cls-284"
          d="M38.2 16.9c-.2-.3-.2-.6 0-.8 0 0 .2-.2.4-.2h.2c.3 0 .4.4.4.5.2-.4.3-.8.2-1 0-.3-.1-.8-.6-.8s-.7.2-.8.4v-1.1c0-.6-.4-1.2-.7-1.5s-.2-.2-.3-.1-.1.2-.2.3c0 .1-.1.3-.2.5 0 .2-.1.3-.1.5v.5c0 .5.3.9.3 1h-.1c-.3-.3-.5-.3-.7-.3s-.5.3-.4.9c.2.5.5.8.6.8 0 0 0-.6.3-.6.2 0 .3 0 .4.2.1.2.1.5 0 .7"
        />
        <path
          class="cls-289"
          d="M38.2 16.9c-.2-.3-.2-.6 0-.8 0 0 .2-.2.4-.2h.2c.3 0 .4.4.5.5.2-.4.2-.7.2-1 0-.3-.1-.8-.6-.8s-.7.2-.8.4v-1.1c0-.7-.5-1.3-.7-1.5s-.2-.2-.2-.1-.1.2-.2.3c0 .1-.2.3-.2.5s-.1.4-.1.5v.5c0 .5.3.9.3 1h-.1c-.3-.3-.6-.3-.7-.3s-.5.3-.4.9c.2.5.5.7.6.8 0 0 0-.6.3-.6.2 0 .3 0 .4.2.1.2.1.5 0 .7"
        />
        <path
          class="cls-391"
          d="M38.2 17c-.2-.3-.2-.6 0-.8 0 0 .2-.2.4-.2h.2c.3 0 .4.4.5.5.2-.3.2-.7.2-.9 0-.3-.1-.7-.6-.7s-.7.2-.8.3v-1.1c0-.7-.5-1.3-.7-1.5s-.2-.1-.2 0-.1.2-.2.3c0 .1-.2.3-.2.5s-.1.4-.1.6v.5c0 .5.3.9.3 1h-.1c-.3-.2-.6-.3-.7-.2-.2 0-.5.3-.4.9.2.5.5.7.5.8 0 0 0-.6.4-.6.2 0 .3 0 .4.2.1.2.1.5 0 .7"
        />
        <path
          class="cls-173"
          d="M38.2 17c-.2-.3-.2-.6 0-.8 0 0 .2-.2.4-.2h.2c.3 0 .4.4.5.5.2-.3.2-.6.2-.9 0-.3-.1-.7-.5-.7s-.7.2-.8.3v-1.1c-.1-.7-.5-1.3-.7-1.5s-.2 0-.2 0-.1.2-.2.3c0 .1-.2.3-.2.5s-.1.4-.1.6v.5c0 .5.3.9.3 1H37c-.3-.2-.6-.2-.7-.2-.2 0-.5.3-.3.8s.5.7.5.7 0-.6.4-.6c.2 0 .3 0 .4.2.2.2.1.5 0 .7"
        />
        <path
          class="cls-262"
          d="M38.2 17c-.2-.3-.2-.6 0-.8 0 0 .2-.2.4-.2h.2c.3 0 .4.3.5.5.1-.3.2-.6.2-.9 0-.3-.1-.7-.5-.7s-.7.2-.8.3v-1.1c-.1-.7-.5-1.3-.7-1.6s-.1 0-.2 0-.1.2-.2.3c0 .1-.2.3-.2.5s-.1.4-.1.6v.5c0 .5.3.9.3 1H37c-.3-.2-.6-.2-.7-.2-.2 0-.5.3-.3.8.1.5.4.7.5.7 0 0 0-.6.4-.6.2 0 .3 0 .4.2.2.2.1.5 0 .7"
        />
        <path
          class="cls-386"
          d="M38.2 17c-.2-.3-.2-.6-.1-.8 0-.1.2-.2.4-.2h.2c.3 0 .4.3.5.5.1-.2.2-.6.1-.9 0-.3-.1-.7-.5-.7s-.7.2-.8.3v-1.1c-.1-.7-.5-1.4-.7-1.6s-.1 0-.2 0 0 .2-.1.2c0 .1-.2.3-.2.5s-.1.4-.1.6v.5c0 .5.3.9.3 1h-.1c-.3-.2-.6-.2-.8-.2-.2 0-.4.3-.3.8.1.5.4.6.5.7 0 0 0-.6.4-.6.2 0 .3.1.4.2.2.2.1.5 0 .7"
        />
        <path
          class="cls-293"
          d="M38.2 17c-.2-.3-.3-.6-.1-.8 0-.1.1-.2.4-.2h.2c.3 0 .4.3.5.5 0-.2.1-.5.1-.8 0-.3-.1-.6-.5-.6s-.7.2-.8.3v-1.2c-.2-.7-.5-1.4-.7-1.6s0 0-.1 0 0 .1-.1.2c0 .1-.2.3-.2.5s-.1.4-.1.6v.5c0 .5.3.9.3 1H37c-.3-.2-.6-.2-.8-.2-.2 0-.4.3-.3.8.1.5.4.6.5.7 0-.1 0-.6.4-.6.2 0 .3.1.4.2.2.2.1.5 0 .7"
        />
        <path
          class="cls-270"
          d="M37.3 15.6s.1-.2.1-.5v-.4c0-.2-.1-.5-.2-.8 0-.5 0-1.1-.1-1.1s-.3.6-.4.9v1.1c0 .5.3.9.5.9Z"
        />
        <path
          class="cls-319"
          d="M37.3 15.6s.1-.2.1-.4v-.4c0-.2-.1-.5-.1-.8 0-.5 0-1.1-.1-1.1s-.3.5-.3.8 0 .6.1 1 .3.8.4.8Z"
        />
        <path
          class="cls-66"
          d="M37.2 15.5s.1-.2.1-.4v-.4c0-.2-.1-.4-.1-.7 0-.5 0-1-.1-1s-.3.5-.3.8 0 .6.1 1 .2.7.4.7Z"
        />
        <path
          class="cls-24"
          d="M37.2 15.5v-.8c0-.1 0-.4-.1-.7v-1c-.1 0-.2.5-.3.7s0 .6.1 1 .2.7.4.6Z"
        />
        <path
          class="cls-156"
          d="M37.2 15.4v-.7c0-.1 0-.4-.1-.6v-.9c-.1 0-.2.4-.3.7s0 .6.2 1 .2.6.3.6Z"
        />
        <path
          class="cls-295"
          d="M37.2 15.3v-.7c0-.1 0-.3-.1-.6v-.8s-.2.4-.2.7 0 .6.2 1 .2.5.3.5Z"
        />
        <path
          class="cls-255"
          d="M37.2 15.3v-.2c0-.2 0-.3-.1-.4s0-.3-.1-.6v-.8s-.2.4-.2.6 0 .6.2.9.2.4.3.4Z"
        />
        <path
          class="cls-79"
          d="M37.2 15.2V15c0-.2 0-.3-.1-.4s0-.3-.1-.5v-.7s-.2.3-.2.6.1.6.2.9.1.4.2.3Z"
        />
        <path
          class="cls-40"
          d="M37.2 15.2V15c0-.2 0-.3-.1-.4s0-.3-.1-.5v-.7s-.1.3-.1.6c0 .2.1.6.2.9s.1.3.2.3Z"
        />
        <path
          class="cls-174"
          d="M37.2 15.1V15c0-.2 0-.3-.1-.4s0-.2-.1-.4v-.6s-.1.3-.1.5.2.6.2.9.1.2.2.2Z"
        />
        <path
          class="cls-205"
          d="M36.9 13.6v.5c0 .3.2.6.3.9 0 .1 0 .1.1.1V15c0-.2 0-.3-.1-.4v-.9Z"
        />
        <path
          class="cls-270"
          d="M36.2 15.9c.2.4-.2.6-.3.2s0-.7 0-.7.1.2.3.5Z"
        />
        <path class="cls-319" d="M36.2 16c.2.4-.2.6-.3.2s0-.6 0-.7.1.2.3.5Z" />
        <path class="cls-66" d="M36.1 16c.2.4-.2.5-.3.2s0-.6 0-.6.1.2.2.5Z" />
        <path class="cls-24" d="M36.1 16c.2.4-.1.5-.2.1s0-.6 0-.6l.2.4Z" />
        <path class="cls-156" d="M36.1 16c.2.3-.1.5-.2.1s0-.5 0-.5l.2.4Z" />
        <path class="cls-295" d="M36.1 16c.2.3-.1.4-.2.1s0-.5 0-.5 0 .2.2.4Z" />
        <path class="cls-255" d="M36.1 16c.1.3 0 .4-.2 0s0-.5 0-.5 0 .2.2.4Z" />
        <path class="cls-79" d="M36.1 16c.1.2 0 .4-.2 0s0-.4 0-.4 0 .2.2.3Z" />
        <path class="cls-40" d="M36.1 16c.1.2 0 .4-.1 0s0-.4 0-.4 0 .2.2.3Z" />
        <path class="cls-174" d="M36.1 16c.1.2 0 .3-.1 0s0-.4 0-.4 0 .2.2.3Z" />
        <path
          class="cls-205"
          d="M36.1 16.1c0-.1-.1-.3-.1-.3v.3c0 .2.2.1 0 0Z"
        />
        <path
          class="cls-270"
          d="M36.3 16.1s.2-.3.6-.3.8.2.9.7-.2.3-.2.3-.1-.2-.2-.3c-.1-.2-.3-.5-.7-.4s-.3 0-.3 0Z"
        />
        <path
          class="cls-319"
          d="M36.3 16.1s.2-.3.6-.3.7.3.8.7-.2.3-.2.3-.1-.1-.2-.3c0-.2-.3-.5-.7-.4s-.3 0-.3 0Z"
        />
        <path
          class="cls-66"
          d="M36.3 16s.2-.2.5-.2.7.3.8.6-.1.3-.2.3-.1-.1-.2-.2c0-.2-.3-.5-.6-.4s-.3 0-.3 0Z"
        />
        <path
          class="cls-24"
          d="M36.3 16s.2-.2.5-.2.7.3.8.6-.1.2-.2.2-.1-.1-.2-.2c0-.2-.3-.5-.6-.4s-.3 0-.3 0Z"
        />
        <path
          class="cls-156"
          d="M36.4 16s.2-.2.5-.2.7.3.8.6-.1.2-.2.2-.1 0-.2-.2c0-.2-.3-.5-.6-.5h-.3Z"
        />
        <path
          class="cls-295"
          d="M36.4 16s.2-.2.5-.2.6.3.8.6 0 .2-.1.2-.1 0-.2-.2c0-.2-.3-.5-.6-.5h-.3Z"
        />
        <path
          class="cls-255"
          d="M36.4 16s.2-.2.5-.2.6.3.7.6 0 .2-.1.2-.1 0-.1-.2-.3-.5-.6-.5h-.3Z"
        />
        <path
          class="cls-79"
          d="M36.4 16s.2-.1.4-.1.6.3.7.5 0 .2 0 .2l-.1-.1c0-.2-.3-.5-.6-.5h-.3Z"
        />
        <path
          class="cls-40"
          d="M36.4 16s.2-.1.4-.1.6.3.7.5 0 .1 0 .2 0 0-.1-.1c0-.1-.3-.5-.6-.5h-.3Z"
        />
        <path
          class="cls-174"
          d="M36.5 16h.4c.2 0 .6.3.7.5s0 .1 0 .1l-.1-.1c0-.1-.2-.5-.6-.5h-.3Z"
        />
        <path
          class="cls-205"
          d="M36.5 16h.4c.3 0 .5.4.6.5v.1h-.1c0-.1-.2-.5-.5-.5h-.3Z"
        />
        <path
          class="cls-270"
          d="M38 16.1v-.2s.2-.2.3-.2H38.9c.1 0 .1 0 .2.2v.3s-.2-.1-.3-.1h-.5c-.1 0-.2.1-.2 0Z"
        />
        <path
          class="cls-319"
          d="M38 16.1v-.2s.2-.2.3-.2H38.9s.1 0 .2.2v.2s-.2 0-.3-.1h-.5c-.1 0-.2.1-.2 0Z"
        />
        <path
          class="cls-66"
          d="M38 16v-.2s.1-.2.3-.2h.5s.1 0 .2.1v.2s-.2 0-.3-.1h-.5c-.1 0-.2.1-.2 0Z"
        />
        <path
          class="cls-24"
          d="M38 16v-.1l.2-.2c.1-.1.1 0 .2 0H38.7s.1 0 .1.1v.2h-.3c-.1 0 0 0 0 0H37.9Z"
        />
        <path
          class="cls-156"
          d="M38 16v-.1l.2-.2c.1-.1.1 0 .2 0H38.7s.1 0 .1.1v.2c0 .1-.2 0-.3 0H38Z"
        />
        <path
          class="cls-295"
          d="M38.1 16v-.1l.2-.2c.1-.1 0 0 .1 0H38.7s.1 0 .1.1v.1h-.5c-.1 0 0 0 0 0h-.2Z"
        />
        <path
          class="cls-255"
          d="M38.1 15.9v-.1s.1-.1.2-.1h.4s.1 0 .1.1-.2 0-.2 0h-.3c-.1 0 0 0 0 0h-.2Z"
        />
        <path
          class="cls-79"
          d="M38.1 15.9s.1 0 .2-.1 0 0 .1 0H38.7h-.2c-.1 0 0 0 0 0h-.3c-.1 0 0 0 0 0h-.1Z"
        />
        <path class="cls-40" d="M38.1 15.9h.5-.2c-.1 0 0 0 0 0H38.1Z" />
        <path
          class="cls-174"
          d="M38.2 15.9h.5c.1 0 0 0 0 0H38.4c-.1 0 0 0 0 0H38.1Z"
        />
        <path class="cls-205" d="M38.6 15.7H38.9h-.7.3Z" />
        <path
          d="M34.6 18.8h.4c.2 0 .2-.2 0-.3l-.6-.4c0 .2.1.4.1.6Z"
          style="fill: url(#linear-gradient-25); stroke-width: 0"
        />
        <path
          class="cls-12"
          d="M36.5 18.6v.1h2.3v.2c0 .1-.1.2-.2.2h-2.5s-.2 0-.2-.2v-.2Z"
        />
        <path
          class="cls-365"
          d="M36.5 18.6v.1h2.3v.2c0 .1-.1.2-.2.2h-2.5s-.2 0-.2-.2v-.2Z"
        />
        <path
          class="cls-218"
          d="M36.5 18.6h2.3v.2c0 .1-.1.2-.2.2h-2.5s-.2 0-.2-.2v-.2Z"
        />
        <path
          class="cls-5"
          d="M36.5 18.6h2.3v.2s-.1.2-.2.2h-2.5s-.2 0-.2-.2v-.1Z"
        />
        <path
          class="cls-273"
          d="M36.5 18.6h2.3v.1s0 .2-.2.2h-2.5s-.2 0-.2-.2v-.1Z"
        />
        <path
          class="cls-266"
          d="M36.5 18.6h2.3v.1s0 .2-.2.2h-2.5s-.2 0-.2-.2v-.1Z"
        />
        <path
          class="cls-238"
          d="M36.5 18.6h2.3v.1s0 .2-.2.2h-2.5s-.2 0-.2-.2v-.1Z"
        />
        <path
          class="cls-82"
          d="M36.5 18.7h2.3v.1s0 .1-.2.1h-2.5s-.2 0-.2-.1v-.1Z"
        />
        <path
          class="cls-14"
          d="M36.5 18.7h2.2v.1s0 .1-.2.1H36s-.1 0-.2-.1v-.1Z"
        />
        <path class="cls-395" d="M36.5 18.7h2.2s0 .1-.2.1H36s-.1 0-.1-.1Z" />
        <path class="cls-350" d="M36.5 18.7h2.2s0 .1-.1.1h-2.5s-.1 0-.1-.1Z" />
        <path class="cls-389" d="M39.1 18.8h-2.5s-.1 0-.1-.1h2.4s0 .1-.1.1Z" />
        <g class="cls-528">
          <path
            class="cls-377"
            d="M47.3 19s.2 0 .2-.2v-.1s-.5-.4-.8-.7c-.3-.3-.6-.7-.6-.7h-.2s-.4.4-.8.7c-.4.4-.9.7-.9.7v.2c0 .2 0 .2.2.2h3.3Z"
          />
        </g>
        <g class="cls-529">
          <path
            class="cls-258"
            d="M47.3 18.9s.2 0 .2-.2v-.1s-.5-.3-.8-.7c-.3-.3-.6-.7-.6-.7h-.2s-.4.4-.8.7c-.4.3-.9.7-.9.7v.2c0 .2 0 .2.2.2h3.2Z"
          />
        </g>
        <g class="cls-533">
          <path
            class="cls-161"
            d="M47.3 18.9s.2 0 .2-.2v-.1s-.4-.3-.8-.7c-.3-.3-.6-.7-.6-.7h-.2c-.1 0-.4.4-.8.7-.4.3-.8.6-.9.6v.2c0 .2 0 .2.2.2h3.1Z"
          />
        </g>
        <g class="cls-537">
          <path
            class="cls-382"
            d="M47.2 18.9s.1 0 .1-.2v-.1l-.8-.6c-.3-.3-.5-.6-.6-.7h-.2c-.1 0-.4.4-.8.7-.4.3-.8.6-.9.6v.1c0 .1 0 .2.1.2h3Z"
          />
        </g>
        <g class="cls-544">
          <path
            class="cls-316"
            d="M47.2 18.9s.1 0 .1-.2v-.1c0-.1-.4-.3-.7-.6-.3-.3-.5-.6-.5-.6h-.2c-.1 0-.4.3-.7.6l-.8.6v.1c0 .1 0 .2.1.2h3Z"
          />
        </g>
        <g class="cls-543">
          <path
            class="cls-282"
            d="M47.1 18.9s.1 0 .1-.1v-.1c0-.1-.4-.3-.7-.6-.3-.3-.5-.6-.5-.6h-.2c-.1 0-.4.3-.7.6l-.8.6v.1c0 .1 0 .1.1.1h2.9Z"
          />
        </g>
        <g class="cls-540">
          <path
            class="cls-160"
            d="M47.1 18.8s.1 0 .1-.1v-.1c0-.1-.4-.3-.7-.6-.3-.3-.5-.6-.5-.6h-.2c-.1 0-.3.3-.7.6-.4.3-.8.5-.8.6v.1c0 .1 0 .1.1.1h2.8Z"
          />
        </g>
        <g class="cls-554">
          <path
            class="cls-197"
            d="M47.1 18.8s.1 0 .1-.1v-.1c0-.1-.4-.3-.7-.6-.3-.3-.5-.6-.5-.6h-.2c-.1 0-.3.3-.7.6-.4.3-.7.5-.8.5v.1c0 .1 0 .1.1.1h2.7Z"
          />
        </g>
        <g class="cls-551">
          <path
            class="cls-329"
            d="M47 18.8s.1 0 .1-.1v-.1c0-.1-.4-.3-.7-.5-.3-.2-.5-.5-.5-.5h-.2c-.1 0-.3.3-.7.5-.3.3-.7.5-.7.5v.1c0 .1 0 .1.1.1H47Z"
          />
        </g>
        <g class="cls-548">
          <path
            class="cls-346"
            d="M47 18.8s.1 0 .1-.1-.4-.3-.6-.5c-.3-.2-.5-.5-.5-.5h-.2c-.1 0-.3.3-.6.5-.3.3-.7.5-.7.5v.1c0 .1 0 .1.1.1h2.6Z"
          />
        </g>
        <g class="cls-547">
          <path
            class="cls-170"
            d="M46.9 18.8s.1 0 .1-.1-.4-.2-.6-.5c-.2-.2-.4-.5-.5-.5h-.2c-.1 0-.3.3-.6.5s-.7.5-.7.5v.1c0 .1 0 .1.1.1H47Z"
          />
        </g>
        <path
          class="cls-67"
          d="M46.9 18.7s.1 0 .1-.1c0 0-.3-.2-.6-.5-.2-.2-.4-.5-.4-.5h-.2s-.3.3-.6.5-.6.4-.7.5v.1c0 .1 0 .1.1.1H47Z"
        />
        <path
          class="cls-12"
          d="M44.3 18.6v.2c0 .1.1.2.2.2H47s.2 0 .2-.2v-.2c0-.1 0 0 0 0v.1h-2.3Z"
        />
        <path
          class="cls-365"
          d="M44.3 18.6v.2c0 .1.1.2.2.2H47s.2 0 .2-.2v-.2c0-.1 0 0 0 0v.1h-2.3Z"
        />
        <path
          class="cls-218"
          d="M44.3 18.6v.2c0 .1.1.2.2.2H47s.2 0 .2-.2v-.2c0-.1 0 0 0 0h-2.3Z"
        />
        <path
          class="cls-5"
          d="M44.3 18.6v.2s.1.2.2.2H47s.2 0 .2-.2v-.1h-2.3Z"
        />
        <path
          class="cls-273"
          d="M44.3 18.6v.1s0 .2.2.2H47s.2 0 .2-.2v-.1h-2.3Z"
        />
        <path
          class="cls-266"
          d="M44.3 18.6v.1s0 .2.2.2H47s.2 0 .2-.2v-.1h-2.3Z"
        />
        <path
          class="cls-238"
          d="M44.4 18.6v.1s0 .2.2.2h2.5s.2 0 .2-.2v-.1c0-.1 0 0 0 0H45Z"
        />
        <path
          class="cls-82"
          d="M44.4 18.6v.1s0 .1.2.1h2.5s.2 0 .2-.1v-.1c0-.1 0 0 0 0H45Z"
        />
        <path
          class="cls-14"
          d="M44.4 18.7v.1s0 .1.2.1h2.5s.1 0 .2-.1v-.1c0-.1 0 0 0 0h-2.2Z"
        />
        <path class="cls-395" d="M44.4 18.7s0 .1.2.1h2.5s.1 0 .1-.1H45Z" />
        <path class="cls-350" d="M44.4 18.7s0 .1.1.1H47s.1 0 .1-.1h-2.2Z" />
        <path class="cls-389" d="M44.5 18.8H47s.1 0 .1-.1h-2.4s0 .1.1.1Z" />
        <path
          class="cls-13"
          d="M41.8 14h-1.3s.6.5.8.8c0 0 .1.2 0 .3s-.2.3-.3.3c-.3 0-.5-.1-.6-.2h-.1V17l.4-.4c.1-.1.3-.2.5-.2.3 0 .3.4.3.4 0 .2 0 .7-.3 1-.1.2-.5.6-1.1.6-.4 0-.9-.3-1.2-.6-.3-.3-.5-.9-.5-.9h-1.1c0 .1 0 .6-.3.9-.2.2-.7.6-1.2.6s-.6 0-.9-.3c-.2-.1-.3-.5-.3-.7 0-.1.1-.2.1-.2-.1.2 0 .4.2.5.2.2.7.4.9.4.8 0 1.3-.7 1.4-1.1h1.1c.2.2.6 1.1 1.8 1.1s1.4-.6 1.4-1.3-.5-.6-.8-.2l-.5.6v-2.7l.8.6h.4v-.4l-.9-.9H42"
        />
        <path
          class="cls-77"
          d="M41.8 14h-1.3l.8.8s.1.2 0 .3-.2.3-.3.3c-.2 0-.5-.1-.6-.3h-.1v1.8l.4-.4c.1-.1.3-.2.5-.2.3 0 .3.4.3.4 0 .2 0 .7-.3 1-.1.2-.5.6-1.1.6-.4 0-.9-.3-1.2-.6-.3-.3-.5-.9-.5-.9h-1.1c0 .1 0 .6-.3.9-.2.2-.7.5-1.2.5s-.6 0-.8-.3c-.2-.1-.3-.5-.3-.6 0-.1.1-.2.1-.2-.1.2 0 .4.2.5.2.2.7.4.9.4.8 0 1.3-.7 1.4-1.1h1.1c.2.2.6 1.1 1.8 1.1s1.4-.6 1.4-1.3-.5-.6-.8-.2l-.5.6v-2.7l.8.6h.4v-.4l-.9-.9h1.5"
        />
        <path
          class="cls-309"
          d="M41.8 14h-1.4l.8.8s.1.2 0 .3-.2.3-.3.2c-.2 0-.4-.1-.6-.3h-.1v1.9l.4-.4c.1-.1.3-.3.5-.3.3 0 .3.4.3.4 0 .2 0 .7-.3 1-.2.2-.5.6-1.1.6-.5 0-1-.3-1.3-.6-.3-.3-.5-.8-.5-.9h-1.1c0 .1 0 .6-.4.9-.2.2-.7.5-1.2.5s-.6 0-.8-.3c-.2-.1-.3-.5-.3-.6 0-.1 0-.2.1-.2-.1.2 0 .4.2.5.2.2.7.4.9.4.8 0 1.3-.7 1.4-1.1h1.1c.2.2.6 1.1 1.8 1.1s1.4-.6 1.4-1.3-.5-.6-.8-.2l-.5.6v-2.7l.8.6h.4v-.4l-.9-.9h1.5"
        />
        <path
          class="cls-217"
          d="M41.8 14h-1.4l.8.8s.1.2 0 .4-.2.2-.4.2-.4-.2-.6-.3h-.1V17l.4-.4c.1-.1.3-.3.5-.3.3 0 .3.4.3.4 0 .2 0 .7-.3 1-.2.2-.5.6-1.1.5-.5 0-1-.3-1.3-.6-.3-.3-.5-.8-.5-.9H37c0 .2 0 .6-.4.9-.2.2-.7.5-1.1.5s-.6 0-.8-.3c-.2-.1-.3-.4-.3-.6 0-.2 0-.2.1-.2-.1.2 0 .4.2.5.2.2.7.4.9.4.8 0 1.3-.7 1.4-1.1h1.1c.2.2.6 1.1 1.8 1.1s1.4-.6 1.4-1.3-.5-.6-.8-.2l-.5.6v-2.7l.8.6h.4v-.4l-.9-.9h1.5"
        />
        <path
          class="cls-111"
          d="M41.8 14h-1.4l.8.8v.4c0 .2-.2.2-.4.2s-.4-.2-.6-.3h-.1V17l.4-.4c.1-.1.3-.3.5-.3.3 0 .3.4.3.4 0 .3-.1.7-.3 1-.2.2-.6.5-1.1.5-.5 0-1-.3-1.3-.6-.3-.3-.5-.8-.5-.9H37c0 .2 0 .6-.4.9-.2.2-.7.5-1.1.5s-.6 0-.8-.3c-.2-.1-.3-.4-.3-.6V17c-.1.2 0 .4.2.5.2.2.7.4.9.4.8 0 1.3-.7 1.4-1.1H38c.2.2.6 1.1 1.8 1.1s1.4-.6 1.4-1.3-.5-.6-.8-.2l-.5.6v-2.7l.8.6h.4v-.4l-.9-.9h1.5"
        />
        <path
          class="cls-325"
          d="M41.8 14h-1.4l.8.8v.4c0 .2-.2.2-.4.2s-.4-.2-.6-.3c0 0-.1 0-.1.1v1.9l.4-.4c.1-.1.3-.3.5-.3.3 0 .3.4.3.4 0 .3-.1.7-.3 1-.2.2-.6.5-1.1.5-.5 0-1-.3-1.3-.5-.3-.3-.5-.8-.5-.9H37c0 .2 0 .6-.4.9-.3.2-.7.5-1.1.5s-.6 0-.8-.3c-.2-.1-.3-.4-.3-.6v-.2c-.1.2 0 .4.2.5.2.2.7.4.9.4.8 0 1.3-.7 1.4-1.1H38c.2.2.6 1.1 1.8 1.1s1.4-.6 1.4-1.3-.5-.6-.8-.2l-.5.6v-2.7l.8.6h.4v-.4l-.9-.9h1.5"
        />
        <path
          class="cls-314"
          d="M41.8 14h-1.4l.8.8v.4c0 .2-.2.2-.4.2s-.4-.2-.6-.3c0 0-.1 0-.1.1v2s.2-.2.3-.4c.1-.1.3-.3.5-.3.3 0 .3.4.3.4 0 .3-.1.7-.3 1-.2.2-.6.5-1 .5-.6 0-1-.3-1.3-.5-.3-.3-.5-.8-.5-.9H37c0 .2-.1.6-.4.9-.3.3-.7.5-1.1.5s-.6 0-.8-.3c-.2-.1-.3-.4-.3-.5v-.2c-.1.2 0 .4.2.5.2.2.7.4.9.4.8 0 1.3-.7 1.4-1.1H38c.2.2.6 1.1 1.8 1.1s1.4-.6 1.4-1.3-.5-.6-.8-.2l-.5.6v-2.7l.8.6h.4v-.4l-.9-.9h1.5"
        />
        <path
          class="cls-285"
          d="M41.8 14h-1.4l.8.8v.4c0 .2-.2.2-.4.1l-.6-.3s-.1 0-.1.1v2s.2-.2.3-.4c.2-.2.3-.3.6-.3s.3.4.3.4c0 .3-.1.7-.3 1-.2.2-.6.5-1 .5-.6 0-1-.3-1.3-.5-.3-.3-.5-.8-.5-.9h-1.1c0 .2-.1.6-.4.9-.3.3-.7.5-1.1.5s-.6 0-.8-.3c-.2-.1-.3-.4-.3-.5v-.2c-.1.2 0 .4.2.5.2.2.7.4.9.4.8 0 1.3-.7 1.4-1.1h1.1c.2.2.6 1.1 1.8 1.1s1.4-.6 1.4-1.3-.5-.6-.8-.2l-.5.6v-2.7l.8.6h.4v-.4l-.9-.9h1.5"
        />
        <path
          class="cls-239"
          d="M41.8 14h-1.4l.8.8v.4c0 .2-.2.2-.4.1l-.6-.3s-.2 0-.2.2v2s.1-.2.3-.3c.2-.2.3-.3.6-.3s.3.4.3.4c0 .3-.2.7-.3.9-.3.3-.7.5-1 .5-.6 0-1-.3-1.3-.5-.3-.3-.5-.8-.5-.8H37c0 .2-.1.6-.4.9-.3.3-.7.5-1.1.5s-.6 0-.8-.3c-.2-.1-.3-.4-.3-.5v-.2c-.1.2 0 .4.2.5.2.2.7.4.9.4.8 0 1.3-.7 1.4-1.1H38c.2.2.6 1.1 1.8 1.1s1.4-.6 1.4-1.3-.5-.6-.8-.2l-.5.6v-2.7l.8.6h.4V15l-.9-.9h1.5"
        />
        <path
          class="cls-181"
          d="M41.8 14h-1.4l.8.8v.4c0 .1-.2.2-.4 0s-.4-.2-.5-.4c0 0-.2 0-.2.2v2s.1-.2.3-.3c.2-.2.3-.4.6-.4s.3.4.3.4c0 .3-.2.7-.4.9-.3.3-.7.5-1 .5-.6 0-1.1-.3-1.3-.5-.3-.3-.4-.7-.5-.8H37c0 .2-.1.6-.4.9-.3.3-.7.5-1.1.5s-.6 0-.8-.3c-.2-.1-.3-.4-.3-.5v-.2c-.1.2 0 .4.2.5.2.2.7.4.9.4.8 0 1.3-.7 1.4-1.1H38c.2.2.6 1.1 1.8 1.1s1.4-.6 1.4-1.3-.5-.6-.8-.2l-.5.6v-2.7l.8.6h.4v-.4l-.9-.9h1.5"
        />
        <path
          class="cls-372"
          d="M41.8 14h-1.4l.8.8c.1.1 0 .3 0 .4s-.2.2-.4 0-.4-.3-.5-.4c0 0-.2 0-.2.2v2.1s.1-.2.3-.3c.2-.2.3-.4.6-.4s.3.4.3.4c0 .3-.2.7-.4.9-.3.3-.7.5-1 .5-.7 0-1.1-.3-1.3-.5-.3-.3-.4-.7-.5-.8H37c0 .2-.1.6-.4.8-.3.3-.7.4-1.1.4s-.5 0-.8-.3c-.2-.1-.3-.3-.3-.5v-.2c-.1.2 0 .4.2.5.2.2.7.4.9.4.8 0 1.3-.7 1.4-1.1H38c.2.2.6 1.1 1.8 1.1s1.4-.6 1.4-1.3-.5-.6-.8-.2l-.5.6v-2.7l.8.6h.4v-.4l-.9-.9h1.5"
        />
        <path
          class="cls-106"
          d="M41.8 14h-1.4l.8.8c.1.1 0 .3 0 .4 0 0-.2.2-.4 0-.2-.1-.4-.3-.5-.4 0 0-.2.1-.2.2v2.1l.3-.3c.2-.2.3-.4.6-.4s.3.4.3.4c0 .3-.2.7-.4.9-.3.3-.8.4-1 .4-.7 0-1.1-.3-1.3-.5-.3-.3-.4-.7-.5-.8H37c0 .2-.1.6-.4.8-.3.3-.7.4-1.1.4s-.5 0-.8-.3c-.2-.1-.3-.3-.3-.4v-.2c-.1.2 0 .4.2.5.2.2.7.4.9.4.8 0 1.3-.7 1.4-1.1H38c.2.2.6 1.1 1.8 1.1s1.4-.6 1.4-1.3-.5-.6-.8-.2l-.5.6v-2.7l.8.6h.4v-.4l-.9-.9h1.5"
        />
        <g style="clip-path: url(#clippath-2)">
          <path class="cls-207" d="m35.5 17.5-.6.1-1.6-2.9 1.4-.5.8 3.3z" />
          <path class="cls-260" d="m35.5 17.5-.6.1-1.6-2.9 1.4-.5.8 3.3z" />
          <path class="cls-334" d="m35.5 17.5-.6.1-1.5-2.9 1.3-.5.8 3.3z" />
          <path class="cls-204" d="m35.5 17.5-.5.1-1.5-3 1.2-.4.8 3.3z" />
          <path class="cls-263" d="m35.5 17.5-.5.1-1.5-3 1.2-.4.8 3.3z" />
          <path class="cls-274" d="m35.5 17.5-.5.1-1.4-3 1.1-.4.8 3.3z" />
          <path class="cls-307" d="m35.5 17.5-.4.1-1.4-3 1-.4.8 3.3z" />
          <path class="cls-419" d="m35.5 17.5-.4.1-1.3-3.1.9-.3.8 3.3z" />
          <path class="cls-48" d="m35.5 17.5-.4.1-1.3-3.1.9-.3.8 3.3z" />
          <path class="cls-117" d="m35.5 17.5-.3.1-1.3-3.1.8-.3.8 3.3z" />
          <path class="cls-20" d="m35.5 17.5-.3.1-1.2-3.1.7-.3.8 3.3z" />
        </g>
        <path
          class="cls-106"
          d="M33.7 14.6c.2 0 .6-.2.6-.2l-.3 1s-.1.4 0 .5h.1c-.2 0-.2-.3-.1-.5 0-.1.3-1.1.3-1.1h-.1l-1.2.4s.3 0 .6-.1ZM34.9 15.3l.6 2.2-.6-2.5v.3z"
        />
        <path
          class="cls-228"
          d="m35.4 17.5-.2-.2-.4-.2c-.2 0-.2.1-.2.2v-.1c.2-.2.7.3.7.3ZM34.1 16c.2 0 .4-.1.4-.3l.2-.6s-.1.4-.2.6c0 .2-.3.5-.6.3h.1Z"
        />
        <path
          class="cls-175"
          d="M34.6 18.8h.6c.3 0 .3-.3 0-.4 0 0-.7-.4-.8-.6 0 .3.2.7.2 1Z"
        />
        <path
          class="cls-43"
          d="M34.6 18.8h.5c.2 0 .3-.3 0-.4 0 0-.7-.4-.8-.5 0 .3.2.6.2.9Z"
        />
        <path
          class="cls-183"
          d="M34.6 18.8h.5c.2 0 .2-.3 0-.4 0 0-.7-.4-.8-.5 0 .3.2.6.2.9Z"
        />
        <path
          class="cls-213"
          d="M34.6 18.8h.5c.2 0 .2-.2 0-.4 0 0-.7-.4-.8-.5 0 .3.2.6.2.9Z"
        />
        <path
          class="cls-108"
          d="M34.6 18.8h.5c.2 0 .2-.2 0-.4 0 0-.6-.4-.7-.5 0 .3.1.6.2.8Z"
        />
        <path
          class="cls-330"
          d="M34.6 18.8h.5c.2 0 .2-.2 0-.3 0 0-.6-.4-.7-.5 0 .3.1.6.2.8Z"
        />
        <path
          class="cls-180"
          d="M34.6 18.8h.5c.2 0 .2-.2 0-.3 0 0-.6-.4-.7-.5 0 .3.1.5.2.8Z"
        />
        <path
          class="cls-320"
          d="M34.6 18.8h.5c.2 0 .2-.2 0-.3 0 0-.6-.4-.7-.4 0 .2.1.5.2.8Z"
        />
        <path
          class="cls-84"
          d="M34.6 18.8h.4c.1 0 .2-.2 0-.3 0 0-.6-.4-.7-.4 0 .2.1.5.2.7Z"
        />
        <path
          class="cls-22"
          d="M34.6 18.8h.4c.1 0 .2-.2 0-.3l-.6-.4c0 .2.1.5.1.7Z"
        />
        <path
          class="cls-371"
          d="M34.6 18.8h.4c.1 0 .2-.2 0-.3l-.6-.4c0 .2.1.5.1.7Z"
        />
        <path
          class="cls-67"
          d="M34.6 18.8h.4c.2 0 .2-.2 0-.3l-.6-.4c0 .2.1.4.1.6Z"
        />
        <path class="cls-228" d="M35 18.8H34.4h.7Z" />
        <path
          class="cls-336"
          d="M46.4 17c0-.3 0-.8.5-.8s.3.6.3.6.5-.3.7-1c.2-.7-.2-1-.4-1s-.4 0-.8.4c0 0 .3-.5.4-1 .1-.7-.2-1.2-.3-1.4 0-.2-.3-.4-.3-.4s-.1 0-.4.3c-.3.3-.7.8-.7 1.4s0 .5.2 1.1c0 0-.2-.5-.8-.5s-.7.7-.7.9 0 .6.4 1.1c0 0 0-.6.5-.6s.6.5.4.9"
        />
        <path
          class="cls-402"
          d="M45.3 16.9c.2-.3.2-.6 0-.8 0 0-.2-.1-.4-.1h-.2c-.3.1-.4.5-.4.6-.3-.5-.3-.9-.3-1.1 0-.2.1-.9.7-.9s.7.4.8.5c-.1-.6-.1-.8-.1-1v-.3c.1-.5.4-.9.6-1.1s.4-.3.4-.3.2.3.3.4c0 .1.1.3.2.4 0 .2.1.3.1.5v.5c0 .4-.3.8-.3 1h.1c.3-.3.5-.3.7-.3s.6.3.4 1c-.2.6-.6.8-.7.9 0 0 0-.6-.3-.6-.2 0-.3 0-.4.2-.1.2-.1.5 0 .6"
        />
        <path
          class="cls-415"
          d="M45.3 16.9c.2-.3.2-.6 0-.8l-.4-.2c-.2-.1-.1 0-.2 0-.3.1-.4.5-.4.5-.3-.5-.3-.9-.3-1.1 0-.2.1-.8.6-.8s.7.4.8.5c-.1-.6-.1-.8-.1-1v-.3c.1-.5.4-.9.6-1.1s.3-.3.4-.3.2.2.3.4c0 .1.1.3.2.4 0 .2.1.3.1.5v.5c0 .4-.3.8-.3 1h.1c.3-.3.5-.3.7-.3s.6.3.4 1c-.2.6-.6.8-.6.8s0-.6-.3-.6c-.2 0-.3 0-.4.2-.1.2-.1.5 0 .7"
        />
        <path
          class="cls-83"
          d="M45.3 16.9c.2-.3.2-.6 0-.8 0 0-.2-.2-.4-.2h-.2c-.3 0-.4.5-.4.5-.2-.5-.3-.8-.3-1.1 0-.2.1-.8.6-.8s.7.3.8.5c-.1-.6-.1-.8-.1-1v-.3c.1-.5.4-.9.6-1.1l.3-.3s.2.2.3.4c0 .1.1.3.2.5 0 .2.1.3.1.5v.5c0 .4-.3.8-.3 1h.1c.3-.3.5-.3.7-.3s.6.3.4 1c-.2.6-.6.8-.6.8s0-.6-.3-.6c-.2 0-.3 0-.4.2-.1.2-.1.5 0 .7"
        />
        <path
          class="cls-216"
          d="M45.3 16.9c.2-.3.2-.6 0-.8 0 0-.2-.2-.4-.2h-.2c-.3 0-.4.5-.4.5-.2-.4-.3-.8-.3-1 0-.2.1-.8.6-.8s.7.3.8.4c-.1-.5 0-.8 0-1v-.3c.1-.5.4-.9.6-1.2s.3-.3.3-.3.2.2.3.4c0 .1.1.3.2.5 0 .2.1.3.1.5v.5c0 .5-.3.9-.3 1h.1c.3-.3.5-.3.7-.3s.5.3.4.9c-.2.6-.6.8-.6.8s0-.6-.3-.6c-.2 0-.3 0-.4.2-.1.2-.1.5 0 .7"
        />
        <path
          class="cls-284"
          d="M45.3 16.9c.2-.3.2-.6 0-.8 0 0-.2-.2-.4-.2h-.2c-.3 0-.4.4-.4.5-.2-.4-.3-.8-.2-1 0-.3.1-.8.6-.8s.7.3.8.4c-.1-.5 0-.8 0-1v-.3c.1-.5.4-.9.6-1.2s.3-.3.3-.3.2.2.3.4c0 .1.1.3.2.5 0 .2.1.3.1.5v.5c0 .5-.3.9-.3 1h.1c.3-.3.5-.3.7-.3s.5.3.4.9c-.2.5-.5.8-.6.8 0 0 0-.6-.3-.6-.2 0-.3 0-.4.2-.1.2-.1.5 0 .7"
        />
        <path
          class="cls-289"
          d="M45.3 16.9c.2-.3.2-.6 0-.8 0 0-.2-.2-.4-.2h-.2c-.3 0-.4.4-.5.5-.2-.4-.2-.7-.2-1 0-.3.1-.8.6-.8s.7.3.8.4v-1.3c.1-.5.4-.9.6-1.2s.3-.3.3-.3l.2.4c0 .1.2.3.2.5s.1.4.1.5v.5c0 .5-.3.9-.3 1h.1c.3-.3.6-.3.7-.3s.5.3.4.9c-.2.5-.5.7-.6.8 0 0 0-.6-.3-.6-.2 0-.3 0-.4.2-.1.2-.1.5 0 .7"
        />
        <path
          class="cls-391"
          d="M45.3 17c.2-.3.2-.6 0-.8 0 0-.2-.2-.4-.2h-.2c-.3 0-.4.4-.5.5-.2-.3-.2-.7-.2-.9 0-.3.1-.7.6-.7s.7.3.8.4V14c.1-.5.3-.9.5-1.2s.3-.3.3-.4.1.2.2.4c0 .1.2.3.2.5s.1.4.1.6v.5c0 .5-.3.9-.3 1h.1c.3-.3.6-.3.7-.2.2 0 .5.3.4.9-.2.5-.5.7-.5.8 0 0 0-.6-.4-.6-.2 0-.3 0-.4.2-.1.2-.1.5 0 .7"
        />
        <path
          class="cls-173"
          d="M45.3 17c.2-.3.2-.6 0-.8 0 0-.2-.2-.4-.2h-.2c-.3 0-.4.4-.5.5-.2-.3-.2-.6-.2-.9 0-.3.1-.7.5-.7s.7.3.8.4V14c.1-.5.3-.9.5-1.2s.2-.3.3-.4.1.2.2.4c0 .1.2.3.2.5s.1.4.1.6v.5c0 .5-.3.9-.3 1h.1c.3-.2.6-.2.7-.2.2 0 .5.3.3.8s-.5.7-.5.7 0-.6-.4-.6c-.2 0-.3 0-.4.2-.2.2-.1.5 0 .7"
        />
        <path
          class="cls-262"
          d="M45.3 17c.2-.3.2-.6 0-.8 0 0-.2-.2-.4-.2h-.2c-.3 0-.4.3-.5.5-.1-.3-.2-.6-.2-.9 0-.3.1-.7.5-.7s.7.2.8.4v-1.2c.1-.5.3-.9.5-1.2s.2-.3.3-.4.1.2.2.4c0 .1.2.3.2.5s.1.4.1.6v.5c0 .5-.3.9-.3 1h.1c.3-.2.6-.2.7-.2.2 0 .5.3.3.8-.1.5-.4.7-.5.7 0 0 0-.6-.4-.6-.2 0-.3 0-.4.2-.2.2-.1.5 0 .7"
        />
        <path
          class="cls-386"
          d="M45.3 17c.2-.3.2-.6.1-.8 0-.1-.2-.2-.4-.2h-.2c-.3 0-.4.3-.5.5-.1-.2-.2-.6-.1-.9 0-.3.1-.7.5-.7s.7.2.8.4v-1.2c.1-.5.3-.9.5-1.2s.2-.3.3-.4.1.2.2.4c0 .1.2.3.2.5s.1.4.1.6v.5c0 .5-.3.9-.3 1h.1c.3-.2.6-.2.8-.2.2 0 .4.3.3.8-.1.5-.4.6-.5.7 0 0 0-.6-.4-.6-.2 0-.3.1-.4.2-.2.2-.1.5 0 .7"
        />
        <path
          class="cls-293"
          d="M45.3 17c.2-.3.3-.6.1-.8 0-.1-.1-.2-.4-.2h-.2c-.3 0-.4.3-.5.5 0-.2-.1-.5-.1-.8 0-.3.1-.6.5-.6s.7.2.8.3v-1.2c.1-.5.3-.9.5-1.2s.2-.3.2-.4.1.1.2.3c0 .1.2.3.2.5s.1.4.1.6v.5c0 .5-.3.9-.3 1h.1c.3-.2.6-.2.8-.2.2 0 .4.3.3.8-.1.5-.4.6-.5.7 0-.1 0-.6-.4-.6-.2 0-.3.1-.4.2-.2.2-.1.5 0 .7"
        />
        <path
          class="cls-270"
          d="M46.3 15.6s-.1-.2-.1-.5v-.4c0-.2.1-.5.2-.8 0-.5 0-1.1.1-1.1s.3.6.4.9 0 .6 0 1.1-.3.9-.5.9Z"
        />
        <path
          class="cls-319"
          d="M46.3 15.6s-.1-.2-.1-.4v-.4c0-.2.1-.5.1-.8 0-.5 0-1.1.1-1.1s.3.5.3.8 0 .6-.1 1-.3.8-.4.8Z"
        />
        <path
          class="cls-66"
          d="M46.3 15.5s-.1-.2-.1-.4v-.4c0-.2.1-.4.1-.7 0-.5 0-1 .1-1s.3.5.3.8 0 .6-.1 1-.2.7-.4.7Z"
        />
        <path
          class="cls-24"
          d="M46.3 15.5v-.8c0-.1 0-.4.1-.7v-1c.1 0 .2.5.3.7s0 .6-.1 1-.2.7-.4.6Z"
        />
        <path
          class="cls-156"
          d="M46.3 15.4v-.7c0-.1 0-.4.1-.6v-.9c.1 0 .2.4.3.7s0 .6-.2 1-.2.6-.3.6Z"
        />
        <path
          class="cls-295"
          d="M46.3 15.3v-.7c0-.1 0-.3.1-.6v-.8s.2.4.2.7 0 .6-.2 1-.2.5-.3.5Z"
        />
        <path
          class="cls-255"
          d="M46.3 15.3v-.2c0-.2 0-.3.1-.4s0-.3.1-.6v-.8s.2.4.2.6 0 .6-.2.9-.2.4-.3.4Z"
        />
        <path
          class="cls-79"
          d="M46.4 15.2V15c0-.2 0-.3.1-.4s0-.3.1-.5v-.7s.2.3.2.6-.1.6-.2.9-.2.4-.2.3Z"
        />
        <path
          class="cls-40"
          d="M46.4 15.2V15c0-.2 0-.3.1-.4s0-.3.1-.5v-.7s.1.3.1.6c0 .2-.1.6-.2.9s-.1.3-.2.3Z"
        />
        <path
          class="cls-174"
          d="M46.4 15.1V15c0-.2 0-.3.1-.4s0-.2 0-.4v-.6s.1.3.1.5-.2.6-.2.9-.1.2-.2.2Z"
        />
        <path
          class="cls-205"
          d="M46.7 13.6v.5c0 .3-.2.6-.3.9 0 .1 0 .1-.1.1V15c0-.2 0-.3.1-.4v-.9Z"
        />
        <path
          class="cls-270"
          d="M47.4 15.9c.1-.3.2-.5.3-.5s.1.2 0 .7-.5.3-.3-.2Z"
        />
        <path
          class="cls-319"
          d="M47.4 16c.1-.3.2-.5.3-.5s.1.2 0 .7-.5.2-.3-.2Z"
        />
        <path
          class="cls-66"
          d="M47.4 16c.1-.2.2-.5.2-.5s.1.2 0 .6-.4.2-.3-.2Z"
        />
        <path class="cls-24" d="m47.4 16 .2-.4v.6c0 .4-.4.2-.2-.1Z" />
        <path class="cls-156" d="m47.4 16 .2-.4v.5c0 .3-.4.2-.2-.1Z" />
        <path class="cls-295" d="m47.5 16 .2-.4v.5c0 .3-.3.2-.2-.1Z" />
        <path class="cls-255" d="M47.5 16c0-.2.2-.4.2-.4v.5c0 .3-.3.2-.2 0Z" />
        <path class="cls-79" d="M47.5 16c0-.2.1-.3.2-.3s0 .2 0 .4-.3.2-.2 0Z" />
        <path class="cls-40" d="M47.5 16c0-.1.1-.3.2-.3s0 .2 0 .4-.2.1-.1 0Z" />
        <path
          class="cls-174"
          d="M47.5 16c0-.1.1-.3.2-.3s0 .2 0 .4c0 .3-.2.1-.1 0Z"
        />
        <path class="cls-205" d="M47.5 16.1c0-.1.1-.3.1-.3v.3c0 .2-.2.1 0 0Z" />
        <path
          class="cls-270"
          d="M47.3 16.1s-.2-.3-.6-.3-.8.2-.9.7.2.3.2.3.1-.2.2-.3c.1-.2.3-.5.7-.4s.3 0 .3 0Z"
        />
        <path
          class="cls-319"
          d="M47.3 16.1s-.2-.3-.6-.3-.7.3-.8.7.2.3.2.3.1-.1.2-.3c0-.2.3-.5.7-.4s.3 0 .3 0Z"
        />
        <path
          class="cls-66"
          d="M47.3 16s-.2-.2-.5-.2-.7.3-.8.6.1.3.2.3.1-.1.2-.2c0-.2.3-.5.6-.4s.3 0 .3 0Z"
        />
        <path
          class="cls-24"
          d="M47.2 16s-.2-.2-.5-.2-.7.3-.8.6.1.2.2.2.1-.1.2-.2c0-.2.3-.5.6-.4s.3 0 .3 0Z"
        />
        <path
          class="cls-156"
          d="M47.2 16s-.2-.2-.5-.2-.7.3-.8.6.1.2.2.2.1 0 .2-.2c0-.2.3-.5.6-.5h.3Z"
        />
        <path
          class="cls-295"
          d="M47.2 16s-.2-.2-.5-.2-.6.3-.8.6 0 .2.1.2.1 0 .2-.2c0-.2.3-.5.6-.5h.3Z"
        />
        <path
          class="cls-255"
          d="M47.2 16s-.2-.2-.5-.2-.6.3-.7.6 0 .2.1.2.1 0 .1-.2.3-.5.6-.5h.3Z"
        />
        <path
          class="cls-79"
          d="M47.1 16s-.2-.1-.4-.1-.6.3-.7.5 0 .2 0 .2l.1-.1c0-.2.3-.5.6-.5h.3Z"
        />
        <path
          class="cls-40"
          d="M47.1 16s-.2-.1-.4-.1-.6.3-.7.5 0 .1 0 .2 0 0 .1-.1c0-.1.3-.5.6-.5h.3Z"
        />
        <path
          class="cls-174"
          d="M47.1 16h-.4c-.2 0-.6.3-.7.5s0 .1 0 .1l.1-.1c0-.1.2-.5.6-.5h.3Z"
        />
        <path
          class="cls-205"
          d="M47.1 16h-.4c-.3 0-.5.4-.6.5v.1h.1c0-.1.2-.5.5-.5h.3Z"
        />
        <path
          class="cls-270"
          d="M44.9 15.5s-.2 0-.2.1 0 0-.1.1v.3s.2 0 .3-.1h.5c.1 0 .2.1.2 0v-.2s-.2-.2-.3-.2h-.4Z"
        />
        <path
          class="cls-319"
          d="M44.9 15.5s-.2 0-.2.1 0 0-.1.1v.2s.2 0 .3-.1h.5c.1 0 .2.1.2 0v-.2s-.1-.2-.2-.2H45Z"
        />
        <path
          class="cls-66"
          d="M44.9 15.5h-.2l-.1.1v.2s.2 0 .3-.1h.4c.1 0 .2.1.2 0v-.2s-.1-.2-.2-.2h-.4Z"
        />
        <path
          class="cls-24"
          d="M44.9 15.6h-.2l-.1.1v.2h.3c.1 0 0 0 0 0h.5v-.1l-.2-.2h-.3Z"
        />
        <path
          class="cls-156"
          d="M44.9 15.6h-.2l-.1.1v.2c0 .1.2 0 .3 0h.5v-.1c0-.1-.1-.1-.2-.2h-.3Z"
        />
        <path
          class="cls-295"
          d="M45 15.6H44.7v.1h.5c.1 0 0 0 0 0h.2c.1 0 0 0 0 0v-.1c0-.1-.1-.1-.2-.1h-.3Z"
        />
        <path
          class="cls-255"
          d="M45 15.6H44.7h.5c.1 0 0 0 0 0h.2c.1 0 0 0 0 0v-.1c0-.1-.1 0-.2-.1h-.3Z"
        />
        <path
          class="cls-79"
          d="M45 15.6H44.7h.2c.1 0 0 0 0 0h.3c.1 0 0 0 0 0h.1l-.2-.1h-.2Z"
        />
        <path class="cls-40" d="M45 15.6H44.7 45c.1 0 0 0 0 0H45.3 45Z" />
        <path class="cls-174" d="M45 15.7H44.7 45c.1 0 0 0 0 0H45.3 45Z" />
        <path class="cls-205" d="M45 15.7H44.7h.7-.3Z" />
        <path
          d="M49 18.8h-.4c-.2 0-.2-.2 0-.3l.6-.4c0 .2-.1.4-.1.6Z"
          style="fill: url(#linear-gradient-26); stroke-width: 0"
        />
        <path
          class="cls-13"
          d="M41.8 14h1.3s-.6.5-.8.8c0 0-.1.2 0 .3s.2.3.3.3c.3 0 .5-.1.6-.2h.1V17l-.4-.4c-.1-.1-.3-.2-.5-.2-.3 0-.3.4-.3.4 0 .2 0 .7.3 1 .1.2.5.6 1.1.6.4 0 .9-.3 1.2-.6.3-.3.5-.9.5-.9h1.1c0 .1 0 .6.3.9.2.2.7.6 1.2.6s.6 0 .9-.3c.2-.1.3-.5.3-.7 0-.1-.1-.2-.1-.2.1.2 0 .4-.2.5-.2.2-.7.4-.9.4-.8 0-1.3-.7-1.4-1.1h-1.1c-.2.2-.6 1.1-1.8 1.1s-1.4-.6-1.4-1.3.5-.6.8-.2l.5.6v-2.7l-.8.6h-.4v-.4l.9-.9h-1.5"
        />
        <path
          class="cls-77"
          d="M41.8 14h1.3l-.8.8s-.1.2 0 .3.2.3.3.3c.2 0 .5-.1.6-.3h.1v1.8l-.4-.4c-.1-.1-.3-.2-.5-.2-.3 0-.3.4-.3.4 0 .2 0 .7.3 1 .1.2.5.6 1.1.6.4 0 .9-.3 1.2-.6.3-.3.5-.9.5-.9h1.1c0 .1 0 .6.3.9.2.2.7.5 1.2.5s.6 0 .8-.3c.2-.1.3-.5.3-.6 0-.1-.1-.2-.1-.2.1.2 0 .4-.2.5-.2.2-.7.4-.9.4-.8 0-1.3-.7-1.4-1.1h-1.1c-.2.2-.6 1.1-1.8 1.1s-1.4-.6-1.4-1.3.5-.6.8-.2l.5.6v-2.7l-.8.6h-.4v-.4l.9-.9h-1.5"
        />
        <path
          class="cls-309"
          d="M41.8 14h1.4l-.8.8s-.1.2 0 .3.2.3.3.2c.2 0 .4-.1.6-.3h.1v1.9l-.4-.4c-.1-.1-.3-.3-.5-.3-.3 0-.3.4-.3.4 0 .2 0 .7.3 1 .2.2.5.6 1.1.6.5 0 1-.3 1.3-.6.3-.3.5-.8.5-.9h1.1c0 .1 0 .6.4.9.2.2.7.5 1.2.5s.6 0 .8-.3c.2-.1.3-.5.3-.6 0-.1-.1-.2-.1-.2.1.2 0 .4-.2.5-.2.2-.7.4-.9.4-.8 0-1.3-.7-1.4-1.1h-1.1c-.2.2-.6 1.1-1.8 1.1s-1.4-.6-1.4-1.3.5-.6.8-.2l.5.6v-2.7l-.8.6h-.4v-.4l.9-.9h-1.5"
        />
        <path
          class="cls-217"
          d="M41.8 14h1.4l-.8.8s-.1.2 0 .4.2.2.4.2.4-.2.6-.3h.1V17l-.4-.4c-.1-.1-.3-.3-.5-.3-.3 0-.3.4-.3.4 0 .2 0 .7.3 1 .2.2.5.6 1.1.5.5 0 1-.3 1.3-.6.3-.3.5-.8.5-.9h1.1c0 .2 0 .6.4.9.2.2.7.5 1.1.5s.6 0 .8-.3c.2-.1.3-.4.3-.6 0-.2 0-.2-.1-.2.1.2 0 .4-.2.5-.2.2-.7.4-.9.4-.8 0-1.3-.7-1.4-1.1h-1.1c-.2.2-.6 1.1-1.8 1.1s-1.4-.6-1.4-1.3.5-.6.8-.2l.5.6v-2.7l-.8.6h-.4v-.4l.9-.9h-1.5"
        />
        <path
          class="cls-111"
          d="M41.8 14h1.4l-.8.8v.4c0 .2.2.2.4.2s.4-.2.6-.3h.1V17l-.4-.4c-.1-.1-.3-.3-.5-.3-.3 0-.3.4-.3.4 0 .3.1.7.3 1 .2.2.6.5 1.1.5.5 0 1-.3 1.3-.6.3-.3.5-.8.5-.9h1.1c0 .2 0 .6.4.9.2.2.7.5 1.1.5s.6 0 .8-.3c.2-.1.3-.4.3-.6V17c.1.2 0 .4-.2.5-.2.2-.7.4-.9.4-.8 0-1.3-.7-1.4-1.1h-1.1c-.2.2-.6 1.1-1.8 1.1s-1.4-.6-1.4-1.3.5-.6.8-.2l.5.6v-2.7l-.8.6h-.4v-.4l.9-.9h-1.5"
        />
        <path
          class="cls-325"
          d="M41.8 14h1.4l-.8.8v.4c0 .2.2.2.4.2s.4-.2.6-.3c0 0 .1 0 .1.1v1.9l-.4-.4c-.1-.1-.3-.3-.5-.3-.3 0-.3.4-.3.4 0 .3.1.7.3 1 .2.2.6.5 1.1.5.5 0 1-.3 1.3-.5.3-.3.5-.8.5-.9h1.1c0 .2 0 .6.4.9.3.2.7.5 1.1.5s.6 0 .8-.3c.2-.1.3-.4.3-.6v-.2c.1.2 0 .4-.2.5-.2.2-.7.4-.9.4-.8 0-1.3-.7-1.4-1.1h-1.1c-.2.2-.6 1.1-1.8 1.1s-1.4-.6-1.4-1.3.5-.6.8-.2l.5.6v-2.7l-.8.6h-.4v-.4l.9-.9h-1.5"
        />
        <path
          class="cls-314"
          d="M41.8 14h1.4l-.8.8v.4c0 .2.2.2.4.2s.4-.2.6-.3c0 0 .1 0 .1.1v2s-.2-.2-.3-.4c-.1-.1-.3-.3-.5-.3-.3 0-.3.4-.3.4 0 .3.1.7.3 1 .2.2.6.5 1 .5.6 0 1-.3 1.3-.5.3-.3.5-.8.5-.9h1.1c0 .2.1.6.4.9.3.3.7.5 1.1.5s.6 0 .8-.3c.2-.1.3-.4.3-.5v-.2c.1.2 0 .4-.2.5-.2.2-.7.4-.9.4-.8 0-1.3-.7-1.4-1.1h-1.1c-.2.2-.6 1.1-1.8 1.1s-1.4-.6-1.4-1.3.5-.6.8-.2l.5.6v-2.7l-.8.6h-.4v-.4l.9-.9h-1.5"
        />
        <path
          class="cls-285"
          d="M41.8 14h1.4l-.8.8v.4c0 .2.2.2.4.1l.6-.3s.1 0 .1.1v2s-.2-.2-.3-.4c-.2-.2-.3-.3-.6-.3s-.3.4-.3.4c0 .3.1.7.3 1 .2.2.6.5 1 .5.6 0 1-.3 1.3-.5.3-.3.5-.8.5-.9h1.1c0 .2.1.6.4.9.3.3.7.5 1.1.5s.6 0 .8-.3c.2-.1.3-.4.3-.5v-.2c.1.2 0 .4-.2.5-.2.2-.7.4-.9.4-.8 0-1.3-.7-1.4-1.1h-1.1c-.2.2-.6 1.1-1.8 1.1s-1.4-.6-1.4-1.3.5-.6.8-.2l.5.6v-2.7l-.8.6h-.4v-.4l.9-.9h-1.5"
        />
        <path
          class="cls-239"
          d="M41.8 14h1.4l-.8.8v.4c0 .2.2.2.4.1l.6-.3s.2 0 .2.2v2s-.1-.2-.3-.3c-.2-.2-.3-.3-.6-.3s-.3.4-.3.4c0 .3.2.7.3.9.3.3.7.5 1 .5.6 0 1-.3 1.3-.5.3-.3.5-.8.5-.8h1.1c0 .2.1.6.4.9.3.3.7.5 1.1.5s.6 0 .8-.3c.2-.1.3-.4.3-.5v-.2c.1.2 0 .4-.2.5-.2.2-.7.4-.9.4-.8 0-1.3-.7-1.4-1.1h-1.1c-.2.2-.6 1.1-1.8 1.1s-1.4-.6-1.4-1.3.5-.6.8-.2l.5.6v-2.7l-.8.6h-.4V15l.9-.9h-1.5"
        />
        <path
          class="cls-181"
          d="M41.8 14h1.4l-.8.8v.4c0 .1.2.2.4 0s.4-.2.5-.4c0 0 .2 0 .2.2v2s-.1-.2-.3-.3c-.2-.2-.3-.4-.6-.4s-.3.4-.3.4c0 .3.2.7.4.9.3.3.7.5 1 .5.6 0 1.1-.3 1.3-.5.3-.3.4-.7.5-.8h1.1c0 .2.1.6.4.9.3.3.7.5 1.1.5s.6 0 .8-.3c.2-.1.3-.4.3-.5v-.2c.1.2 0 .4-.2.5-.2.2-.7.4-.9.4-.8 0-1.3-.7-1.4-1.1h-1.1c-.2.2-.6 1.1-1.8 1.1s-1.4-.6-1.4-1.3.5-.6.8-.2l.5.6v-2.7l-.8.6h-.4v-.4l.9-.9h-1.5"
        />
        <path
          class="cls-372"
          d="M41.8 14h1.4l-.8.8c-.1.1 0 .3 0 .4s.2.2.4 0 .4-.3.5-.4c0 0 .2 0 .2.2v2.1s-.1-.2-.3-.3c-.2-.2-.3-.4-.6-.4s-.3.4-.3.4c0 .3.2.7.4.9.3.3.7.5 1 .5.7 0 1.1-.3 1.3-.5.3-.3.4-.7.5-.8h1.1c0 .2.1.6.4.8.3.3.7.4 1.1.4s.5 0 .8-.3c.2-.1.3-.3.3-.5v-.2c.1.2 0 .4-.2.5-.2.2-.7.4-.9.4-.8 0-1.3-.7-1.4-1.1h-1.1c-.2.2-.6 1.1-1.8 1.1s-1.4-.6-1.4-1.3.5-.6.8-.2l.5.6v-2.7l-.8.6h-.4v-.4l.9-.9h-1.5"
        />
        <path
          class="cls-106"
          d="M41.8 14h1.4l-.8.8c-.1.1 0 .3 0 .4 0 0 .2.2.4 0 .2-.1.4-.3.5-.4 0 0 .2.1.2.2v2.1l-.3-.3c-.2-.2-.3-.4-.6-.4s-.3.4-.3.4c0 .3.2.7.4.9.3.3.8.4 1 .4.7 0 1.1-.3 1.3-.5.3-.3.4-.7.5-.8h1.1c0 .2.1.6.4.8.3.3.7.4 1.1.4s.5 0 .8-.3c.2-.1.3-.3.3-.4v-.2c.1.2 0 .4-.2.5-.2.2-.7.4-.9.4-.8 0-1.3-.7-1.4-1.1h-1.1c-.2.2-.6 1.1-1.8 1.1s-1.4-.6-1.4-1.3.5-.6.8-.2l.5.6v-2.7l-.8.6h-.4v-.4l.9-.9h-1.5"
        />
        <g style="clip-path: url(#clippath-3)">
          <path class="cls-207" d="m48 17.5.7.1 1.6-2.9-1.4-.5-.9 3.3z" />
          <path class="cls-260" d="m48 17.5.7.1 1.5-2.9-1.3-.5-.9 3.3z" />
          <path class="cls-334" d="m48 17.5.6.1 1.6-2.9-1.3-.5-.9 3.3z" />
          <path class="cls-204" d="m48 17.5.6.1 1.5-3-1.2-.4-.9 3.3z" />
          <path class="cls-263" d="m48 17.5.6.1 1.4-3-1.1-.4-.9 3.3z" />
          <path class="cls-274" d="m48 17.5.5.1 1.4-3-1-.4-.9 3.3z" />
          <path class="cls-307" d="m48 17.5.5.1 1.4-3-1-.4-.9 3.3z" />
          <path class="cls-419" d="m48 17.5.5.1 1.3-3.1-.9-.3-.9 3.3z" />
          <path class="cls-48" d="m48 17.5.4.1 1.3-3.1-.8-.3-.9 3.3z" />
          <path class="cls-117" d="m48 17.5.4.1 1.3-3.1-.8-.3-.9 3.3z" />
          <path class="cls-20" d="m48 17.5.4.1 1.2-3.1-.7-.3-.9 3.3z" />
        </g>
        <path
          class="cls-106"
          d="M49.9 14.6c-.2 0-.6-.2-.6-.2l.3 1s.1.4 0 .5h-.1c.2 0 .2-.3.1-.5 0-.1-.3-1.1-.3-1.1h.1l1.2.4s-.3 0-.6-.1ZM48.7 15.3l-.6 2.2H48l.7-2.5v.3z"
        />
        <path
          class="cls-228"
          d="m48.1 17.5.2-.2.4-.2c.2 0 .2.1.2.2v-.1c-.2-.2-.7.3-.7.3ZM49.4 16c-.2 0-.4-.1-.4-.3l-.2-.6s.1.4.2.6c0 .2.3.5.6.3h-.1Z"
        />
        <path
          class="cls-175"
          d="M49 18.8h-.6c-.3 0-.3-.3 0-.4 0 0 .7-.4.8-.6 0 .3-.2.7-.2 1Z"
        />
        <path
          class="cls-43"
          d="M49 18.8h-.5c-.2 0-.3-.3 0-.4 0 0 .7-.4.8-.5 0 .3-.2.6-.2.9Z"
        />
        <path
          class="cls-183"
          d="M49 18.8h-.5c-.2 0-.2-.3 0-.4 0 0 .7-.4.8-.5 0 .3-.2.6-.2.9Z"
        />
        <path
          class="cls-213"
          d="M49 18.8h-.5c-.2 0-.2-.2 0-.4 0 0 .7-.4.8-.5 0 .3-.2.6-.2.9Z"
        />
        <path
          class="cls-108"
          d="M49 18.8h-.5c-.2 0-.2-.2 0-.4 0 0 .6-.4.7-.5 0 .3-.1.6-.2.8Z"
        />
        <path
          class="cls-330"
          d="M49 18.8h-.5c-.2 0-.2-.2 0-.3 0 0 .6-.4.7-.5 0 .3-.1.6-.2.8Z"
        />
        <path
          class="cls-180"
          d="M49 18.8h-.5c-.2 0-.2-.2 0-.3 0 0 .6-.4.7-.5 0 .3-.1.5-.2.8Z"
        />
        <path
          class="cls-320"
          d="M49 18.8h-.5c-.2 0-.2-.2 0-.3 0 0 .6-.4.7-.4 0 .2-.1.5-.2.8Z"
        />
        <path
          class="cls-84"
          d="M49 18.8h-.4c-.1 0-.2-.2 0-.3 0 0 .6-.4.7-.4 0 .2-.1.5-.2.7Z"
        />
        <path
          class="cls-22"
          d="M49 18.8h-.4c-.1 0-.2-.2 0-.3l.6-.4c0 .2-.1.5-.1.7Z"
        />
        <path
          class="cls-371"
          d="M49 18.8h-.4c-.1 0-.2-.2 0-.3l.6-.4c0 .2-.1.5-.1.7Z"
        />
        <path
          class="cls-67"
          d="M49 18.8h-.4c-.2 0-.2-.2 0-.3l.6-.4c0 .2-.1.4-.1.6Z"
        />
        <path class="cls-228" d="M48.5 18.8H49.1h-.7Z" />
        <path
          d="M41.8 18.8h1.1v-.2s-.3-.2-.5-.4l-.4-.4h-.4l-.4.4c-.2.2-.5.4-.5.4v.2h1.1Z"
          style="fill: #efc952; opacity: 0.1; stroke-width: 0"
        />
        <path
          d="M41.8 18.8h1.1v-.1s-.3-.2-.5-.4l-.4-.4h-.4l-.4.4c-.2.2-.5.4-.5.4v.1h1.1Z"
          style="fill: #deb74d; opacity: 0.2; stroke-width: 0"
        />
        <path
          d="M41.8 18.7h1.1v-.1s-.3-.2-.5-.4-.4-.3-.4-.4h-.4l-.4.4c-.2.2-.5.4-.5.4v.1h1.1Z"
          style="fill: #cea547; opacity: 0.4; stroke-width: 0"
        />
        <path
          d="M41.8 18.7h1v-.1s-.3-.2-.5-.4-.4-.3-.4-.4h-.4c-.1 0-.2.2-.4.4s-.4.3-.5.4v.1h1Z"
          style="fill: #bd9342; opacity: 0.5; stroke-width: 0"
        />
        <path
          d="M41.8 18.7h1v-.1s-.3-.2-.5-.4c-.2-.1-.3-.3-.4-.4h-.2l-.4.4c-.2.2-.4.3-.5.4v.1h1Z"
          style="fill: #ad813c; opacity: 0.6; stroke-width: 0"
        />
        <path
          d="M41.8 18.7h1v-.1s-.3-.2-.4-.3c-.2-.1-.3-.3-.4-.3h-.2c-.1 0-.2.2-.4.3-.2.2-.4.3-.4.3v.1h1Z"
          style="fill: #9d6f37; opacity: 0.8; stroke-width: 0"
        />
        <path
          d="M41.8 18.7h.9v-.1s-.2-.2-.4-.3c-.2-.1-.3-.3-.4-.3h-.2c-.1 0-.2.2-.4.3-.2.2-.4.3-.4.3v.1c0 .1 0 0 .1 0h.8Z"
          style="fill: #8c5d31; opacity: 0.9; stroke-width: 0"
        />
        <path
          class="cls-67"
          d="M41.8 18.7h.9v-.1s-.2-.2-.4-.3c-.2-.1-.3-.3-.3-.3h-.2l-.3.3c-.2.1-.4.3-.4.3v.1h.9Z"
        />
        <path
          class="cls-12"
          d="M41.8 18.7h.8s.1 0 0-.1c.1 0 .1.3 0 .3H41c-.2 0-.2-.3 0-.3v.1h.8Z"
        />
        <path
          class="cls-365"
          d="M41.8 18.7h.8s.1 0 0-.1c.1 0 .1.3 0 .3H41c-.2 0-.2-.3 0-.3v.1h.8Z"
        />
        <path
          class="cls-218"
          d="M41.8 18.7h.8s.1 0 0-.1c.1 0 .1.3 0 .3H41c-.2 0-.2-.3 0-.3v.1h.8Z"
        />
        <path
          class="cls-5"
          d="M41.8 18.7h.8l.1-.1s0 .2-.1.2H41c-.2 0-.2-.3-.1-.2 0 0 0 .1.1.1h.8Z"
        />
        <path
          class="cls-273"
          d="M41.8 18.7h.8l.1-.1s0 .2-.1.2H41c-.2 0-.2-.2-.1-.2 0 0 0 .1.1.1h.8Z"
        />
        <path
          class="cls-266"
          d="M41.8 18.7h.9s0 .2-.1.2H41c-.2 0-.2-.2-.1-.2h.9Z"
        />
        <path
          class="cls-238"
          d="M41.8 18.7h.9s0 .2-.1.2H41c-.2 0-.2-.2-.1-.2h.9Z"
        />
        <path
          class="cls-82"
          d="M41.8 18.7h.9s0 .2-.1.2H41c-.1 0-.2-.2-.1-.2h.9Z"
        />
        <path
          class="cls-14"
          d="M41.8 18.7h.9s0 .2-.1.2H41c-.1 0-.1-.1-.1-.2h.9Z"
        />
        <path
          class="cls-395"
          d="M41.8 18.7h.9s0 .1-.1.1H41c-.1 0-.1-.1-.1-.1h.9Z"
        />
        <path
          class="cls-350"
          d="M41.8 18.7h.9s0 .1-.1.1H41c-.1 0-.1 0-.1-.1h.9Z"
        />
        <path class="cls-389" d="M41.8 18.7h.9s0 .1-.1.1H41s-.1 0-.1-.1h.9Z" />
        <g style="clip-path: url(#clippath-4)">
          <path
            d="M34.3 19.1H49.2s0 .1-.1.2H34.2Z"
            style="fill: #ad7136; opacity: 0.1; stroke-width: 0"
          />
          <path
            d="M34.3 19.1H49.2s0 .1-.1.2H34.2Z"
            style="fill: #ac7036; opacity: 0.1; stroke-width: 0"
          />
          <path
            d="M34.3 19.1H49.2s0 .1-.1.2H34.2Z"
            style="fill: #ab7036; opacity: 0.1; stroke-width: 0"
          />
          <path
            d="M34.3 19.1H49.2s0 .1-.1.2H34.2Z"
            style="fill: #aa6f36; opacity: 0.1; stroke-width: 0"
          />
          <path
            d="M34.3 19.1H49.1s0 .1-.1.2H34.1Z"
            style="opacity: 0.2; fill: #a96e36; stroke-width: 0"
          />
          <path
            d="M34.3 19.1H49.1s0 .1-.1.2H34.1Z"
            style="fill: #a86d35; opacity: 0.2; stroke-width: 0"
          />
          <path
            d="M34.3 19.1H49.1s0 .1-.1.2H34.1Z"
            style="fill: #a76d35; opacity: 0.2; stroke-width: 0"
          />
          <path
            d="M34.3 19.1H49.1s0 .1-.1.2H34.1Z"
            style="fill: #a66c35; opacity: 0.2; stroke-width: 0"
          />
          <path
            d="M34.3 19.1H49.1s0 .1-.1.2H34.1Z"
            style="opacity: 0.2; fill: #a56b35; stroke-width: 0"
          />
          <path
            d="M34.3 19.1H49.1s0 .1-.1.2H34.1Z"
            style="fill: #a46a35; opacity: 0.2; stroke-width: 0"
          />
          <path
            d="M34.3 19.1H49.1s0 .1-.1.2H34.3Z"
            style="fill: #a36934; opacity: 0.2; stroke-width: 0"
          />
          <path
            d="M34.3 19.1H49.1s0 .1-.1.2H34.3Z"
            style="fill: #a26934; opacity: 0.2; stroke-width: 0"
          />
          <path
            d="M34.3 19.1H49.1s0 .1-.1.2H34.3Z"
            style="fill: #a16834; opacity: 0.2; stroke-width: 0"
          />
          <path
            d="M34.3 19.1H49.1s0 .1-.1.2H34.3Z"
            style="opacity: 0.2; fill: #a06734; stroke-width: 0"
          />
          <path
            d="M34.3 19.1H49s0 .1-.1.2H34.2Z"
            style="fill: #9f6634; opacity: 0.3; stroke-width: 0"
          />
          <path
            d="M34.3 19.2H49s0 .1-.1.2H34.2Z"
            style="fill: #9e6633; opacity: 0.3; stroke-width: 0"
          />
          <path
            d="M34.3 19.2H49s0 .1-.1.2H34.2Z"
            style="fill: #9d6533; opacity: 0.3; stroke-width: 0"
          />
          <path
            d="M34.3 19.2H49s0 .1-.1.1H34.2Z"
            style="fill: #9c6433; opacity: 0.3; stroke-width: 0"
          />
          <path
            d="M34.3 19.2H49s0 .1-.2.1H34.1Z"
            style="fill: #9b6333; opacity: 0.3; stroke-width: 0"
          />
          <path
            d="M34.3 19.2H49s0 .1-.2.1H34.1Z"
            style="fill: #9a6332; opacity: 0.3; stroke-width: 0"
          />
          <path
            d="M34.3 19.2H49s0 .1-.2.1H34.1Z"
            style="fill: #996232; opacity: 0.3; stroke-width: 0"
          />
          <path
            d="M34.3 19.2H49s0 .1-.2.1H34.1Z"
            style="fill: #986132; opacity: 0.3; stroke-width: 0"
          />
          <path
            d="M34.3 19.2H49s0 .1-.2.1H34.1Z"
            style="fill: #976032; opacity: 0.3; stroke-width: 0"
          />
          <path
            d="M34.4 19.2h14.7s0 .1-.2.1H34.2Z"
            style="fill: #965f32; opacity: 0.4; stroke-width: 0"
          />
          <path
            d="M34.4 19.2h14.7s0 .1-.2.1H34.2Z"
            style="fill: #955f31; opacity: 0.4; stroke-width: 0"
          />
          <path
            d="M34.4 19.2h14.7l-.2.1H34.2Z"
            style="fill: #945e31; opacity: 0.4; stroke-width: 0"
          />
          <path
            d="M34.4 19.2h14.7l-.2.1H34.2Z"
            style="fill: #935d31; opacity: 0.4; stroke-width: 0"
          />
          <path
            d="M34.4 19.2h14.7l-.2.1H34.2Z"
            style="fill: #925c31; opacity: 0.4; stroke-width: 0"
          />
          <path
            d="M34.4 19.2h14.7l-.2.1H34.2Z"
            style="fill: #915c31; opacity: 0.4; stroke-width: 0"
          />
          <path
            d="M34.4 19.2h14.7l-.2.1H34.2Z"
            style="fill: #905b30; opacity: 0.4; stroke-width: 0"
          />
          <path
            d="M34.4 19.2H49l-.2.1H34.1Z"
            style="fill: #905a30; opacity: 0.4; stroke-width: 0"
          />
          <path
            d="M34.4 19.2H49l-.2.1H34.1Z"
            style="fill: #8f5930; opacity: 0.4; stroke-width: 0"
          />
          <path
            d="M34.4 19.2H49l-.2.1H34.1Z"
            style="fill: #8e5930; opacity: 0.5; stroke-width: 0"
          />
          <path
            d="M34.4 19.2H49l-.2.1H34.1Z"
            style="fill: #8d5830; opacity: 0.5; stroke-width: 0"
          />
          <path
            d="M34.4 19.2H49l-.2.1H34.1Z"
            style="fill: #8c572f; opacity: 0.5; stroke-width: 0"
          />
          <path
            d="M34.4 19.2H49l-.2.1H34.1Z"
            style="fill: #8b562f; opacity: 0.5; stroke-width: 0"
          />
          <path
            d="M34.4 19.2H49l-.2.1H34.1Z"
            style="fill: #8a552f; opacity: 0.5; stroke-width: 0"
          />
          <path
            d="M34.4 19.2H49l-.2.1H34.1Z"
            style="opacity: 0.5; fill: #89552f; stroke-width: 0"
          />
          <path
            d="M34.4 19.2H49 34.1Z"
            style="fill: #88542f; opacity: 0.5; stroke-width: 0"
          />
          <path
            d="M34.4 19.2H49 34.1Z"
            style="fill: #87532e; opacity: 0.5; stroke-width: 0"
          />
          <path
            d="M34.4 19.2H49 34.1Z"
            style="fill: #86522e; opacity: 0.5; stroke-width: 0"
          />
          <path
            d="M34.4 19.2H49 34.1Z"
            style="opacity: 0.6; fill: #85522e; stroke-width: 0"
          />
          <path
            d="M34.4 19.2H49 34.1Z"
            style="fill: #84512e; opacity: 0.6; stroke-width: 0"
          />
          <path
            d="M34.4 19.2H49 34.1Z"
            style="fill: #83502d; opacity: 0.6; stroke-width: 0"
          />
          <path
            d="M34.4 19.2H49 34.1Z"
            style="fill: #824f2d; opacity: 0.6; stroke-width: 0"
          />
          <path
            d="M34.4 19.2H49 34.1Z"
            style="fill: #814f2d; opacity: 0.6; stroke-width: 0"
          />
          <path
            d="M34.4 19.2H49 34.1Z"
            style="fill: #804e2d; opacity: 0.6; stroke-width: 0"
          />
          <path
            d="M34.4 19.3H49 34.3Z"
            style="fill: #7f4d2d; opacity: 0.6; stroke-width: 0"
          />
          <path
            d="M34.4 19.3H49 34.3Z"
            style="fill: #7e4c2c; opacity: 0.6; stroke-width: 0"
          />
          <path
            d="M34.4 19.3H49 34.3Z"
            style="fill: #7d4b2c; opacity: 0.6; stroke-width: 0"
          />
          <path
            d="M41.8 19.3h7.4H34.5h7.3Z"
            style="opacity: 0.7; fill: #7c4b2c; stroke-width: 0"
          />
        </g>
        <path
          d="M44.5 18.7s-.1 0-.1-.1v-.1s.4-.2.7-.5c.3-.2.6-.5.6-.5h.2c.1 0 .2.3.4.5.3.2.6.4.6.5 0 0 0 .1-.1.1h-2.4Zm-2.7 0h.9v-.1s-.2-.2-.4-.3c-.2-.1-.3-.3-.3-.3h-.2l-.3.3c-.2.1-.4.3-.4.3v.1h.9Zm-2.8 0s.1 0 .1-.1v-.1s-.4-.2-.7-.5c-.3-.2-.6-.5-.6-.5h-.2s-.2.3-.4.5c-.3.2-.6.4-.6.5 0 0 0 .1.1.1h2.4Zm-4.4.1h.4c.2 0 .2-.2 0-.3l-.6-.4c0 .2.1.4.1.6Zm14.5-.7s-.5.3-.6.4c-.1.1-.1.3 0 .3h.4c0-.2 0-.4.1-.6Z"
          style="fill: url(#linear-gradient-27); stroke-width: 0"
        />
        <path
          d="M38.9 17.8c-.4-.3-.6-.7-.7-.9h-1.1c0 .4-.3.7-.7 1h2.4Z"
          style="
            mix-blend-mode: multiply;
            fill: url(#linear-gradient-28);
            stroke-width: 0;
          "
        />
        <path
          d="M37.7 17h-.5c-.2 0-.3 0-.3-.3 0-.2 0-.3.3-.3h1.2c.2 0 .3 0 .3.3 0 .2 0 .3-.3.3h-.6Z"
          style="fill: url(#linear-gradient-29); stroke-width: 0"
        />
        <g class="cls-526" style="clip-path: url(#clippath-5)">
          <g class="cls-527">
            <path
              class="cls-481"
              d="M37.7 17h-.5c-.2 0-.3 0-.3-.3 0-.2 0-.3.3-.3h1.2c.2 0 .3 0 .3.3 0 .2 0 .3-.3.3h-.6Z"
            />
          </g>
          <g class="cls-530">
            <path
              class="cls-452"
              d="M37.7 17h-.5c-.2 0-.3 0-.3-.3 0-.2 0-.3.3-.3h1.2c.2 0 .3 0 .3.3 0 .2 0 .3-.3.3h-.6Z"
            />
          </g>
          <g class="cls-534">
            <path
              class="cls-450"
              d="M37.7 17h-.5c-.2 0-.3 0-.3-.3 0-.2 0-.3.3-.3h1.2c.2 0 .3 0 .3.3 0 .2 0 .3-.3.3h-.6Z"
            />
          </g>
          <g class="cls-532">
            <path
              class="cls-509"
              d="M37.7 17h-.5c-.2 0-.3 0-.3-.3 0-.2 0-.3.3-.3h1.2c.2 0 .3 0 .3.3 0 .2 0 .3-.3.3h-.6Z"
            />
          </g>
          <g class="cls-531">
            <path
              class="cls-462"
              d="M37.7 17h-.5c-.2 0-.3 0-.3-.3 0-.2 0-.3.3-.3h1.2c.2 0 .3 0 .3.3 0 .2 0 .3-.3.3h-.6Z"
            />
          </g>
          <g class="cls-536">
            <path
              class="cls-427"
              d="M37.7 17h-.5c-.2 0-.3 0-.3-.3 0-.2 0-.3.3-.3h1.2c.2 0 .3 0 .3.3 0 .2 0 .3-.3.3h-.6Z"
            />
          </g>
          <g class="cls-535">
            <path
              class="cls-486"
              d="M37.7 17h-.5c-.2 0-.3 0-.3-.3 0-.2 0-.3.3-.3h1.2c.2 0 .3 0 .3.3 0 .2 0 .3-.3.3h-.6Z"
            />
          </g>
          <g class="cls-545">
            <path
              class="cls-432"
              d="M37.7 17h-.5c-.2 0-.3 0-.3-.3 0-.2 0-.3.3-.3h1.2c.2 0 .3 0 .3.3 0 .2 0 .3-.3.3h-.6Z"
            />
          </g>
          <g class="cls-542">
            <path
              class="cls-491"
              d="M37.7 17h-.5c-.2 0-.3 0-.3-.3 0-.2 0-.3.3-.3h1.2c.2 0 .3 0 .3.3 0 .2 0 .3-.3.3h-.6Z"
            />
          </g>
          <g class="cls-539">
            <path
              class="cls-503"
              d="M37.7 17h-.5c-.2 0-.3 0-.3-.3 0-.2 0-.3.3-.3h1.2c.2 0 .3 0 .3.3 0 .2 0 .3-.3.3h-.6Z"
            />
          </g>
          <g class="cls-541">
            <path
              class="cls-467"
              d="M37.7 17h-.5c-.2 0-.3 0-.3-.3 0-.2 0-.3.3-.3h1.2c.2 0 .3 0 .3.3 0 .2 0 .3-.3.3h-.6Z"
            />
          </g>
          <g class="cls-538">
            <path
              class="cls-483"
              d="M37.7 17h-.5c-.2 0-.3 0-.3-.3 0-.2 0-.3.3-.3h1.2c.2 0 .3 0 .3.3 0 .2 0 .3-.3.3h-.6Z"
            />
          </g>
          <g class="cls-553">
            <path
              class="cls-448"
              d="M37.7 17h-.5c-.2 0-.3 0-.3-.3 0-.2 0-.3.3-.3h1.2c.2 0 .3 0 .3.3 0 .2 0 .3-.3.3h-.6Z"
            />
          </g>
          <g class="cls-550">
            <path
              class="cls-461"
              d="M37.7 17h-.5c-.2 0-.3 0-.3-.3 0-.2 0-.3.3-.3h1.2c.2 0 .3 0 .3.3 0 .2 0 .3-.3.3h-.6Z"
            />
          </g>
          <g class="cls-552">
            <path
              class="cls-484"
              d="M37.7 17h-.5c-.2 0-.3 0-.3-.3 0-.2 0-.3.3-.3h1.2c.2 0 .3 0 .3.3 0 .2 0 .3-.3.3h-.6Z"
            />
          </g>
          <g class="cls-549">
            <path
              class="cls-501"
              d="M37.7 17h-.5c-.2 0-.3 0-.3-.3 0-.2 0-.3.3-.3h1.2c.2 0 .3 0 .3.3 0 .2 0 .3-.3.3h-.6Z"
            />
          </g>
          <g class="cls-546">
            <path
              class="cls-429"
              d="M37.7 17h-.5c-.2 0-.3 0-.3-.3 0-.2 0-.3.3-.3h1.2c.2 0 .3 0 .3.3 0 .2 0 .3-.3.3h-.6Z"
            />
          </g>
          <g class="cls-555">
            <path
              class="cls-511"
              d="M37.7 17h-.5c-.2 0-.3 0-.3-.3 0-.2 0-.3.3-.3h1.2c.2 0 .3 0 .3.3 0 .2 0 .3-.3.3h-.6Z"
            />
          </g>
          <path
            class="cls-479"
            d="M37.7 17h-.5c-.2 0-.3 0-.3-.3 0-.2 0-.3.3-.3h1.2c.2 0 .3 0 .3.3 0 .2 0 .3-.3.3h-.6Z"
          />
        </g>
        <path
          d="M44.6 17.8c.4-.3.6-.7.7-.9h1.1c0 .4.3.7.7 1h-2.4Z"
          style="
            fill: url(#linear-gradient-30);
            mix-blend-mode: multiply;
            stroke-width: 0;
          "
        />
        <path
          d="M45.9 17h.5c.2 0 .3 0 .3-.3 0-.2 0-.3-.3-.3h-1.2c-.2 0-.3 0-.3.3 0 .2 0 .3.3.3h.6Z"
          style="fill: url(#linear-gradient-31); stroke-width: 0"
        />
        <g class="cls-526" style="clip-path: url(#clippath-6)">
          <g class="cls-527">
            <path
              class="cls-481"
              d="M45.9 17h.5c.2 0 .3 0 .3-.3 0-.2 0-.3-.3-.3h-1.2c-.2 0-.3 0-.3.3 0 .2 0 .3.3.3h.6Z"
            />
          </g>
          <g class="cls-530">
            <path
              class="cls-452"
              d="M45.9 17h.5c.2 0 .3 0 .3-.3 0-.2 0-.3-.3-.3h-1.2c-.2 0-.3 0-.3.3 0 .2 0 .3.3.3h.6Z"
            />
          </g>
          <g class="cls-534">
            <path
              class="cls-450"
              d="M45.9 17h.5c.2 0 .3 0 .3-.3 0-.2 0-.3-.3-.3h-1.2c-.2 0-.3 0-.3.3 0 .2 0 .3.3.3h.6Z"
            />
          </g>
          <g class="cls-532">
            <path
              class="cls-509"
              d="M45.9 17h.5c.2 0 .3 0 .3-.3 0-.2 0-.3-.3-.3h-1.2c-.2 0-.3 0-.3.3 0 .2 0 .3.3.3h.6Z"
            />
          </g>
          <g class="cls-531">
            <path
              class="cls-462"
              d="M45.9 17h.5c.2 0 .3 0 .3-.3 0-.2 0-.3-.3-.3h-1.2c-.2 0-.3 0-.3.3 0 .2 0 .3.3.3h.6Z"
            />
          </g>
          <g class="cls-536">
            <path
              class="cls-427"
              d="M45.9 17h.5c.2 0 .3 0 .3-.3 0-.2 0-.3-.3-.3h-1.2c-.2 0-.3 0-.3.3 0 .2 0 .3.3.3h.6Z"
            />
          </g>
          <g class="cls-535">
            <path
              class="cls-486"
              d="M45.9 17h.5c.2 0 .3 0 .3-.3 0-.2 0-.3-.3-.3h-1.2c-.2 0-.3 0-.3.3 0 .2 0 .3.3.3h.6Z"
            />
          </g>
          <g class="cls-545">
            <path
              class="cls-432"
              d="M45.9 17h.5c.2 0 .3 0 .3-.3 0-.2 0-.3-.3-.3h-1.2c-.2 0-.3 0-.3.3 0 .2 0 .3.3.3h.6Z"
            />
          </g>
          <g class="cls-542">
            <path
              class="cls-491"
              d="M45.9 17h.5c.2 0 .3 0 .3-.3 0-.2 0-.3-.3-.3h-1.2c-.2 0-.3 0-.3.3 0 .2 0 .3.3.3h.6Z"
            />
          </g>
          <g class="cls-539">
            <path
              class="cls-503"
              d="M45.9 17h.5c.2 0 .3 0 .3-.3 0-.2 0-.3-.3-.3h-1.2c-.2 0-.3 0-.3.3 0 .2 0 .3.3.3h.6Z"
            />
          </g>
          <g class="cls-541">
            <path
              class="cls-467"
              d="M45.9 17h.5c.2 0 .3 0 .3-.3 0-.2 0-.3-.3-.3h-1.2c-.2 0-.3 0-.3.3 0 .2 0 .3.3.3h.6Z"
            />
          </g>
          <g class="cls-538">
            <path
              class="cls-483"
              d="M45.9 17h.5c.2 0 .3 0 .3-.3 0-.2 0-.3-.3-.3h-1.2c-.2 0-.3 0-.3.3 0 .2 0 .3.3.3h.6Z"
            />
          </g>
          <g class="cls-553">
            <path
              class="cls-448"
              d="M45.9 17h.5c.2 0 .3 0 .3-.3 0-.2 0-.3-.3-.3h-1.2c-.2 0-.3 0-.3.3 0 .2 0 .3.3.3h.6Z"
            />
          </g>
          <g class="cls-550">
            <path
              class="cls-461"
              d="M45.9 17h.5c.2 0 .3 0 .3-.3 0-.2 0-.3-.3-.3h-1.2c-.2 0-.3 0-.3.3 0 .2 0 .3.3.3h.6Z"
            />
          </g>
          <g class="cls-552">
            <path
              class="cls-484"
              d="M45.9 17h.5c.2 0 .3 0 .3-.3 0-.2 0-.3-.3-.3h-1.2c-.2 0-.3 0-.3.3 0 .2 0 .3.3.3h.6Z"
            />
          </g>
          <g class="cls-549">
            <path
              class="cls-501"
              d="M45.9 17h.5c.2 0 .3 0 .3-.3 0-.2 0-.3-.3-.3h-1.2c-.2 0-.3 0-.3.3 0 .2 0 .3.3.3h.6Z"
            />
          </g>
          <g class="cls-546">
            <path
              class="cls-429"
              d="M45.9 17h.5c.2 0 .3 0 .3-.3 0-.2 0-.3-.3-.3h-1.2c-.2 0-.3 0-.3.3 0 .2 0 .3.3.3h.6Z"
            />
          </g>
          <g class="cls-555">
            <path
              class="cls-511"
              d="M45.9 17h.5c.2 0 .3 0 .3-.3 0-.2 0-.3-.3-.3h-1.2c-.2 0-.3 0-.3.3 0 .2 0 .3.3.3h.6Z"
            />
          </g>
          <path
            class="cls-479"
            d="M45.9 17h.5c.2 0 .3 0 .3-.3 0-.2 0-.3-.3-.3h-1.2c-.2 0-.3 0-.3.3 0 .2 0 .3.3.3h.6Z"
          />
        </g>
        <path
          d="M42.3 15.8c0 .3-.2.5-.5.5s-.5-.2-.5-.5.2-.5.5-.5.5.2.5.5Z"
          style="fill: url(#radial-gradient-21); stroke-width: 0"
        />
        <path
          class="cls-280"
          d="M41.2 15.8c0-.3.2-.6.6-.6.3 0 .6.2.6.6 0 .3-.2.6-.6.6-.3 0-.6-.2-.6-.6Zm0 0c0 .3.2.5.5.5s.5-.2.5-.5-.2-.5-.5-.5-.5.2-.5.5Z"
        />
        <path
          d="M34.2 17.3c-.2 0-.4-.1-.5-.4-.1-.3 0-.6.2-.6.1 0 .3.2.4.4.1.3 0 .6 0 .6Z"
          style="fill: url(#radial-gradient-22); stroke-width: 0"
        />
        <path
          class="cls-280"
          d="M33.7 16.9v-.3c0-.2 0-.3.2-.4.1 0 .3.2.4.5v.4c0 .1 0 .2-.1.2-.2 0-.4-.2-.5-.4Zm.2-.6c-.1 0-.2.2-.2.4v.3c0 .2.3.4.4.4V16.8c0-.3-.3-.4-.4-.4Z"
        />
        <path
          d="M49.3 17.3c.2 0 .4-.1.5-.4.1-.3 0-.6-.2-.6-.1 0-.3.2-.4.4-.1.3 0 .6 0 .6Z"
          style="fill: url(#radial-gradient-23); stroke-width: 0"
        />
        <path
          class="cls-280"
          d="M49.3 17.3c.2 0 .4-.2.4-.4v-.3c0-.2 0-.3-.2-.4-.1 0-.3.2-.4.4V17.2s-.1-.1-.1-.2v-.4c0-.3.3-.5.4-.5.1 0 .2.2.2.4v.3c0 .2-.3.4-.5.4Z"
        />
        <path
          class="cls-398"
          d="M37.1 16.5h-.2v.2c0 .1.1.2.2.2h.5c.3 0 .6-.1.6-.1h.2c.1 0 0-.1 0-.2s-.1-.2-.2-.2H37Zm.6.5h-.5c-.2 0-.3 0-.3-.3s0-.3.3-.3h1.2c.2 0 .3 0 .3.3 0 .2 0 .3-.3.3h-.6Z"
        />
        <path
          class="cls-199"
          d="M37.1 16.5h-.2v.2c0 .1.1.2.2.2h.5c.3 0 .6-.1.6-.1h.2c.1 0 0-.1 0-.2s-.1-.2-.2-.2H37Zm.6.5h-.5c-.2 0-.3 0-.3-.3s0-.3.3-.3h1.2c.2 0 .3 0 .3.3 0 .2 0 .3-.3.3h-.6Z"
        />
        <path
          class="cls-33"
          d="M37.1 16.5h-.2v.2c0 .1.1.2.2.2h.5c.3 0 .6-.1.6-.1h.2v-.2c0-.1-.1-.2-.2-.2H37Zm.6.5h-.5c-.2 0-.3 0-.3-.3s0-.3.3-.3h1.2c.2 0 .3 0 .3.3 0 .2 0 .3-.3.3h-.6Z"
        />
        <path
          class="cls-302"
          d="M37.1 16.5h-.2v.2c0 .1.1.2.3.2h.5c.3 0 .6-.1.6-.1h.2v-.2c0-.1-.1-.2-.3-.2H37Zm.6.5h-.5c-.2 0-.3 0-.3-.3s0-.3.3-.3h1.2c.2 0 .3 0 .3.3 0 .2 0 .3-.3.3h-.6Z"
        />
        <path
          class="cls-232"
          d="M37.1 16.5h-.2v.2c0 .1.1.2.3.2h.5c.3 0 .6-.1.6-.1h.2v-.2c0-.1-.1-.2-.3-.2H37Zm.6.5h-.5c-.2 0-.3 0-.3-.3s0-.3.3-.3h1.2c.2 0 .3 0 .3.3 0 .2 0 .3-.3.3h-.6Z"
        />
        <path
          class="cls-45"
          d="M37.1 16.5h-.2v.2c0 .1.1.2.3.2h.5c.3 0 .6-.1.6-.1h.2v-.2c0-.1-.1-.2-.3-.2H37Zm.6.5h-.5c-.2 0-.3 0-.3-.3s0-.3.3-.3h1.2c.2 0 .3 0 .3.3 0 .2 0 .3-.3.3h-.6Z"
        />
        <path
          class="cls-351"
          d="M37.1 16.5h-.2v.2c0 .1.1.2.3.2h.5c.3 0 .6-.1.6-.1h.2v-.2c0-.1-.1-.2-.3-.2H37Zm.6.5h-.5c-.2 0-.3 0-.3-.3s0-.3.3-.3h1.2c.2 0 .3 0 .3.3 0 .2 0 .3-.3.3h-.6Z"
        />
        <path
          class="cls-315"
          d="M37.1 17.1h.5c.3 0 .6-.1.6-.1.1 0 .3-.1.3-.3 0-.1-.1-.3-.3-.3H37c-.1 0-.3.1-.3.3 0 .1.1.3.3.3Zm.6-.1h-.5c-.2 0-.3 0-.3-.3s0-.3.3-.3h1.2c.2 0 .3 0 .3.3 0 .2 0 .3-.3.3h-.6Z"
        />
        <path
          class="cls-398"
          d="M45.4 16.4c-.1 0-.2 0-.2.2v.2h1.3c.1 0 .2 0 .2-.2v-.2c0-.1 0 0-.2 0h-1.2Zm-.1.6c-.2 0-.3-.2-.3-.3 0-.2.2-.3.3-.3h1.2c.2 0 .3.2.3.3 0 .2-.2.3-.3.3h-1.1Z"
        />
        <path
          class="cls-199"
          d="M45.4 16.4c-.1 0-.2 0-.2.2v.2h1.3c.1 0 .2 0 .2-.2v-.2c0-.1 0 0-.2 0h-1.2Zm-.1.6c-.2 0-.3-.2-.3-.3 0-.2.2-.3.3-.3h1.2c.2 0 .3.2.3.3 0 .2-.2.3-.3.3h-1.1Z"
        />
        <path
          class="cls-33"
          d="M45.4 16.4c-.1 0-.2 0-.2.2v.2h1.3c.1 0 .2 0 .2-.2v-.2c0-.1 0 0-.2 0h-1.2Zm-.1.6c-.2 0-.3-.2-.3-.3 0-.2.2-.3.3-.3h1.2c.2 0 .3.2.3.3 0 .2-.2.3-.3.3h-1.1Z"
        />
        <path
          class="cls-302"
          d="M45.4 16.4c-.1 0-.2 0-.3.2v.2h1.3c.1 0 .2 0 .3-.2v-.2h-1.4Zm-.1.6c-.2 0-.3-.2-.3-.3 0-.2.2-.3.3-.3h1.2c.2 0 .3.2.3.3 0 .2-.2.3-.3.3h-1.1Z"
        />
        <path
          class="cls-232"
          d="M45.4 16.4c-.1 0-.2 0-.3.2v.2h1.3c.1 0 .2 0 .3-.2v-.2h-1.4Zm-.1.6c-.2 0-.3-.2-.3-.3 0-.2.2-.3.3-.3h1.2c.2 0 .3.2.3.3 0 .2-.2.3-.3.3h-1.1Z"
        />
        <path
          class="cls-45"
          d="M45.4 16.4c-.1 0-.3 0-.3.2v.2h1.3c.1 0 .3 0 .3-.2v-.2h-1.4Zm-.1.6c-.2 0-.3-.2-.3-.3 0-.2.2-.3.3-.3h1.2c.2 0 .3.2.3.3 0 .2-.2.3-.3.3h-1.1Z"
        />
        <path
          class="cls-351"
          d="M45.4 16.4c-.1 0-.3.1-.3.2v.2h1.3c.1 0 .3-.1.3-.2v-.2h-1.4Zm-.1.6c-.2 0-.3-.2-.3-.3 0-.2.2-.3.3-.3h1.2c.2 0 .3.2.3.3 0 .2-.2.3-.3.3h-1.1Z"
        />
        <path
          class="cls-315"
          d="M46.5 17.1c.1 0 .3-.1.3-.3 0-.1-.1-.3-.3-.3h-1.2c-.1 0-.3.1-.3.3 0 .1.1.3.3.3h1.1Zm-1.2-.1c-.2 0-.3-.2-.3-.3 0-.2.2-.3.3-.3h1.2c.2 0 .3.2.3.3 0 .2-.2.3-.3.3h-1.1Z"
        />
        <path
          d="M41.8 13.9h-1.5s.2-1.1.2-2.4-.3-2-.7-2.3c-.1-.1 0-.3 0-.4s.1 0 .2 0c0 0 1 .3 1.7.3v5Z"
          style="fill: url(#linear-gradient-32); stroke-width: 0"
        />
        <path
          d="M41.8 13.9h1.5s-.2-1.1-.2-2.4.3-2 .7-2.3c.1-.1 0-.3 0-.4s-.1 0-.2 0c0 0-1 .3-1.7.3v5Z"
          style="fill: url(#linear-gradient-33); stroke-width: 0"
        />
        <g style="clip-path: url(#clippath-7)">
          <path
            d="M43.7 8.6h-.2s-1 .3-1.7.3-1.7-.3-1.7-.3h-.2c-.1.1-.2.3 0 .4.2.3.7 1 .7 2.3s-.2 2.4-.2 2.4h2.8s-.2-1.5-.2-2.4c0-1.4.5-2.1.7-2.3.1-.1 0-.3 0-.4Z"
            style="
              fill: url(#linear-gradient-34);
              mix-blend-mode: multiply;
              stroke-width: 0;
            "
          />
        </g>
        <g style="clip-path: url(#clippath-8)">
          <path class="cls-487" d="M41 13.9s.7-4.7-.8-5.3" />
          <path
            d="M41 13.9s.1-1.2.1-2.4-.2-2.6-.9-2.9c.6.2.9 1.2 1 2.9 0 1.2-.2 2.4-.2 2.4Z"
            style="fill: url(#linear-gradient-35); stroke-width: 0"
          />
          <path class="cls-487" d="M42.5 13.9s-.7-4.7.8-5.3" />
          <path
            d="M42.6 13.9s-.1-1.2-.1-2.4.2-2.6.9-2.9c-.6.2-.9 1.2-1 2.9 0 1.2.2 2.4.2 2.4Z"
            style="fill: url(#linear-gradient-36); stroke-width: 0"
          />
        </g>
        <path
          d="M42.2 10.1c0 .2-.2.4-.4.4s-.4-.2-.4-.4.2-.4.4-.4.4.2.4.4Z"
          style="fill: url(#radial-gradient-24); stroke-width: 0"
        />
        <path
          class="cls-280"
          d="M41.3 10.1c0-.2.2-.5.5-.5.2 0 .5.2.5.5 0 .2-.2.5-.5.5-.2 0-.5-.2-.5-.5Zm0 0c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4-.4.2-.4.4Z"
        />
        <path
          d="M42.2 11.1c0 .2-.2.4-.4.4s-.4-.2-.4-.4.2-.4.4-.4.4.2.4.4Z"
          style="fill: url(#radial-gradient-25); stroke-width: 0"
        />
        <path
          class="cls-280"
          d="M41.3 11.1c0-.2.2-.5.5-.5.2 0 .5.2.5.5 0 .2-.2.5-.5.5-.2 0-.5-.2-.5-.5Zm0 0c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4-.4.2-.4.4Z"
        />
        <path
          d="M42.2 12.1c0 .2-.2.4-.4.4s-.4-.2-.4-.4.2-.4.4-.4.4.2.4.4Z"
          style="fill: url(#radial-gradient-26); stroke-width: 0"
        />
        <path
          class="cls-280"
          d="M41.3 12.1c0-.2.2-.5.5-.5.2 0 .5.2.5.5 0 .2-.2.5-.5.5-.2 0-.5-.2-.5-.5Zm0 0c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4-.4.2-.4.4Z"
        />
        <path
          d="M42.2 13.2c0 .2-.2.4-.4.4s-.4-.2-.4-.4.2-.4.4-.4.4.2.4.4Z"
          style="fill: url(#radial-gradient-27); stroke-width: 0"
        />
        <path
          class="cls-280"
          d="M41.3 13.2c0-.2.2-.5.5-.5.2 0 .5.2.5.5 0 .2-.2.5-.5.5-.2 0-.5-.2-.5-.5Zm0 0c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4-.4.2-.4.4Z"
        />
        <path
          d="m41.8 21 1.3-.7-1.3-.7-1.3.7 1.3.7Z"
          style="opacity: 0.1; fill: #7c4b2c; stroke-width: 0"
        />
        <path
          d="m41.8 20.9 1.3-.7-1.3-.7-1.3.7 1.3.7Z"
          style="opacity: 0.1; fill: #7c4b2c; stroke-width: 0"
        />
        <path
          d="m41.8 20.9 1.3-.7-1.3-.7-1.3.7 1.3.7Z"
          style="opacity: 0.1; fill: #7c4b2c; stroke-width: 0"
        />
        <path
          d="m41.8 20.9 1.3-.7-1.3-.7-1.3.7 1.3.7Z"
          style="opacity: 0.1; fill: #7c4b2c; stroke-width: 0"
        />
        <path
          d="m41.8 20.9 1.3-.7-1.3-.7-1.3.7 1.3.7Z"
          style="opacity: 0.1; fill: #7c4b2c; stroke-width: 0"
        />
        <path
          d="m41.8 20.9 1.3-.7-1.3-.7-1.3.7 1.3.7Z"
          style="opacity: 0.1; fill: #7c4b2c; stroke-width: 0"
        />
        <path
          d="m41.8 20.9 1.3-.7-1.3-.7-1.3.7 1.3.7Z"
          style="opacity: 0.1; fill: #7c4b2c; stroke-width: 0"
        />
        <path
          d="m41.8 20.9 1.3-.7-1.3-.7-1.3.7 1.3.7Z"
          style="opacity: 0.2; fill: #7c4b2c; stroke-width: 0"
        />
        <path
          d="m41.8 20.9 1.3-.7-1.3-.7-1.3.7 1.3.7Z"
          style="opacity: 0.2; fill: #7c4b2c; stroke-width: 0"
        />
        <path
          d="m41.8 20.9 1.3-.7-1.3-.7-1.3.7 1.3.7Z"
          style="opacity: 0.2; fill: #7c4b2c; stroke-width: 0"
        />
        <path
          d="m41.8 20.9 1.3-.7-1.3-.7-1.3.7 1.3.7Z"
          style="opacity: 0.2; fill: #7c4b2c; stroke-width: 0"
        />
        <path
          d="m41.8 20.9 1.3-.7-1.3-.7-1.3.7 1.3.7Z"
          style="opacity: 0.2; fill: #7c4b2c; stroke-width: 0"
        />
        <path
          d="m41.8 20.9 1.3-.7-1.3-.7-1.3.7 1.3.7Z"
          style="opacity: 0.2; fill: #7c4b2c; stroke-width: 0"
        />
        <path
          d="m41.8 20.9 1.3-.7-1.3-.7-1.3.7 1.3.7Z"
          style="opacity: 0.2; fill: #7c4b2c; stroke-width: 0"
        />
        <path
          d="m41.8 20.9 1.3-.7-1.3-.7-1.3.7 1.3.7Z"
          style="opacity: 0.2; fill: #7c4b2c; stroke-width: 0"
        />
        <path
          d="m41.8 20.9 1.3-.7-1.3-.7-1.3.7 1.3.7Z"
          style="opacity: 0.2; fill: #7c4b2c; stroke-width: 0"
        />
        <path
          d="m41.8 20.9 1.3-.7-1.3-.7-1.3.7 1.3.7Z"
          style="opacity: 0.2; fill: #7c4b2c; stroke-width: 0"
        />
        <path
          d="m41.8 20.9 1.3-.7-1.3-.7-1.3.7 1.3.7Z"
          style="opacity: 0.2; fill: #7c4b2c; stroke-width: 0"
        />
        <path
          d="m41.8 20.9 1.3-.7-1.3-.7-1.3.7 1.3.7Z"
          style="opacity: 0.2; fill: #7c4b2c; stroke-width: 0"
        />
        <path
          d="m41.8 20.9 1.3-.7-1.3-.7-1.3.7 1.3.7Z"
          style="opacity: 0.2; fill: #7c4b2c; stroke-width: 0"
        />
        <path
          d="m41.8 20.9 1.3-.7-1.3-.7-1.3.7 1.3.7Z"
          style="opacity: 0.2; fill: #7c4b2c; stroke-width: 0"
        />
        <path
          d="m41.8 20.9 1.3-.7-1.3-.7-1.3.7 1.3.7Z"
          style="opacity: 0.3; fill: #7c4b2c; stroke-width: 0"
        />
        <path
          d="m41.8 20.9 1.3-.7-1.3-.7-1.3.7 1.3.7Z"
          style="opacity: 0.3; fill: #7c4b2c; stroke-width: 0"
        />
        <path
          d="m41.8 20.9 1.3-.7-1.3-.7-1.3.7 1.3.7Z"
          style="opacity: 0.3; fill: #7c4b2c; stroke-width: 0"
        />
        <path
          d="m41.8 20.9 1.3-.7-1.3-.7-1.3.7 1.3.7Z"
          style="opacity: 0.3; fill: #7c4b2c; stroke-width: 0"
        />
        <path
          d="m41.8 20.9 1.3-.7-1.3-.7-1.3.7 1.3.7Z"
          style="opacity: 0.3; fill: #7c4b2c; stroke-width: 0"
        />
        <path
          d="m41.8 20.9 1.3-.7-1.3-.7-1.3.7 1.3.7Z"
          style="opacity: 0.3; fill: #7c4b2c; stroke-width: 0"
        />
        <path
          d="M40.4 20.2h.6l.7-.4v-.3l-1.3.7Z"
          style="fill: url(#linear-gradient-37); stroke-width: 0"
        />
        <path
          d="M41.8 19.5v.3l.7.4h.6l-1.3-.7Z"
          style="fill: url(#linear-gradient-38); stroke-width: 0"
        />
        <path
          d="M43.1 20.2h-.6l-.7.4v.3l1.3-.7Z"
          style="fill: url(#linear-gradient-39); stroke-width: 0"
        />
        <path
          d="M41.8 20.9v-.3l-.7-.4h-.6l1.3.7Z"
          style="fill: url(#linear-gradient-40); stroke-width: 0"
        />
        <path
          d="m43.1 20.2-1.3.6v.1l1.3-.7z"
          style="fill: url(#linear-gradient-41); stroke-width: 0"
        />
        <path
          d="m41.8 20.6.8-.4-.8-.4-.8.4.8.4z"
          style="fill: url(#linear-gradient-42); stroke-width: 0"
        />
        <path class="cls-190" d="m41.8 19.8-.8.4.8.4-.7-.4Z" />
        <path class="cls-115" d="m41 20.2.8-.4-.8.4z" />
        <path
          d="m43.1 20.2-1.3.7v-.1l1.3-.6z"
          style="fill: url(#linear-gradient-43); stroke-width: 0"
        />
        <path class="cls-113" d="m42.5 20.2-.7.3v.1l.8-.4h-.1z" />
        <path
          d="m40.4 20.2 1.3-.7-1.3.7Z"
          style="fill: url(#linear-gradient-44); stroke-width: 0"
        />
        <path class="cls-115" d="M43.1 20.2h-.6.6z" />
        <path
          d="m40.5 20.2 1.3.6v.1l-1.4-.7h.1z"
          style="fill: url(#linear-gradient-45); stroke-width: 0"
        />
        <path d="m42.5 20.2-.7-.4.8.4" class="cls-115" />
        <path
          d="m43.1 20.2-1.3-.7 1.3.7z"
          style="fill: url(#linear-gradient-46); stroke-width: 0"
        />
        <path d="M35.8 20.2h-.9l-.5.4.4.3.9-.7Z" class="cls-211" />
        <path d="m35 20.8-.5-.2.4.3.1-.1z" class="cls-3" />
        <path d="m34.5 20.6.5-.4-.5-.3v.7z" class="cls-225" />
        <path
          d="m34.9 19.6-.4.3.5.3h.9l-1-.7Z"
          style="fill: url(#linear-gradient-47); stroke-width: 0"
        />
        <path d="M35.8 20.2H35l.8-.1v.1z" class="cls-389" />
        <path
          d="M35.8 20.2h-.9.9z"
          style="fill: url(#linear-gradient-48); stroke-width: 0"
        />
        <path
          d="m35 20.2-.5.4.5-.4z"
          style="fill: url(#linear-gradient-49); stroke-width: 0"
        />
        <path
          d="m34.9 19.6-.4.3.4-.3z"
          style="fill: url(#linear-gradient-50); stroke-width: 0"
        />
        <path d="m35 20.2-.5-.3.5.3" class="cls-389" />
        <path d="m48.6 20.9.4-.3-.5-.4h-.9l.9.7Z" class="cls-211" />
        <path d="m48.6 20.8.4-.2h.1l-.5.3v-.1z" class="cls-3" />
        <path d="m49.1 20.6-.5-.4.5-.3v.7z" class="cls-225" />
        <path
          d="M47.7 20.2h.9l.5-.3-.4-.3-1 .6Z"
          style="fill: url(#linear-gradient-51); stroke-width: 0"
        />
        <path d="M47.7 20.2h.9l-.8-.1-.1.1z" class="cls-389" />
        <path
          d="M47.8 20.2h.8-.9.1z"
          style="fill: url(#linear-gradient-52); stroke-width: 0"
        />
        <path
          d="m48.6 20.2.5.4-.5-.4z"
          style="fill: url(#linear-gradient-53); stroke-width: 0"
        />
        <path
          d="m48.7 19.6.4.3-.4-.3z"
          style="fill: url(#linear-gradient-54); stroke-width: 0"
        />
        <path d="m48.6 20.2.5-.3-.5.3" class="cls-389" />
        <path
          d="M43.3 7.4c0 .9-.7 1.6-1.6 1.6s-1.6-.7-1.6-1.6.7-1.6 1.6-1.6 1.6.7 1.6 1.6Z"
          style="fill: url(#radial-gradient-28); stroke-width: 0"
        />
        <path
          d="M43.3 7.1h-1.2V5.5h-.6v1.6h-1.2v.6h3.1v-.6Z"
          style="fill: url(#linear-gradient-55); stroke-width: 0"
        />
        <path
          d="m42.6 5.7-.4-.6v-.3h.3l.5.5V3.4l-.5.5h-.3v-.3l.4-.6H41l.4.6v.3h-.3l-.5-.5v1.9l.5-.5h.3v.3l-.4.6h1.7Z"
          style="fill: url(#radial-gradient-29); stroke-width: 0"
        />
        <path d="M40.2 7.2Z" class="cls-41" />
        <path
          d="M43.3 7.7h-3.1 3.1Z"
          style="fill: url(#linear-gradient-56); stroke-width: 0"
        />
        <path
          d="M42.1 7.1V5.9v1.2Z"
          style="fill: url(#linear-gradient-57); stroke-width: 0"
        />
        <path d="M42.1 7.2V5.9v1.3Z" class="cls-67" />
        <path
          d="M41.5 7.1V5.9v1.2Z"
          style="fill: url(#linear-gradient-58); stroke-width: 0"
        />
        <path d="M41.5 7.2V5.9v1.3Z" class="cls-67" />
        <path
          d="M42.1 7.2h1.2-1.2Z"
          style="fill: url(#linear-gradient-59); stroke-width: 0"
        />
        <path
          d="M41.5 7.1h-1.2 1.2Z"
          style="fill: url(#linear-gradient-60); stroke-width: 0"
        />
        <path
          d="M42.1 4.4c0 .2-.2.4-.4.4s-.4-.2-.4-.4.2-.4.4-.4.4.2.4.4Z"
          style="fill: url(#radial-gradient-30); stroke-width: 0"
        />
        <path
          d="M41.4 4.4c0-.2.2-.4.4-.4s.4.2.4.4-.2.4-.4.4-.4-.2-.4-.4Zm0 0c0 .2.2.3.3.3.2 0 .3-.2.3-.3 0-.2-.2-.3-.3-.3-.2 0-.3.2-.3.3Z"
          class="cls-280"
        />
        <path
          d="M42.2 9.1c0 .2-.2.4-.4.4s-.4-.2-.4-.4.2-.4.4-.4.4.2.4.4Z"
          style="fill: url(#radial-gradient-31); stroke-width: 0"
        />
        <path
          d="M41.3 9.1c0-.2.2-.5.5-.5.2 0 .5.2.5.5 0 .2-.2.5-.5.5-.2 0-.5-.2-.5-.5Zm0 0c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4-.4.2-.4.4Z"
          class="cls-280"
        />
      </g>
    </g>
  </svg>
</template>

<style scoped>
.cls-1 {
  fill: #d6e8e7;
}

.cls-1,
.cls-106,
.cls-107,
.cls-108,
.cls-109,
.cls-11,
.cls-110,
.cls-111,
.cls-112,
.cls-113,
.cls-115,
.cls-116,
.cls-117,
.cls-12,
.cls-120,
.cls-13,
.cls-14,
.cls-15,
.cls-156,
.cls-159,
.cls-160,
.cls-161,
.cls-163,
.cls-164,
.cls-168,
.cls-170,
.cls-173,
.cls-174,
.cls-175,
.cls-176,
.cls-177,
.cls-178,
.cls-180,
.cls-181,
.cls-183,
.cls-185,
.cls-186,
.cls-187,
.cls-19,
.cls-190,
.cls-192,
.cls-197,
.cls-198,
.cls-199,
.cls-2,
.cls-20,
.cls-200,
.cls-201,
.cls-204,
.cls-205,
.cls-207,
.cls-208,
.cls-209,
.cls-210,
.cls-211,
.cls-213,
.cls-214,
.cls-216,
.cls-217,
.cls-218,
.cls-22,
.cls-220,
.cls-221,
.cls-224,
.cls-225,
.cls-228,
.cls-232,
.cls-233,
.cls-235,
.cls-236,
.cls-237,
.cls-238,
.cls-239,
.cls-24,
.cls-240,
.cls-241,
.cls-242,
.cls-243,
.cls-244,
.cls-255,
.cls-258,
.cls-259,
.cls-26,
.cls-260,
.cls-262,
.cls-263,
.cls-266,
.cls-269,
.cls-27,
.cls-270,
.cls-272,
.cls-273,
.cls-274,
.cls-275,
.cls-280,
.cls-281,
.cls-282,
.cls-284,
.cls-285,
.cls-288,
.cls-289,
.cls-291,
.cls-292,
.cls-293,
.cls-294,
.cls-295,
.cls-297,
.cls-298,
.cls-299,
.cls-3,
.cls-300,
.cls-301,
.cls-302,
.cls-303,
.cls-307,
.cls-309,
.cls-31,
.cls-311,
.cls-312,
.cls-313,
.cls-314,
.cls-315,
.cls-316,
.cls-318,
.cls-319,
.cls-320,
.cls-322,
.cls-324,
.cls-325,
.cls-327,
.cls-328,
.cls-329,
.cls-33,
.cls-330,
.cls-334,
.cls-335,
.cls-336,
.cls-337,
.cls-339,
.cls-340,
.cls-342,
.cls-344,
.cls-346,
.cls-349,
.cls-350,
.cls-351,
.cls-353,
.cls-354,
.cls-355,
.cls-357,
.cls-358,
.cls-359,
.cls-361,
.cls-362,
.cls-364,
.cls-365,
.cls-367,
.cls-37,
.cls-370,
.cls-371,
.cls-372,
.cls-374,
.cls-377,
.cls-378,
.cls-382,
.cls-384,
.cls-386,
.cls-388,
.cls-389,
.cls-39,
.cls-391,
.cls-393,
.cls-395,
.cls-398,
.cls-40,
.cls-401,
.cls-402,
.cls-404,
.cls-407,
.cls-409,
.cls-41,
.cls-411,
.cls-413,
.cls-415,
.cls-419,
.cls-43,
.cls-44,
.cls-45,
.cls-48,
.cls-49,
.cls-5,
.cls-52,
.cls-53,
.cls-54,
.cls-56,
.cls-59,
.cls-62,
.cls-63,
.cls-64,
.cls-66,
.cls-67,
.cls-68,
.cls-69,
.cls-71,
.cls-72,
.cls-74,
.cls-77,
.cls-78,
.cls-79,
.cls-8,
.cls-80,
.cls-81,
.cls-82,
.cls-83,
.cls-84,
.cls-9 {
  stroke-width: 0;
}

.cls-2 {
  fill: #579559;
}

.cls-41,
.cls-423,
.cls-424,
.cls-425,
.cls-427,
.cls-428,
.cls-429,
.cls-430,
.cls-432,
.cls-433,
.cls-436,
.cls-438,
.cls-439,
.cls-441,
.cls-442,
.cls-444,
.cls-445,
.cls-448,
.cls-450,
.cls-451,
.cls-452,
.cls-453,
.cls-455,
.cls-456,
.cls-457,
.cls-458,
.cls-459,
.cls-460,
.cls-461,
.cls-462,
.cls-463,
.cls-464,
.cls-466,
.cls-467,
.cls-468,
.cls-469,
.cls-470,
.cls-471,
.cls-472,
.cls-474,
.cls-475,
.cls-476,
.cls-477,
.cls-479,
.cls-480,
.cls-481,
.cls-483,
.cls-484,
.cls-485,
.cls-486,
.cls-487,
.cls-488,
.cls-489,
.cls-490,
.cls-491,
.cls-492,
.cls-493,
.cls-494,
.cls-495,
.cls-496,
.cls-497,
.cls-498,
.cls-501,
.cls-502,
.cls-503,
.cls-505,
.cls-506,
.cls-508,
.cls-509,
.cls-510,
.cls-511 {
  fill: none;
}

.cls-423,
.cls-424,
.cls-425,
.cls-428,
.cls-430,
.cls-433,
.cls-436,
.cls-438,
.cls-439,
.cls-442,
.cls-444,
.cls-445,
.cls-451,
.cls-453,
.cls-455,
.cls-456,
.cls-457,
.cls-458,
.cls-459,
.cls-460,
.cls-463,
.cls-464,
.cls-466,
.cls-468,
.cls-469,
.cls-470,
.cls-471,
.cls-472,
.cls-474,
.cls-477,
.cls-480,
.cls-485,
.cls-487,
.cls-488,
.cls-489,
.cls-490,
.cls-492,
.cls-493,
.cls-494,
.cls-495,
.cls-496,
.cls-497,
.cls-498,
.cls-502,
.cls-505,
.cls-506,
.cls-508,
.cls-510 {
  stroke-miterlimit: 10;
}

.cls-3 {
  fill: #88151b;
}

.cls-185,
.cls-297,
.cls-298,
.cls-299,
.cls-340,
.cls-353,
.cls-367,
.cls-401,
.cls-411,
.cls-49,
.cls-52,
.cls-64,
.cls-67,
.cls-72,
.cls-81 {
  fill: #7c4b2c;
}

.cls-106,
.cls-111,
.cls-12,
.cls-13,
.cls-14,
.cls-15,
.cls-173,
.cls-181,
.cls-199,
.cls-201,
.cls-216,
.cls-217,
.cls-218,
.cls-232,
.cls-238,
.cls-239,
.cls-243,
.cls-262,
.cls-266,
.cls-273,
.cls-284,
.cls-285,
.cls-289,
.cls-293,
.cls-302,
.cls-309,
.cls-314,
.cls-315,
.cls-318,
.cls-325,
.cls-33,
.cls-335,
.cls-336,
.cls-350,
.cls-351,
.cls-365,
.cls-372,
.cls-386,
.cls-389,
.cls-391,
.cls-395,
.cls-398,
.cls-402,
.cls-415,
.cls-45,
.cls-5,
.cls-77,
.cls-82,
.cls-83 {
  fill: #fff;
}

.cls-213,
.cls-382,
.cls-5 {
  opacity: 0.4;
}

.cls-8 {
  fill: #ddebea;
}

.cls-9 {
  opacity: 0;
}

.cls-156,
.cls-174,
.cls-205,
.cls-24,
.cls-255,
.cls-270,
.cls-295,
.cls-319,
.cls-359,
.cls-361,
.cls-40,
.cls-59,
.cls-66,
.cls-79,
.cls-9 {
  fill: #b77939;
}

.cls-11 {
  fill: #daeae8;
}

.cls-12,
.cls-175,
.cls-377 {
  opacity: 0.2;
}

.cls-13 {
  opacity: 0.1;
}

.cls-423 {
  stroke: #ffe171;
  stroke-width: 0.2px;
}

.cls-14,
.cls-329,
.cls-84 {
  opacity: 0.8;
}

.cls-15 {
  opacity: 0;
}

.cls-424 {
  stroke: #d99c32;
  stroke-width: 0.7px;
}

.cls-425 {
  stroke: #fbd24d;
  stroke-width: 0.3px;
}

.cls-108 {
  fill: #9c6433;
}

.cls-19 {
  fill: #c0dddb;
}

.cls-117,
.cls-20,
.cls-204,
.cls-207,
.cls-260,
.cls-263,
.cls-274,
.cls-307,
.cls-334,
.cls-339,
.cls-355,
.cls-370,
.cls-419,
.cls-48 {
  fill: #f8d043;
}

.cls-20,
.cls-315 {
  opacity: 0.5;
}

.cls-22 {
  fill: #85522e;
}

.cls-22,
.cls-346,
.cls-395 {
  opacity: 0.8;
}

.cls-427 {
  stroke-width: 0.2px;
}

.cls-427,
.cls-429,
.cls-432,
.cls-439,
.cls-441,
.cls-448,
.cls-450,
.cls-452,
.cls-461,
.cls-462,
.cls-467,
.cls-475,
.cls-476,
.cls-479,
.cls-481,
.cls-483,
.cls-484,
.cls-486,
.cls-491,
.cls-501,
.cls-503,
.cls-509,
.cls-511 {
  stroke: #fff;
}

.cls-24 {
  opacity: 0.2;
}

.cls-26 {
  fill: #538455;
}

.cls-27 {
  fill: #273d28;
}

.cls-31 {
  fill: #bddcd9;
}

.cls-428 {
  stroke: #dfa131;
  stroke-width: 0.7px;
}

.cls-33 {
  opacity: 0.2;
}

.cls-37 {
  fill: #7d9ca6;
}

.cls-39 {
  fill: #8fc2b4;
}

.cls-40 {
  opacity: 0.4;
}

.cls-43 {
  fill: #a96e36;
}

.cls-258,
.cls-365,
.cls-43 {
  opacity: 0.2;
}

.cls-44 {
  fill: #558e58;
}

.cls-45 {
  opacity: 0.3;
}

.cls-429 {
  stroke-width: 0;
}

.cls-430 {
  stroke: #fdd457;
  stroke-width: 0.3px;
}

.cls-514 {
  opacity: 0;
}

.cls-48 {
  opacity: 0.4;
}

.cls-515 {
  opacity: 0;
}

.cls-49 {
  opacity: 0.3;
}

.cls-320 {
  fill: #8e5930;
}

.cls-516,
.cls-52 {
  opacity: 0;
}

.cls-53 {
  fill: #da202a;
}

.cls-54 {
  fill: #405e42;
}

.cls-432 {
  stroke-width: 0.2px;
}

.cls-56 {
  fill: #3e5b40;
}

.cls-433 {
  stroke: #ffdb58;
}

.cls-433,
.cls-436,
.cls-442,
.cls-456,
.cls-463,
.cls-464,
.cls-470,
.cls-492,
.cls-495,
.cls-508 {
  stroke-width: 0.2px;
}

.cls-436 {
  stroke: #ffe277;
}

.cls-59 {
  opacity: 0;
}

.cls-62 {
  fill: #4f7652;
}

.cls-63 {
  fill: #88bca9;
}

.cls-64,
.cls-66 {
  opacity: 0.2;
}

.cls-438 {
  stroke: #bd7f38;
  stroke-width: 0.8px;
}

.cls-269,
.cls-318,
.cls-339,
.cls-359,
.cls-411,
.cls-439,
.cls-517 {
  opacity: 0;
}

.cls-439,
.cls-479 {
  stroke-width: 0;
}

.cls-68 {
  fill: #64a06f;
}

.cls-69 {
  fill: #b0d5d3;
}

.cls-71 {
  fill: #528255;
}

.cls-72 {
  opacity: 0.1;
}

.cls-441 {
  stroke-width: 0.3px;
}

.cls-74 {
  fill: #375339;
}

.cls-77 {
  opacity: 0.2;
}

.cls-78 {
  fill: #4a6c4c;
}

.cls-79 {
  opacity: 0.4;
}

.cls-80 {
  fill: #466648;
}

.cls-442 {
  stroke: #ffda59;
}

.cls-81 {
  opacity: 0.3;
}

.cls-197,
.cls-320,
.cls-82,
.cls-83 {
  opacity: 0.7;
}

.cls-84 {
  fill: #89552f;
}

.cls-444 {
  stroke: #c28436;
  stroke-width: 0.8px;
}

.cls-106,
.cls-487 {
  opacity: 0.8;
}

.cls-107 {
  fill: #e0edeb;
}

.cls-108,
.cls-273,
.cls-316 {
  opacity: 0.5;
}

.cls-109 {
  fill: #b9dad8;
}

.cls-110 {
  fill: #517d54;
}

.cls-111 {
  opacity: 0.4;
}

.cls-112 {
  fill: #96c7be;
}

.cls-113 {
  fill: #95b6df;
}

.cls-115 {
  fill: #d4effc;
}

.cls-445 {
  stroke: #ffdf67;
  stroke-width: 0.2px;
}

.cls-487 {
  stroke-width: 0;
}

.cls-336 {
  opacity: 0.9;
}

.cls-116,
.cls-354 {
  fill: #fdda24;
}

.cls-448 {
  stroke-width: 0.1px;
}

.cls-117 {
  opacity: 0.4;
}

.cls-120 {
  fill: #b6d8d6;
}

.cls-156 {
  opacity: 0.3;
}

.cls-159 {
  fill: #253b26;
}

.cls-450 {
  stroke-width: 0.3px;
}

.cls-451 {
  stroke: #ffe274;
  stroke-width: 0.2px;
}

.cls-160 {
  fill: #ae8444;
}

.cls-160,
.cls-180,
.cls-238 {
  opacity: 0.6;
}

.cls-161 {
  fill: #d7b257;
}

.cls-161,
.cls-183,
.cls-218 {
  opacity: 0.3;
}

.cls-163 {
  fill: #78af8e;
}

.cls-164 {
  fill: #619d69;
}

.cls-452,
.cls-453 {
  stroke-width: 0.3px;
}

.cls-453 {
  stroke: #fad24a;
}

.cls-168 {
  fill: #82b79e;
}

.cls-170 {
  fill: #865631;
}

.cls-170,
.cls-350,
.cls-371 {
  opacity: 0.9;
}

.cls-455 {
  stroke: #f8d043;
}

.cls-455,
.cls-476 {
  stroke-width: 0.4px;
}

.cls-456 {
  stroke: #ffd95a;
}

.cls-457 {
  stroke: #d49633;
  stroke-width: 0.7px;
}

.cls-458 {
  stroke: #ffe06e;
  stroke-width: 0.2px;
}

.cls-173 {
  opacity: 0.3;
}

.cls-174 {
  opacity: 0.5;
}

.cls-175 {
  fill: #ae7237;
}

.cls-176 {
  fill: #c3dfdd;
}

.cls-177 {
  fill: #b3d7d4;
}

.cls-178 {
  fill: #48694a;
}

.cls-180 {
  fill: #935c31;
}

.cls-459 {
  stroke: #e7ac33;
  stroke-width: 0.6px;
}

.cls-181 {
  opacity: 0.7;
}

.cls-330 {
  fill: #976032;
}

.cls-183 {
  fill: #a56b35;
}

.cls-460 {
  stroke: #b77939;
  stroke-width: 0.8px;
}

.cls-185 {
  opacity: 0;
}

.cls-186 {
  fill: #426144;
}

.cls-187 {
  fill: #29402a;
}

.cls-190 {
  fill: #283a6b;
}

.cls-192 {
  fill: #4f7552;
}

.cls-461 {
  stroke-width: 0.1px;
}

.cls-197 {
  fill: #a4793f;
}

.cls-198 {
  fill: #b27538;
}

.cls-198,
.cls-335,
.cls-342 {
  opacity: 0;
}

.cls-199 {
  opacity: 0.2;
}

.cls-200 {
  fill: #c6e0de;
}

.cls-462 {
  stroke-width: 0.3px;
}

.cls-201 {
  opacity: 0;
}

.cls-204 {
  opacity: 0.2;
}

.cls-463 {
  stroke: #ffdb58;
}

.cls-205 {
  opacity: 0.5;
}

.cls-207 {
  opacity: 0.1;
}

.cls-464 {
  stroke: #ffd85b;
}

.cls-208 {
  fill: #233824;
}

.cls-209 {
  fill: #add4d1;
}

.cls-210 {
  fill: #334e35;
}

.cls-211 {
  fill: #ba2029;
}

.cls-213 {
  fill: #a06734;
}

.cls-214 {
  fill: #446446;
}

.cls-216 {
  opacity: 0.6;
}

.cls-217 {
  opacity: 0.3;
}

.cls-220 {
  fill: #a3cfcc;
}

.cls-221 {
  fill: #4f7351;
}

.cls-224 {
  fill: #cde3e2;
}

.cls-225 {
  fill: #d52e2d;
}

.cls-228,
.cls-269 {
  fill: #ffe06a;
}

.cls-232 {
  opacity: 0.3;
}

.cls-233 {
  fill: #cae2e0;
}

.cls-235 {
  fill: #75ad89;
}

.cls-466 {
  stroke: #ffdd5e;
  stroke-width: 0.2px;
}

.cls-236 {
  fill: #9cccc9;
}

.cls-237 {
  fill: #559058;
}

.cls-239 {
  opacity: 0.6;
}

.cls-240 {
  fill: #a6d1ce;
}

.cls-241 {
  fill: #a0cdcb;
}

.cls-242 {
  fill: #538856;
}

.cls-243 {
  opacity: 0;
}

.cls-244 {
  fill: #569459;
}

.cls-467,
.cls-468 {
  stroke-width: 0.2px;
}

.cls-468 {
  stroke: #ffde64;
}

.cls-469 {
  stroke: #f3c63e;
  stroke-width: 0.4px;
}

.cls-255 {
  opacity: 0.3;
}

.cls-258 {
  fill: #e1bd5c;
}

.cls-470 {
  stroke: #ffd75c;
}

.cls-259 {
  fill: #314b33;
}

.cls-260 {
  opacity: 0.1;
}

.cls-262 {
  opacity: 0.3;
}

.cls-263 {
  opacity: 0.2;
}

.cls-471 {
  stroke: #ecb737;
  stroke-width: 0.6px;
}

.cls-472 {
  stroke: #ffe580;
  stroke-width: 0.1px;
}

.cls-474 {
  stroke: #e5a730;
  stroke-width: 0.7px;
}

.cls-266,
.cls-282,
.cls-330 {
  opacity: 0.5;
}

.cls-475 {
  stroke-width: 0.4px;
}

.cls-270 {
  opacity: 0.1;
}

.cls-272 {
  fill: #517f54;
}

.cls-274 {
  opacity: 0.3;
}

.cls-275 {
  fill: #2b432c;
}

.cls-280 {
  fill: #7b8791;
}

.cls-281 {
  fill: #85baa4;
}

.cls-282 {
  fill: #b89049;
}

.cls-284,
.cls-285 {
  opacity: 0.6;
}

.cls-477 {
  stroke: #ce9034;
  stroke-width: 0.7px;
}

.cls-288 {
  fill: #39563b;
}

.cls-526 {
  mix-blend-mode: soft-light;
}

.cls-289 {
  opacity: 0.5;
}

.cls-480 {
  stroke: #f6cb40;
  stroke-width: 0.4px;
}

.cls-481 {
  stroke-width: 0.3px;
}

.cls-291 {
  fill: #507852;
}

.cls-292 {
  fill: #558d57;
}

.cls-483 {
  stroke-width: 0.2px;
}

.cls-293 {
  opacity: 0.1;
}

.cls-294 {
  fill: #71aa84;
}

.cls-295 {
  opacity: 0.3;
}

.cls-527 {
  opacity: 0.1;
}

.cls-297,
.cls-528 {
  opacity: 0.2;
}

.cls-298 {
  opacity: 0;
}

.cls-299,
.cls-529 {
  opacity: 0.2;
}

.cls-484 {
  stroke-width: 0.1px;
}

.cls-530 {
  opacity: 0.2;
}

.cls-300 {
  fill: #7fb599;
}

.cls-531,
.cls-532,
.cls-533 {
  opacity: 0.3;
}

.cls-485 {
  stroke: #eab235;
  stroke-width: 0.6px;
}

.cls-301 {
  fill: #528154;
}

.cls-302,
.cls-534 {
  opacity: 0.2;
}

.cls-303 {
  fill: #a9d2cf;
}

.cls-535,
.cls-536,
.cls-537 {
  opacity: 0.4;
}

.cls-486 {
  stroke-width: 0.2px;
}

.cls-538 {
  opacity: 0.7;
}

.cls-539 {
  opacity: 0.6;
}

.cls-307 {
  opacity: 0.3;
}

.cls-540,
.cls-541 {
  opacity: 0.6;
}

.cls-542,
.cls-543,
.cls-544,
.cls-545 {
  opacity: 0.5;
}

.cls-487 {
  stroke: #7c4b2c;
}

.cls-309 {
  opacity: 0.2;
}

.cls-546,
.cls-547 {
  opacity: 0.9;
}

.cls-548 {
  opacity: 0.8;
}

.cls-549 {
  opacity: 0.9;
}

.cls-550,
.cls-551,
.cls-552 {
  opacity: 0.8;
}

.cls-488 {
  stroke: #f1c13c;
  stroke-width: 0.5px;
}

.cls-553,
.cls-554 {
  opacity: 0.7;
}

.cls-311 {
  fill: #355137;
}

.cls-312 {
  fill: #4e7151;
}

.cls-313 {
  fill: #5a985f;
}

.cls-555 {
  opacity: 1;
}

.cls-314 {
  opacity: 0.5;
}

.cls-316 {
  fill: #c29b4d;
}

.cls-371 {
  fill: #804e2d;
}

.cls-319 {
  opacity: 0.2;
}

.cls-322 {
  fill: #517c53;
}

.cls-324 {
  fill: #548956;
}

.cls-325 {
  opacity: 0.4;
}

.cls-327 {
  fill: #7bb294;
}

.cls-328 {
  fill: #8cbfae;
}

.cls-329 {
  fill: #9a6d3a;
}

.cls-489 {
  stroke: #f9d146;
  stroke-width: 0.4px;
}

.cls-334 {
  opacity: 0.2;
}

.cls-337 {
  fill: #548b57;
}

.cls-340 {
  opacity: 0.3;
}

.cls-490 {
  stroke: #ffe06a;
  stroke-width: 0.2px;
}

.cls-342 {
  fill: #f5d465;
}

.cls-344 {
  fill: #3c593d;
}

.cls-491 {
  stroke-width: 0.2px;
}

.cls-346 {
  fill: #906236;
}

.cls-349 {
  fill: #569259;
}

.cls-492 {
  stroke: #ffd95b;
}

.cls-351 {
  opacity: 0.4;
}

.cls-353 {
  opacity: 0.3;
}

.cls-354 {
  fill-rule: evenodd;
}

.cls-355 {
  opacity: 0;
}

.cls-493 {
  stroke: #c88a35;
  stroke-width: 0.7px;
}

.cls-494 {
  stroke: #ffdc5b;
  stroke-width: 0.2px;
}

.cls-357 {
  fill: #5d9b64;
}

.cls-358 {
  fill: #507a53;
}

.cls-362 {
  fill: #d0e5e3;
}

.cls-495 {
  stroke: #ffd65d;
}

.cls-364 {
  fill: #4c6f4f;
}

.cls-367 {
  opacity: 0.2;
}

.cls-370 {
  opacity: 0;
}

.cls-496 {
  stroke: #fcd454;
  stroke-width: 0.3px;
}

.cls-372 {
  opacity: 0.7;
}

.cls-497 {
  stroke: #ffe47d;
  stroke-width: 0.1px;
}

.cls-374 {
  fill: #538656;
}

.cls-498 {
  stroke: #fcd350;
  stroke-width: 0.3px;
}

.cls-377 {
  fill: #ebc960;
}

.cls-378 {
  fill: #d3e7e5;
}

.cls-382 {
  fill: #cda652;
}

.cls-384 {
  fill: #99c9c4;
}

.cls-386 {
  opacity: 0.2;
}

.cls-388 {
  fill: #2d462e;
}

.cls-501 {
  stroke-width: 0.1px;
}

.cls-391 {
  opacity: 0.4;
}

.cls-393 {
  fill: #67a274;
}

.cls-502 {
  stroke: #efbc3a;
  stroke-width: 0.5px;
}

.cls-503 {
  stroke-width: 0.2px;
}

.cls-398 {
  opacity: 0.1;
}

.cls-505 {
  stroke: #fed55a;
  stroke-width: 0.3px;
}

.cls-401 {
  opacity: 0.1;
}

.cls-506 {
  stroke: #ffe37a;
  stroke-width: 0.1px;
}

.cls-402 {
  opacity: 0.8;
}

.cls-404 {
  fill: #2f4831;
}

.cls-508 {
  stroke: #ffd65e;
}

.cls-407 {
  fill: #6ea87f;
}

.cls-409 {
  fill: #6ba579;
}

.cls-509 {
  stroke-width: 0.3px;
}

.cls-510 {
  stroke: #ffdd61;
  stroke-width: 0.2px;
}

.cls-413 {
  fill: #92c4b9;
}

.cls-415 {
  opacity: 0.8;
}

.cls-511 {
  stroke-width: 0;
}

.cls-419 {
  opacity: 0.3;
}
</style>
